/**
* @description: vod在线配置
* @author: hwx
* @update: lyr
* @update: wgt
* @update: chy
*/
<template>
    <div class="vod-manage">
        <ul class="row list-tit" v-show="titShow">
            <li class="col-md-3"><span class="col-md-10" @click="titClk('1')">大厅公视配置</span></li>
            <li class="col-md-3"><span class="col-md-10" @click="titClk('2')">效果器配置</span></li>
            <li class="col-md-3"><span class="col-md-10" @click="titClk('3')">智能灯光设置</span></li>
            <li class="col-md-3"><span class="col-md-10" @click="titClk('4')">开房播放设置</span></li>
            <li class="col-md-3"><span class="col-md-10" @click="titClk('5')">开机播放设置</span></li>
            <li class="col-md-3"><span class="col-md-10" @click="titClk('6')">包厢配置</span></li>
            <li class="col-md-3"><span class="col-md-10" @click="titClk('7')">息屏背景自定义设置</span></li>
            <li class="col-md-3"><span class="col-md-10" @click="titClk('8')">包厢火警通知图配置</span></li>
            <li class="col-md-3"><span class="col-md-10" @click="titClk('9')">关房播放设置</span></li>
            <li class="col-md-3"><span class="col-md-10" @click="titClk('10')">灯光面板点播设置</span></li>
            <li class="col-md-3" v-if="business_model == 2"><span class="col-md-10" @click="titClk('11')">购买单曲设置</span>
            </li>
            <li class="col-md-3"><span class="col-md-10" @click="titClk('12')">V1.0三合一效果文件管理</span></li>
            <li class="col-md-3" v-if="business_model == 2"><span class="col-md-10"
                    @click="titClk('13')">智慧交换机设置(旧版弃用)</span></li>
            <li class="col-md-3" v-if="intelligent_controller_status == 1"><span class="col-md-10"
                    @click="titClk('14')">智能控制器配置(旧版弃用)</span></li>
            <li class="col-md-3"><span class="col-md-10" @click="titClk('15')">工作歌单</span></li>
            <li class="col-md-3" v-if="youtube_status == 1"><span class="col-md-10"
                    @click="titClk('16')">Youtube设置</span>
            </li>
            <li class="col-md-3"><span class="col-md-10" @click="titClk('17')">包厢麦克风低电量通知图配置</span></li>
            <li class="col-md-3"><span class="col-md-10" @click="titClk('18')">场景灯光配置</span></li>
            <li class="col-md-3"><span class="col-md-10" @click="titClk('19')">广告机设置</span></li>
            <li class="col-md-3"><span class="col-md-10" @click="titClk('20')">智能控制器配置</span></li>
            <li class="col-md-3"><span class="col-md-10" @click="titClk('21')">V2.0三合一调音库效果管理</span></li>
        </ul>
        <div class="list-con vod-wrap">
            <div class="vod-online-set" v-show="listShow1">
                <div class="vod-list" v-show="!showSet">
                    <div class="row row-magin-bottom">
                        <button type="button" class="btn bg-orange btn-flat bigbtn" @click="add_vod()">新增大厅公视配置</button>
                    </div>
                    <div class="table-responsive">
                        <table id="vodList" class="table table-bordered table-hover" data-pagination="true"
                            ref="vodList" style="margin-top:10px"></table>
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="backFun">返回</button>
                    </div>
                </div>
                <!-- 新增/修改 -->
                <div class="vod-set" v-show="showSet">
                    <div class="page-tit">{{ add_header }}</div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">门店：</label>
                        <div class="col-md-4" v-show="visible">
                            <select class="form-control select2" id="shopId" ref="shop"></select>
                        </div>
                        <div class="col-md-4" v-show="!visible">
                            <span class="col-md-12 shop-cg" ref="shopCg"></span>
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">channel1：</label>
                        <div class="col-md-4">
                            <input class="form-control" placeholder="请输入大厅转播服务器的转播地址，如196.168.3.11"
                                v-model="vod_set_cnfrt">
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">channel2：</label>
                        <div class="col-md-4">
                            <input class="form-control" placeholder="请输入大厅转播服务器的转播地址，如196.168.3.11"
                                v-model="vod_set_cnsnd">
                        </div>
                    </div>
                    <div class="row" style="padding-top: 30px;">
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="rtnFun('0')">返回</button>
                        <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;"
                            @click="save(addModify)">保存</button>
                    </div>
                </div>
            </div>



            <!-- 效果器配置 -->
            <div class="vod-xgq-set" v-show="listShow2">
                <div class="xgq-list" v-show="showXgq">
                    <div class="row row-magin-bottom">
                        <button type="button" class="btn bg-orange btn-flat bigbtn" @click="add_xgq()">新增效果器配置</button>
                    </div>
                    <div class="table-responsive">
                        <table id="xgqList" class="table table-bordered table-hover xqg-list" data-pagination="true"
                            ref="xgqList" style="margin-top:10px"></table>
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="backFun">返回</button>
                    </div>
                </div>
                <!-- 新增/修改 -->
                <div class="xgq-set" v-show="showXgqSet">
                    <div class="page-tit">{{ add_xgq_header }}</div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">门店：</label>
                        <div class="col-md-4" v-show="xgqVisible">
                            <select class="form-control select2" id="xgqShop" ref="xgqShop"></select>
                        </div>
                        <div class="col-md-4" v-show="!xgqVisible">
                            <span class="col-md-12 shop-cg" ref="xgqShopCg"></span>
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">包厢号：</label>
                        <div class="col-md-4">
                            <input class="form-control input-readonly" placeholder="请选择包厢号" v-model="xgq_room_num"
                                ref="xgq_room_num" readonly="readonly" @click="xgq_room_fun($event)">
                            <span :class="objClass" @click="clear_input()">×</span>
                            <span class="printer_arrow" role="presentation"><b role="presentation"></b></span>
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">麦克风音量加：</label>
                        <div class="col-md-4">
                            <input class="form-control" placeholder="请输入麦克风音量加参数" v-model="xgq_volup">
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">麦克风音量减：</label>
                        <div class="col-md-4">
                            <input class="form-control" placeholder="请输入麦克风音量减参数" v-model="xgq_voldown">
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">麦克风专业音效：</label>
                        <div class="col-md-4">
                            <textarea class="form-control xgq-mp" v-model="xgq_mp_zy"
                                placeholder="请配置专业音效果的参数"></textarea>
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">麦克风标准音效：</label>
                        <div class="col-md-4">
                            <textarea class="form-control xgq-mp" v-model="xgq_mp_bz"
                                placeholder="请配置标准音效果的参数"></textarea>
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">麦克风K歌音效：</label>
                        <div class="col-md-4">
                            <textarea class="form-control xgq-mp" v-model="xgq_mp_kg"
                                placeholder="请配置K歌音效果的参数"></textarea>
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">麦克风剧院音效：</label>
                        <div class="col-md-4">
                            <textarea class="form-control xgq-mp" v-model="xgq_mp_jy"
                                placeholder="请配置剧院音效果的参数"></textarea>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 30px;">
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="rtnFun('1')">返回</button>
                        <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;"
                            @click="xgqSave(addXgqModify)">保存</button>
                    </div>
                </div>
                <!-- 包厢号 -->
                <div class="details_content" ref="box_area" v-show="showbox">
                    <div class="page_header">选择包厢</div>
                    <p>请选择包厢范围</p>
                    <div class="box_area_main">
                        <div class="goods_checkboxdiv box_area">
                            <div class="first">
                                <input type="radio" name="roomNum" v-model='room_checkboxModel' :value="0">
                                <span>全部包厢</span>
                            </div>
                            <ul></ul>
                        </div>
                        <div class="goods_checkboxdiv box_area" v-for="items in room_checkboxdata"
                            :key="items.room_area">
                            <div class="first">
                                <span>{{ items.room_area_name }}</span>
                            </div>
                            <ul>
                                <li v-for="item in items.room" :key="item.id">
                                    <input type="radio" name="roomNum" v-model='room_checkboxModel' :value="item.id">
                                    <span>{{ item.name }}</span>
                                </li>
                                <div style="clear:both;"></div>
                            </ul>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 30px;">
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="roomboxbackFun()">返回</button>
                        <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;"
                            @click="roomboxokFun()">确定</button>
                    </div>
                </div>
            </div>



            <!-- 智能灯光配置 -->
            <div class="vod-lamp-set" v-show="listShow3">
                <div class="lamp-list" v-show="showLamp">
                    <!-- <div class="row row-magin-bottom">
                        <button type="button" class="btn bg-orange btn-flat bigbtn" @click="add_lamp()">智能灯光配置</button>
                    </div> -->
                    <el-form :inline="true">
                        <el-form-item label="门店名称">
                            <el-select v-model="lamp_shop_id" placeholder="请选择门店">
                                <el-option v-for="item in lampShop" :key="item.id" :label="item.text"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-button type="primary" @click="innitLampTable">查询</el-button>
                        <el-button type="primary" @click="add_lamp">智能灯光配置</el-button>
                    </el-form>
                    <div class="table-responsive">
                        <table id="lampList" class="table table-bordered table-hover xqg-list" data-pagination="true"
                            ref="lampList" style="margin-top:10px"></table>
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="backFun">返回</button>
                    </div>
                </div>
                <!-- 新增/修改 -->
                <div class="lamp-set" v-show="showLampSet">
                    <div class="page-tit">{{ add_lamp_header }}</div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">门店：</label>
                        <div class="col-md-4" v-show="lampVisible">
                            <select class="form-control select2" id="lampShop" ref="lampShop"></select>
                        </div>
                        <div class="col-md-4" v-show="!lampVisible">
                            <span class="col-md-12 shop-cg" ref="lampShopCg"></span>
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">状态：</label>
                        <div class="col-md-4">
                            <select class="form-control select2" ref="lampStatus">
                                <option value="1">开启</option>
                                <option value="-1">关闭</option>
                            </select>
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">包厢号：</label>
                        <div class="col-md-4">
                            <input class="form-control input-readonly" placeholder="请选择包厢号" v-model="lamp_room_num"
                                ref="lamp_room_num" readonly="readonly" @click="lamp_room_fun($event)">
                            <span :class="l_objClass" @click="l_clear_input()">×</span>
                            <span class="printer_arrow" role="presentation"><b role="presentation"></b></span>
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">配置参数：</label>
                        <div class="col-md-4">
                            <textarea class="form-control xgq-mp" v-model="lamp_mp_cs"
                                placeholder="请输入智能灯光配置参数，例如：paclista=48;49;paclistb=49;paclistc=48;49;paclistd=48;49;pacliste=48;49;paclistn=49;49;49;49;49;"></textarea>
                        </div>
                        <span class="rmarkspan"
                            titles="配置说明：<br>解析：1）paclista是指a类歌曲；paclistb是指b类歌曲，以此类推···<br>2）49数值是通过 先歌协议/灯光1/开/31H 的十六进制转换成十进制得来。<br>3）48数值是通过 先歌协议/灯光1/关/30H 的十六进制转换成十进制得来。<br>4）paclista=49;49;49;49;49; 意思是a类歌曲灯光全开<br>5）paclistb=48;48;48;48;48; 意思是b类歌曲灯光全关<br>6）paclistc=49;48;48;48;48; 意思是c类歌曲灯光1路开，其他4路都关。<br>7）灯光分类标准：<br>A 空白&nbsp; B 迪斯科&nbsp; C 打碟&nbsp; D 华尔兹&nbsp; E 四拍舞曲&nbsp; F 探戈&nbsp; G 恰恰、伦巴、慢摇&nbsp; H 心痛&nbsp; I 伤感&nbsp; J 舒服&nbsp; K 欢快&nbsp; L 激情&nbsp; M 励志&nbsp; N 怀旧&nbsp; O 摇滚&nbsp; P R&B&nbsp; Q Hip-Pop&nbsp; R 电子&nbsp; S 爵士&nbsp; T 蓝调、美声&nbsp; U 乡村、民谣&nbsp; V 生日&nbsp; W 民歌、民族&nbsp; X 戏曲&nbsp; Y 儿歌&nbsp; Z 喜庆&nbsp;"
                            @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
                    </div>
                    <div class="el-row">
                        <label class="col-md-1 ctr-label-left">手动灯光1</label>
                        <el-radio v-model="paclist1.status" label="1">开启</el-radio>
                        <el-radio v-model="paclist1.status" label="-1">关闭<span
                                class="red-tip">（关闭后，则该灯光按键不在点歌页面显示）</span></el-radio>
                    </div>
                    <div class="gray-block" v-if="paclist1.status == '1'">
                        <div class="label">灯光</div>
                        <el-input class="small" type="text" placeholder="灯光名称" v-model="paclist1.name" maxlength="3"
                            show-word-limit></el-input>
                        <div class="label">配置参数</div>
                        <el-input type="text" placeholder="请输入手动灯光配置参数，例如：paclist1=48;49;48;48;48;48"
                            v-model="paclist1.value"></el-input>
                    </div>
                    <div class="el-row">
                        <label class="col-md-1 ctr-label-left">手动灯光2</label>
                        <el-radio v-model="paclist2.status" label="1">开启</el-radio>
                        <el-radio v-model="paclist2.status" label="-1">关闭<span
                                class="red-tip">（关闭后，则该灯光按键不在点歌页面显示）</span></el-radio>
                    </div>
                    <div class="gray-block" v-if="paclist2.status == '1'">
                        <div class="label">灯光</div>
                        <el-input class="small" type="text" placeholder="灯光名称" v-model="paclist2.name" maxlength="3"
                            show-word-limit></el-input>
                        <div class="label">配置参数</div>
                        <el-input type="text" placeholder="请输入手动灯光配置参数，例如：paclist2=48;48;49;48;48;48"
                            v-model="paclist2.value"></el-input>
                    </div>
                    <div class="el-row">
                        <label class="col-md-1 ctr-label-left">手动灯光3</label>
                        <el-radio v-model="paclist3.status" label="1">开启</el-radio>
                        <el-radio v-model="paclist3.status" label="-1">关闭<span
                                class="red-tip">（关闭后，则该灯光按键不在点歌页面显示）</span></el-radio>
                    </div>
                    <div class="gray-block" v-if="paclist3.status == '1'">
                        <div class="label">灯光</div>
                        <el-input class="small" type="text" placeholder="灯光名称" v-model="paclist3.name" maxlength="3"
                            show-word-limit></el-input>
                        <div class="label">配置参数</div>
                        <el-input type="text" placeholder="请输入手动灯光配置参数，例如：paclist3=49;48;48;48;48;48"
                            v-model="paclist3.value"></el-input>
                    </div>
                    <div class="el-row">
                        <label class="col-md-1 ctr-label-left">手动灯光4</label>
                        <el-radio v-model="paclist4.status" label="1">开启</el-radio>
                        <el-radio v-model="paclist4.status" label="-1">关闭<span
                                class="red-tip">（关闭后，则该灯光按键不在点歌页面显示）</span></el-radio>
                    </div>
                    <div class="gray-block" v-if="paclist4.status == '1'">
                        <div class="label">灯光</div>
                        <el-input class="small" type="text" placeholder="灯光名称" v-model="paclist4.name" maxlength="3"
                            show-word-limit></el-input>
                        <div class="label">配置参数</div>
                        <el-input type="text" placeholder="请输入手动灯光配置参数，例如：paclist4=48;48;48;49;48;48"
                            v-model="paclist4.value"></el-input>
                    </div>
                    <div class="el-row">
                        <label class="col-md-1 ctr-label-left">手动灯光5</label>
                        <el-radio v-model="paclist5.status" label="1">开启</el-radio>
                        <el-radio v-model="paclist5.status" label="-1">关闭<span
                                class="red-tip">（关闭后，则该灯光按键不在点歌页面显示）</span></el-radio>
                    </div>
                    <div class="gray-block" v-if="paclist5.status == '1'">
                        <div class="label">灯光</div>
                        <el-input class="small" type="text" placeholder="灯光名称" v-model="paclist5.name" maxlength="3"
                            show-word-limit></el-input>
                        <div class="label">配置参数</div>
                        <el-input type="text" placeholder="请输入手动灯光配置参数，例如：paclist4=48;48;48;49;48;48"
                            v-model="paclist5.value"></el-input>
                    </div>
                    <div class="el-row">
                        <label class="col-md-1 ctr-label-left">手动灯光6</label>
                        <el-radio v-model="paclist6.status" label="1">开启</el-radio>
                        <el-radio v-model="paclist6.status" label="-1">关闭<span
                                class="red-tip">（关闭后，则该灯光按键不在点歌页面显示）</span></el-radio>
                    </div>
                    <div class="gray-block" v-if="paclist6.status == '1'">
                        <div class="label">灯光</div>
                        <el-input class="small" type="text" placeholder="灯光名称" v-model="paclist6.name" maxlength="3"
                            show-word-limit></el-input>
                        <div class="label">配置参数</div>
                        <el-input type="text" placeholder="请输入手动灯光配置参数，例如：paclist4=48;48;48;49;48;48"
                            v-model="paclist6.value"></el-input>
                    </div>
                    <div class="gray-block" v-show="other_lamp_room.length > 0">
                        <div class="block-title">
                            资料同步<span class="red-tip">（勾选同步的包厢后，对应的包厢也会同步修改）</span>
                            <div class="other-room-wrapper">
                                <el-checkbox v-model="lampSyncAllOtherRoom"
                                    @change="handleLampSyncAllOtherRoomChange">全选</el-checkbox>
                                <el-checkbox-group v-model="choosed_other_lamp_room"
                                    @change="handleLampSyncOtherRoomChange">
                                    <el-checkbox v-for="item in other_lamp_room" :key="item.id" :label="item.id">{{
                                        item.room_name }}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 30px;">
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="rtnFun('2')">返回</button>
                        <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;"
                            @click="lampSave(addLampModify)">保存</button>
                    </div>
                </div>
                <!-- 包厢号 -->
                <!-- <div class="details_content" ref="lamp_box_area" v-show="l_showbox">
                    <div class="page_header">选择包厢</div>
                    <p>请选择包厢范围</p>
                    <div class="box_area_main">
                        <div class="goods_checkboxdiv box_area">
                            <div class="first">
                                <input type="radio" name="roomNum" v-model='l_room_checkboxModel' :value="0">
                                <span>全部包厢</span>
                            </div>
                            <ul></ul>
                        </div>
                        <div class="goods_checkboxdiv box_area" v-for="items in l_room_checkboxdata" :key="items.room_area">
                            <div class="first">
                                <span>{{items.room_area_name}}</span>
                            </div>
                            <ul>
                                <li v-for="item in items.room" :key="item.id">
                                    <input type="radio" name="roomNum" v-model='l_room_checkboxModel' :value="item.id">
                                    <span>{{item.name}}</span>
                                </li>
                                <div style="clear:both;"></div>
                            </ul>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 30px;">
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="l_roomboxbackFun()">返回</button>
                        <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;" @click="l_roomboxokFun()">确定</button>
                    </div>
                </div> -->
                <!-- 适用包厢面板 -->
                <div class="rooms-panel" v-show="l_showbox">
                    <h3>选择适用包厢</h3>
                    <div class="room-wrapper">
                        <div class="block-title">
                            <el-checkbox v-model="lampCheckAllRoom"
                                @change="handleLampCheckAllRoomChange">全选</el-checkbox>
                        </div>
                        <div class="block" v-for="(item, pindex) in l_room_checkboxdata">
                            <div class="block-title">
                                <el-checkbox @change="checked => handleLampCheckArea(checked, pindex)"
                                    v-model="item.checked">{{ item.room_area_name }}</el-checkbox>
                            </div>
                            <el-checkbox-group class="rooms" v-model="choosedLampRoom">
                                <el-checkbox class="room" v-for="(room, cindex) in item.room" :label="room.id"
                                    :key="room.id" @change="checked => handleLampCheckRoom(checked, pindex, cindex)">{{
                                        room.name }}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                    <el-button @click="l_roomboxbackFun">返回</el-button>
                    <el-button type="primary" @click="commitLampRoomChoose">确认</el-button>
                </div>
            </div>



            <!-- 开房播放设置 -->
            <div class="vod-room-set" v-show="listShow4">
                <div class="room-list" v-show="showRoom">
                    <div class="row row-magin-bottom">
                        <button type="button" class="btn bg-orange btn-flat bigbtn" @click="add_room()">开房播放设置</button>
                    </div>
                    <div class="table-responsive">
                        <table id="roomList" class="table table-bordered table-hover" data-pagination="true"
                            ref="roomList" style="margin-top:10px"></table>
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="backFun">返回</button>
                    </div>
                </div>
                <!-- 新增/修改 -->
                <div class="room-set" v-show="showRoomSet">
                    <div class="page-tit">{{ add_room_header }}</div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">门店：</label>
                        <div class="col-md-4" v-show="roomVisible">
                            <select class="form-control select2" id="roomShop" ref="roomShop"></select>
                        </div>
                        <div class="col-md-4" v-show="!roomVisible">
                            <span class="col-md-12 shop-cg" ref="roomShopCg"></span>
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">包厢号：</label>
                        <div class="col-md-4">
                            <input class="form-control input-readonly" placeholder="请选择包厢号" v-model="room_box_num"
                                ref="room_box_num" readonly="readonly" @click="room_box_fun($event)">
                            <span :class="r_objClass" @click="r_clear_input()">×</span>
                            <span class="printer_arrow" role="presentation"><b role="presentation"></b></span>
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">开房播放歌曲：</label>
                        <div class="col-md-4">
                            <!-- <select class="form-control select2" ref="roomSong" placeholder="开房播放歌曲"></select> -->
                            <input class="form-control input-readonly" placeholder="请选择开房播放歌曲" v-model="room_song_name"
                                ref="room_song_name" readonly="readonly" @click="room_song_fun($event)" />
                            <span class="selection_clear" @click="clear_input('room_song_fun')">×</span>
                            <span class="printer_arrow" role="presentation">
                                <b role="presentation"></b></span>
                        </div>
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="openUpdsongs($event)">上传歌曲</button>
                    </div>
                    <div class="row" style="padding-top: 30px;">
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="rtnFun('3')">返回</button>
                        <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;"
                            @click="roomSave(addRoomModify)">保存</button>
                    </div>
                </div>
                <!-- 包厢号 -->
                <div class="details_content" ref="room_box_area" v-show="r_showbox">
                    <div class="page_header">选择包厢</div>
                    <p>请选择包厢范围</p>
                    <div class="box_area_main">
                        <div class="goods_checkboxdiv box_area">
                            <div class="first">
                                <input type="checkbox" v-model='r_box_allcheck' @click='rBoxAllcheck'>
                                <span>全部包厢</span>
                            </div>
                            <ul></ul>
                        </div>
                        <div class="goods_checkboxdiv box_area" v-for="items in r_box_checkboxData"
                            :key="items.room_area">
                            <div class="first">
                                <span>{{ items.room_area_name }}</span>
                            </div>
                            <ul>
                                <li v-for="item in items.room" :key="item.id">
                                    <input type="checkbox" v-model='r_box_checkboxModel' :value="item.id">
                                    <span>{{ item.name }}</span>
                                </li>
                                <div style="clear:both;"></div>
                            </ul>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 30px;">
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="rBoxReturn()">返回</button>
                        <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;"
                            @click="rBoxSubmit()">确定</button>
                    </div>
                </div>
                <!-- 开房播放歌曲弹窗 -->
                <div class="room-song-alert" ref="roomSong_alert">
                    <div class="sel-seldiv">
                        <ul class="set-area">
                            <li v-for="item in songData" :key="item.id">
                                <input type="radio" v-model='r_song_checkModel' :value="item.id">
                                <label>{{ item.text }}</label>
                                <img src="../../assets/images/icon_del.png" @click="delSong(item.id)">
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 上传歌曲 -->
                <div class="ele-hide" ref="upload_songs">
                    <div class="upload-wrap" id="uploadWrap">
                        <span>选择并上传歌曲</span>
                        <div class="upload-file-info" id="ossfile">
                            你的浏览器不支持flash,Silverlight或者HTML5！
                        </div>
                        <input type="button" value="选择文件" id="roomSelFile">
                        <button id="roomSubFile">开始上传</button>
                        <p>上传歌曲格式需为：<em>mkv/mp4/avi</em>，仅支持H.264编码的文件</p>
                        <p>如上传格式不符合将无法正常播放</p>
                        <p>歌曲分辨率不能超过1080p，单个文件大小不能超过200m。</p>
                    </div>
                </div>
            </div>



            <!-- 开机播放设置 -->
            <div class="vod-wake-set" v-show="listShow5">
                <div class="wake-list" v-show="showWake">
                    <div class="row row-magin-bottom">
                        <button type="button" class="btn bg-orange btn-flat bigbtn" @click="add_wake()">开机播放设置</button>
                    </div>
                    <div class="table-responsive">
                        <table id="wakeList" class="table table-bordered table-hover" data-pagination="true"
                            ref="wakeList" style="margin-top:10px"></table>
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="backFun">返回</button>
                    </div>
                </div>
                <!-- 新增/修改 -->
                <div class="wake-set" v-show="showWakeSet">
                    <div class="page-tit">{{ add_wake_header }}</div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">门店：</label>
                        <div class="col-md-4" v-show="wakeVisible">
                            <select class="form-control select2" id="wakeShop" ref="wakeShop"></select>
                        </div>
                        <div class="col-md-4" v-show="!wakeVisible">
                            <span class="col-md-12 shop-cg" ref="wakeShopCg"></span>
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">包厢号：</label>
                        <div class="col-md-4">
                            <input class="form-control input-readonly" placeholder="请选择包厢号" v-model="wake_box_num"
                                ref="wake_box_num" readonly="readonly" @click="wake_box_fun($event)">
                            <span :class="w_objClass" @click="w_clear_input()">×</span>
                            <span class="printer_arrow" role="presentation"><b role="presentation"></b></span>
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">开机播放歌曲：</label>
                        <div class="col-md-4">
                            <input class="form-control input-readonly" placeholder="请选择开机播放歌曲" v-model="wake_song_name"
                                ref="wake_song_name" readonly="readonly" @click="wake_song_fun($event)" />
                            <span class="selection_clear" @click="clear_input('wake_song_fun')">×</span>
                            <span class="printer_arrow" role="presentation">
                                <b role="presentation"></b></span>
                        </div>
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="openWakeUpdsongs($event)">上传歌曲</button>
                    </div>
                    <div class="row" style="padding-top: 30px;">
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="rtnFun('4')">返回</button>
                        <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;"
                            @click="wakeSave(addWakeModify)">保存</button>
                    </div>
                </div>
                <!-- 包厢号 -->
                <div class="details_content" ref="wake_box_area" v-show="w_showbox">
                    <div class="page_header">选择包厢</div>
                    <p>请选择包厢范围</p>
                    <div class="box_area_main">
                        <div class="goods_checkboxdiv box_area">
                            <div class="first">
                                <input type="checkbox" v-model='w_box_allcheck' @click='wBoxAllcheck'>
                                <span>全部包厢</span>
                            </div>
                            <ul></ul>
                        </div>
                        <div class="goods_checkboxdiv box_area" v-for="items in w_box_checkboxData"
                            :key="items.room_area">
                            <div class="first">
                                <span>{{ items.room_area_name }}</span>
                            </div>
                            <ul>
                                <li v-for="item in items.room" :key="item.id">
                                    <input type="checkbox" v-model='w_box_checkboxModel' :value="item.id">
                                    <span>{{ item.name }}</span>
                                </li>
                                <div style="clear:both;"></div>
                            </ul>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 30px;">
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="wBoxReturn()">返回</button>
                        <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;"
                            @click="wBoxSubmit()">确定</button>
                    </div>
                </div>
                <!-- 开机播放歌曲弹窗 -->
                <div class="wake-song-alert" ref="wakeSong_alert">
                    <div class="sel-seldiv">
                        <ul class="set-area">
                            <li v-for="item in songData" :key="item.id">
                                <input type="radio" v-model='w_song_checkModel' :value="item.id">
                                <label>{{ item.text }}</label>
                                <img src="../../assets/images/icon_del.png" @click="delSong(item.id)">
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 上传歌曲 -->
                <div class="ele-hide" ref="wake_upload_songs">
                    <div class="upload-wrap" id="uploadWrap">
                        <span>选择并上传歌曲</span>
                        <div class="upload-file-info" id="ossfileWake">
                            你的浏览器不支持flash,Silverlight或者HTML5！
                        </div>
                        <input type="button" value="选择文件" id="wakeSelFile">
                        <button id="wakeSubFile">开始上传</button>
                        <p>上传歌曲格式需为：<em>mkv/mp4/avi</em>，仅支持H.264编码的文件</p>
                        <p>如上传格式不符合将无法正常播放</p>
                        <p>歌曲分辨率不能超过1080p，单个文件大小不能超过200m。</p>
                    </div>
                </div>
            </div>



            <!-- 包厢配置 -->
            <div class="vod-bx-set" v-show="listShow6">
                <div class="bx-list" v-show="showBx">
                    <div class="row row-magin-bottom">
                        <el-button type="primary" @click="add_bx()">新增包厢配置</el-button>
                        <p>注：设置成功后，包厢机设为空闲状态，重启机顶盒，看到2分钟后升级重启的提醒，手动或者自动重启机顶盒方可生效</p>
                    </div>
                    <el-form :inline="true">
                        <el-form-item label="门店">
                            <el-select v-model="bx_form.shop_id" filterable placeholder="请选择门店"
                                @change="onBxShopChange">
                                <el-option v-for="item in bx_shop_list" :key="item.id" :label="item.text"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="包厢区域">
                            <el-input placeholder="请选择包厢区域" v-model="room_area_str" readonly
                                @click.native="openRoomAreaPop"></el-input>
                        </el-form-item>
                        <el-form-item label="包厢类型">
                            <el-input placeholder="请选择包厢类型" v-model="room_type_str" readonly
                                @click.native="openBxRoomTypePop"></el-input>
                        </el-form-item>
                        <el-form-item label="包厢名称">
                            <el-input placeholder="请输入包厢名称" v-model="bx_form.room_name" clearable></el-input>
                        </el-form-item>
                        <el-button type="primary" @click="getBoxSetList(1)">查询</el-button>
                        <el-button type="primary" @click="onMultModifyBoxClick">批量修改</el-button>
                    </el-form>
                    <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)" :header-cell-style="{ 'text-align': 'center' }"
                        :cell-style="{ 'text-align': 'center' }" :max-height="500" ref="box_set_table"
                        :data="box_set_list" @selection-change="onBoxSetTableSelect">
                        <el-table-column type="selection"></el-table-column>
                        <el-table-column prop="shop_name" label="门店"></el-table-column>
                        <el-table-column prop="room_name" label="包厢"></el-table-column>
                        <el-table-column prop="room_area_name" label="区域"></el-table-column>
                        <el-table-column prop="room_type_name" label="类型"></el-table-column>
                        <el-table-column prop="setting_info" label="配置内容">
                            <template slot-scope="scope">
                                <span>{{ scope.row.setting_info.length > 30 ? scope.row.setting_info.substring(0, 30) +
                                    '...' : scope.row.setting_info }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" @click="onBoxSetTableModify(scope.row)">修改</el-button>
                                <el-button type="text" @click="onBoxSetTableDelete(scope.row)">删除</el-button>
                                <el-button type="text" @click="onBoxSetTableCopyAdd(scope.row)">复制新增</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="total, prev, pager, next, jumper" :page-size="box_set_page_size"
                        :current-page.sync="box_set_page" :total="box_set_total" @current-change="getBoxSetList">
                    </el-pagination>
                    <el-button @click="backFun">返回</el-button>
                    <!-- <div class="row row-magin-bottom">
                        <label class="ct-label">门店:</label>
                        <div class="col-md-2 ct-col">
                            <select class="form-control" ref="bx_shop" data-placeholder="请选择门店"></select>
                        </div>
                        <div class="pull-right">
                            <button type="button" class="btn btn-flat btn-small btn-orange" @click="clkBxQuery">查询</button>
                        </div>
                    </div> -->
                    <!-- <div class="table-responsive">
                        <table id="bxList" class="table table-bordered table-hover bx-list" data-pagination="true" ref="bxList"></table>
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backFun">返回</button>
                    </div> -->
                    <!-- 包厢区域选择 -->
                    <div class="room-area-pop ele-hide" ref="room_area_pop">
                        <div class="checkbox-wrapper">
                            <el-checkbox v-model="checkAllRoomArea"
                                @change="handleCheckAllRoomAreaChange">全选</el-checkbox>
                            <el-checkbox-group v-model="bx_form.room_area" @change="handleCheckRoomAreaChange">
                                <el-checkbox v-for="item in room_area_list" :label="item.id" :key="item.id">{{ item.name
                                    }}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                    <!-- 包厢类型选择 -->
                    <div class="room-type-pop ele-hide" ref="room_type_pop">
                        <div class="checkbox-wrapper">
                            <el-checkbox v-model="checkAllRoomType"
                                @change="handleCheckAllRoomTypeChange">全选</el-checkbox>
                            <el-checkbox-group v-model="bx_form.room_type" @change="handleCheckRoomTypeChange">
                                <el-checkbox v-for="item in room_type_list" :label="item.id" :key="item.id">{{ item.name
                                    }}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                    <!-- 批量修改弹窗 -->
                    <div class="mult-set-pop ele-hide" ref="mult_set_pop">
                        <div class="red-tip">注：请确保输入的参数值是正确的，否则不正确的参数不会添加/修改成功！</div>
                        <el-form label-width="120px">
                            <el-form-item label="pac配置">
                                <div class="el-row" v-for="(item, index) in mult_box_set_form.pac_setting" :key="index">
                                    <el-input :value="item" placeholder="请输入pac配置内容"
                                        @input="val => updateMultSet('pac_setting', index, val)">
                                    </el-input>
                                    <img src="../../assets/images/vod_add.png" alt="" class="add-btn"
                                        @click="addMultSet('pac_setting')" v-if="index == 0">
                                    <img src="../../assets/images/vod_del.png" alt="" class="del-btn"
                                        @click="delMultSet(index, 'pac_setting')" v-if="index > 0">
                                </div>
                            </el-form-item>
                            <el-form-item label="room配置">
                                <div class="el-row" v-for="(item, index) in mult_box_set_form.room_setting"
                                    :key="index">
                                    <el-input :value="item" placeholder="请输入room配置内容"
                                        @input="val => updateMultSet('room_setting', index, val)">
                                    </el-input>
                                    <img src="../../assets/images/vod_add.png" alt="" class="add-btn"
                                        @click="addMultSet('room_setting')" v-if="index == 0">
                                    <img src="../../assets/images/vod_del.png" alt="" class="del-btn"
                                        @click="delMultSet(index, 'room_setting')" v-if="index > 0">
                                </div>
                            </el-form-item>
                            <el-form-item label="dajianpan配置">
                                <div class="el-row" v-for="(item, index) in mult_box_set_form.dajianpan_setting"
                                    :key="index">
                                    <el-input :value="item" placeholder="请输入dajianpan配置内容"
                                        @input="val => updateMultSet('dajianpan_setting', index, val)">
                                    </el-input>
                                    <img src="../../assets/images/vod_add.png" alt="" class="add-btn"
                                        @click="addMultSet('dajianpan_setting')" v-if="index == 0">
                                    <img src="../../assets/images/vod_del.png" alt="" class="del-btn"
                                        @click="delMultSet(index, 'dajianpan_setting')" v-if="index > 0">
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <!-- 新增/修改 -->
                <div class="bx-set" v-show="showBxSet">
                    <div class="content">
                        <div class="left">
                            <div class="page-tit">{{ add_bx_header }}</div>
                            <div class="page-notice">
                                <p>注：</p>
                                <p>1、设置多条请点加号增加多条</p>
                                <p>2、删除配置无法起到还原默认配置的状态，必须重新设置初始参数</p>
                            </div>
                            <div class="row rowpadding">
                                <label class="col-md-1 ctr-label-left margin30">门店：</label>
                                <div class="col-md-4">
                                    <select class="form-control select2" ref="bxShop"></select>
                                </div>
                            </div>
                            <div class="row rowpadding">
                                <label class="ctr-label-left margin30">适用包厢：</label>
                                <div class="col-md-4">
                                    <input class="form-control input-readonly" placeholder="请选择包厢号" v-model="edit_box"
                                        ref="edit_box" readonly @click="editBoxFun">
                                    <span class="selection-clear" @click="clearInput('edit_box')">×</span>
                                    <span class="span-arrow"><b></b></span>
                                </div>
                            </div>
                            <div class="row rowpadding">
                                <label class="col-md-2 ctr-label-left margin30">pac配置：</label>
                                <div class="bx-txt-wrap" v-for="(item, index) in bx_pac_lists" :key="index">
                                    <div class="col-md-4">
                                        <input class="form-control input-readonly" placeholder="请输入pac配置内容"
                                            v-model.trim="item.pac_model">
                                    </div>
                                    <img src="../../assets/images/vod_del.png" @click="delBxPac(index)">
                                </div>
                                <div class="bx-txt-add">
                                    <div class="col-md-4">
                                        <input class="form-control input-readonly" placeholder="请输入pac配置内容"
                                            v-model.trim="bx_pac">
                                    </div>
                                    <img src="../../assets/images/vod_add.png" @click="addBxPac">
                                </div>
                            </div>
                            <div class="row rowpadding">
                                <label class="col-md-1 ctr-label-left margin30">room配置：</label>
                                <!-- <span class="rmarkspan" @click="openRmHint"></span> -->
                                <div class="bx-txt-wrap" v-for="(item, index) in bx_rm_lists" :key="index">
                                    <div class="col-md-4">
                                        <input class="form-control input-readonly" placeholder="请输入room配置内容"
                                            v-model.trim="item.rm_model" @inpput="changeRoomSetInput">
                                    </div>
                                    <img src="../../assets/images/vod_del.png" @click="delBxRm(index)">
                                </div>
                                <div class="bx-txt-add">
                                    <div class="col-md-4">
                                        <input class="form-control input-readonly" placeholder="请输入room配置内容"
                                            v-model.trim="bx_rm" @input="changeRoomSetInput">
                                    </div>
                                    <img src="../../assets/images/vod_add.png" @click="addBxRm">
                                </div>
                            </div>
                            <div class="row rowpadding">
                                <label class="col-md-1 ctr-label-left margin30">dajianpan配置：</label>
                                <div class="bx-txt-wrap" v-for="(item, index) in bx_djp_lists" :key="index">
                                    <div class="col-md-4">
                                        <input class="form-control input-readonly" placeholder="请输入dajianpan配置内容"
                                            v-model.trim="item.djp_model">
                                    </div>
                                    <img src="../../assets/images/vod_del.png" @click="delBxDjp(index)">
                                </div>
                                <div class="bx-txt-add">
                                    <div class="col-md-4">
                                        <input class="form-control input-readonly" placeholder="请输入dajianpan配置内容"
                                            v-model.trim="bx_djp">
                                    </div>
                                    <img src="../../assets/images/vod_add.png" @click="addBxDjp">
                                </div>
                            </div>
                        </div>
                        <!-- room说明 -->
                        <div class="init-params-explain">
                            <pre v-html="room_ini_params"></pre>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 30px;">
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="rtnFun('5')">返回</button>
                        <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;"
                            @click="bxSave(addBxModify)">保存</button>
                    </div>
                </div>
                <!-- 包厢号 -->
                <div class="multi-page" ref="box_area" v-show="showBox">
                    <div class="page-tit">选择包厢</div>
                    <p>请选择包厢范围</p>
                    <div class="multi-page-main">
                        <div class="multi-page-row">
                            <div>
                                <input type="checkbox" v-model='box_all' @click='boxAll'>
                                <span>全部包厢</span>
                            </div>
                            <ul></ul>
                        </div>
                        <div class="multi-page-row" v-for="(items, index) in box_arr" :key="items.room_area">
                            <div>
                                <input type="checkbox" v-model='box_floor' :value="items.room_area"
                                    @click="boxFloor(items.room_area, index)">
                                <span>{{ items.room_area_name }}</span>
                            </div>
                            <ul class="clearfix">
                                <li v-for="item in items.room" :key="item.id">
                                    <input type="checkbox" v-model='box_item' :value="item.id">
                                    <span>{{ item.name }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row">
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="boxBackEdit">返回</button>
                        <button type="button" class="btn btn-flat btn-middle btn-orange sub-margin"
                            @click="saveBox()">确定</button>
                    </div>
                </div>
            </div>
            <!-- room配置错误 -->
            <div class="bx-room-err ele-hide" ref="bxRoomErr">
                <p class="row-margin">room配置格式错误，请重新配置！（参数格式：XXXX=XXXX）</p>
                <img src="../../assets/images/room_set.png">
            </div>
            <!-- room说明 -->
            <!-- <div class="bx-rm-hint ele-hide" ref="bxRmHint">
                <pre v-html="room_ini_params"></pre>
            </div> -->



            <!-- 息屏背景自定义设置 -->
            <div class="vod-xbz-set" v-show="listShow7">
                <div class="xbz-list" v-show="showXbzList">
                    <el-button type="primary" @click="xbzAdd">自定义息屏背景设置</el-button>
                    <p class="p-hint">注：自定义息屏背景设置后，需重启机顶盒后生效</p>
                    <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)" :data="xbz_table">
                        <el-table-column prop="shop_name" label="门店"></el-table-column>
                        <el-table-column label="电视背景图">
                            <template slot-scope="scope">
                                <el-image :src="scope.row.img"></el-image>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="xbzModify(scope.row)">修改</span>
                                <span class="text-blue" @click="xbzDel(scope.row.id)">删除</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="total, prev, pager, next, jumper" :page-size="GLOBAL.PAGESIZE"
                        :current-page.sync="xbz_page" :total="xbz_total" @current-change="xbzTable">
                    </el-pagination>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backFun">返回</button>
                </div>
                <div class="xbz-edit" v-show="!showXbzList">
                    <div class="page-tit">{{ xbz_edit_tit }}</div>
                    <el-form label-width="120px">
                        <el-form-item label="门店" v-show="!xbz_edit_id">
                            <el-select v-model="xbz_edit_shop_id" filterable placeholder="请选择门店">
                                <el-option v-for="item in unset_shop_list" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="门店" v-show="xbz_edit_id">
                            {{ xbz_edit_shop_name }}
                        </el-form-item>
                        <el-form-item label="背景图">
                            <p class="p-hint">图片格式：1080P</p>
                            <img :src="xbz_edit_img" id="xbzEditImg" class="xbz-edit-img">
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="showXbzList = true">返回</el-button>
                            <el-button type="primary" @click="xbzEdit">确定</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>


            <!-- 包厢火警通知图配置 -->
            <div class="fire-alarm-set" v-show="listShow8">
                <div v-show="!showFireAddPanel">
                    <p class="p-hint">注：配置成功后，1 包厢触发火警通知时，TV及触摸屏页面显示对应配置图片；2 需重启机顶盒后生效；</p>
                    <el-form :inline="true">
                        <el-select v-model="fire_shop" placeholder="请选择门店" filterable @change="onShopChange">
                            <el-option v-for="item in fireShopList" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                        <div class="pull-right">
                            <el-button type="primary" @click="getFireAlarmList(1)">查询</el-button>
                            <el-button type="primary" @click="fireAdd">新增配置</el-button>
                            <el-button @click="backFun">返回</el-button>
                        </div>
                    </el-form>
                    <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)" :data="fire_table">
                        <el-table-column label="图片">
                            <template slot-scope="scope">
                                <img class="list-img" :src="scope.row.img_url">
                            </template>
                        </el-table-column>
                        <el-table-column prop="room_str" label="适用包厢"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="fireModify(scope.row)">修改</span>
                                <span class="text-blue" @click="fireDel(scope.row.id)">删除</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="total, prev, pager, next, jumper" :page-size="GLOBAL.PAGESIZE"
                        :current-page.sync="fire_page" :total="fire_total" @current-change="getFireAlarmList">
                    </el-pagination>
                </div>
                <div class="fire-add-panel" v-show="showFireAddPanel && !showFireBox">
                    <h1>{{ add_fire_form.id == '' ? '新增' : '修改' }}配置</h1>
                    <el-form label-width="80px">
                        <el-form-item label="门店">
                            <el-select v-model="add_fire_form.shop_id" placeholder="请选择门店" filterable disabled>
                                <el-option v-for="item in fireShopList" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="适用包厢">
                            <el-input v-model="add_fire_form.room_str" placeholder="请选择适用包厢" readonly
                                @click.native="openRoomPanel"></el-input>
                        </el-form-item>
                        <el-form-item label="图片">
                            <span class="red-tip">图片规范：尺寸1920*1080，格式png</span>
                            <div class="fire-img-wrapper" id="fire-img-wrapper">
                                <img :src="add_fire_form.img_url" alt="" class="fire-img"
                                    v-if="add_fire_form.img_url != ''">
                                <img src="../../assets/images/upload_btn.png" alt="" class="fire-img" v-else>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="showFireAddPanel = false">返回</el-button>
                            <el-button type="primary" @click="commitFireSet">确认</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 包厢号 -->
                <div class="multi-page" ref="box_area" v-show="showFireBox">
                    <div class="page-tit">选择包厢</div>
                    <p>请选择包厢范围</p>
                    <div class="multi-page-main">
                        <div class="multi-page-row">
                            <div>
                                <input type="checkbox" v-model='box_all' @click='boxAll'>
                                <span>全部包厢</span>
                            </div>
                            <ul></ul>
                        </div>
                        <div class="multi-page-row" v-for="(items, index) in box_arr" :key="items.room_area">
                            <div>
                                <input type="checkbox" v-model='box_floor' :value="items.room_area"
                                    @click="boxFloor(items.room_area, index)">
                                <span>{{ items.room_area_name }}</span>
                            </div>
                            <ul class="clearfix">
                                <li v-for="item in items.room" :key="item.id">
                                    <input type="checkbox" v-model='box_item' :value="item.id">
                                    <span>{{ item.name }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row">
                        <el-button @click="showFireBox = false">返回</el-button>
                        <el-button type="primary" @click="saveFireBox">确定</el-button>
                    </div>
                </div>
            </div>

            <!-- 关房播放设置 -->
            <div class="vod-room-set" v-show="listShow9">
                <div class="room-list" v-show="showRoom">
                    <div class="row row-magin-bottom">
                        <button type="button" class="btn bg-orange btn-flat bigbtn"
                            @click="add_close_room">关房播放设置</button>
                    </div>
                    <div class="table-responsive">
                        <table id="closeRoomList" class="table table-bordered table-hover" data-pagination="true"
                            ref="closeRoomList" style="margin-top:10px"></table>
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="backFun">返回</button>
                    </div>
                </div>
                <!-- 新增/修改 -->
                <div class="room-set" v-show="showRoomSet">
                    <div class="page-tit">{{ add_room_header }}</div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">门店：</label>
                        <div class="col-md-4" v-show="roomVisible">
                            <select class="form-control select2" id="closeRoomShop" ref="closeRoomShop"></select>
                        </div>
                        <div class="col-md-4" v-show="!roomVisible">
                            <span class="col-md-12 shop-cg" ref="closeRoomShopCg"></span>
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">包厢号：</label>
                        <div class="col-md-4">
                            <input class="form-control input-readonly" placeholder="请选择包厢号" v-model="room_box_num"
                                ref="close_room_box_num" readonly="readonly" @click="close_room_box_fun($event)">
                            <span :class="r_objClass" @click="r_clear_input()">×</span>
                            <span class="printer_arrow" role="presentation"><b role="presentation"></b></span>
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">关房播放歌曲：</label>
                        <div class="col-md-4">
                            <input class="form-control input-readonly" placeholder="请选择关房播放歌曲" v-model="room_song_name"
                                ref="room_song_name" readonly="readonly" @click="close_room_song_fun($event)" />
                            <span class="selection_clear" @click="clear_input('room_song_fun')">×</span>
                            <span class="printer_arrow" role="presentation">
                                <b role="presentation"></b></span>
                        </div>
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="openCloseUpdsongs($event)">上传歌曲</button>
                    </div>
                    <div class="row" style="padding-top: 30px;">
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="rtnFun('3')">返回</button>
                        <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;"
                            @click="closeRoomSave(addRoomModify)">保存</button>
                    </div>
                </div>
                <!-- 包厢号 -->
                <div class="details_content" ref="room_box_area" v-show="r_showbox">
                    <div class="page_header">选择包厢</div>
                    <p>请选择包厢范围</p>
                    <div class="box_area_main">
                        <div class="goods_checkboxdiv box_area">
                            <div class="first">
                                <input type="checkbox" v-model='r_box_allcheck' @click='rBoxAllcheck'>
                                <span>全部包厢</span>
                            </div>
                            <ul></ul>
                        </div>
                        <div class="goods_checkboxdiv box_area" v-for="items in r_box_checkboxData"
                            :key="items.room_area">
                            <div class="first">
                                <span>{{ items.room_area_name }}</span>
                            </div>
                            <ul>
                                <li v-for="item in items.room" :key="item.id">
                                    <input type="checkbox" v-model='r_box_checkboxModel' :value="item.id">
                                    <span>{{ item.name }}</span>
                                </li>
                                <div style="clear:both;"></div>
                            </ul>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 30px;">
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="rBoxReturn()">返回</button>
                        <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;"
                            @click="rBoxSubmit()">确定</button>
                    </div>
                </div>
                <!-- 关房播放歌曲弹窗 -->
                <div class="room-song-alert" ref="closeRoomSong_alert">
                    <div class="sel-seldiv">
                        <ul class="set-area">
                            <li v-for="item in songData" :key="item.id">
                                <input type="radio" v-model='r_song_checkModel' :value="item.id">
                                <label>{{ item.text }}</label>
                                <img src="../../assets/images/icon_del.png" @click="delSong(item.id)">
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 上传歌曲 -->
                <div class="ele-hide" ref="close_upload_songs">
                    <div class="upload-wrap" id="uploadWrap">
                        <span>选择并上传歌曲</span>
                        <div class="upload-file-info" id="closeOssfile">
                            你的浏览器不支持flash,Silverlight或者HTML5！
                        </div>
                        <input type="button" value="选择文件" id="closeRoomSelFile">
                        <button id="closeRoomSubFile">开始上传</button>
                        <p>上传歌曲格式需为：<em>mkv/mp4/avi</em>，仅支持H.264编码的文件</p>
                        <p>如上传格式不符合将无法正常播放</p>
                        <p>歌曲分辨率不能超过1080p，单个文件大小不能超过200m。</p>
                    </div>
                </div>
            </div>

            <!-- 灯光面板点播设置 -->
            <div class="vod-light-set" v-show="listShow10">
                <div v-show="!showLightSetPanel">
                    <p class="p-hint">注：1 设置后，操作灯光面板某个按键，TV播放对应歌单内容。2 灯光中控协议需支持巨嗨中控协议。3 设置成功后，需重启包厢机后生效</p>
                    <el-form :inline="true">
                        <el-select v-model="light_shop" placeholder="请选择门店" filterable>
                            <el-option v-for="item in lightShopList" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                        <div class="pull-right">
                            <el-button type="primary" @click="getLightTable">查询</el-button>
                            <el-button type="primary" @click="addNewLight">新增配置</el-button>
                            <el-button @click="backFun">返回</el-button>
                        </div>
                    </el-form>
                    <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)" :data="light_table">
                        <el-table-column prop="light_name" label="灯光名称"></el-table-column>
                        <el-table-column prop="key_name" label="面板按键名称"></el-table-column>
                        <el-table-column prop="status_name" label="状态"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="updateLightStatus(scope.row)">{{ scope.row.status == '1'
                                    ? '禁用' : '启用' }}</span>
                                <span class="text-blue" @click="getLightSetDetail(scope.row.id)">修改</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- 新增、修改 -->
                <div class="edit-panel" v-show="showLightSetPanel">
                    <h3>{{ light_edit_form.id == '' ? '新增' : '修改' }}点播歌单设置</h3>
                    <el-form label-width="120px">
                        <el-form-item label="灯光名称">
                            <el-select v-model="light_edit_form.light" placeholder="请选择灯光名称">
                                <el-option v-for="item in light_name_list" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                            <el-popover placement="top-start" title="说明" width="400" trigger="hover">
                                <p>灯光1(in24949=631)：上下行码值 7E 3B 31 31 0D</p>
                                <p>灯光2(in25049=632)：上下行码值 7E 3B 32 31 0D</p>
                                <p>灯光3(in25149=633)：上下行码值 7E 3B 33 31 0D</p>
                                <p>灯光4(in25249=634)：上下行码值 7E 3B 34 31 0D</p>
                                <p>灯光5(in25349=635)：上下行码值 7E 3B 35 31 0D</p>
                                <p>灯光6(in25449=636)：上下行码值 7E 3B 36 31 0D</p>
                                <p>灯光7(in25549=637)：上下行码值 7E 3B 37 31 0D</p>
                                <p>灯光8(in25649=638)：上下行码值 7E 3B 38 31 0D</p>
                                <p>灯光9(in25749=639)：上下行码值 7E 3B 39 31 0D</p>
                                <p>灯光10(in25849=640)：上下行码值 7E 3B 3A 31 0D</p>
                                <span class="rmarkspan" slot="reference"></span>
                            </el-popover>
                        </el-form-item>
                        <el-form-item label="面板按键名称">
                            <el-input v-model="light_edit_form.key_name" placeholder="请输入面板按键名称"></el-input>
                        </el-form-item>
                        <el-form-item label="TV端显示模式">
                            <el-radio-group v-model="light_edit_form.tv_mode" placeholder="请选择TV端显示模式">
                                <el-radio :label="'1'">全屏</el-radio>
                                <el-radio :label="'2'">壁画</el-radio>
                                <el-radio :label="'3'">画中画</el-radio>
                            </el-radio-group>
                            <el-popover placement="top-start" title="说明" width="400" trigger="hover"
                                content="若包厢未设置“播放器模式=2或3”时，设置“壁画、画中画”时不生效，默认为全屏">
                                <span class="rmarkspan" slot="reference"></span>
                            </el-popover>
                        </el-form-item>
                        <el-form-item label="歌单播放模式">
                            <el-radio-group v-model="light_edit_form.play_mode" placeholder="请选择播放模式">
                                <el-radio :label="'1'">单次+顺序播放</el-radio>
                                <el-radio :label="'2'">单次+随机播放</el-radio>
                                <el-radio :label="'3'">循环+顺序播放</el-radio>
                                <el-radio :label="'4'">循环+随机播放</el-radio>
                            </el-radio-group>
                            <el-popover placement="top-start" title="说明" width="450" trigger="hover">
                                <p>单次：歌单歌曲播放结束后，自动退出歌单播放模式</p>
                                <p>循环：循环播放歌单歌曲，需操作切歌后才退出歌单播放模式</p>
                                <p>顺序播放：根据添加歌单列表顺序播放</p>
                                <p>随机播放：根据添加歌单列表随机播放</p>
                                <span class="rmarkspan" slot="reference"></span>
                            </el-popover>
                        </el-form-item>
                        <el-form-item label="歌单设置">
                            <div class="song-list-set">
                                <div class="search-table">
                                    <h3>歌曲选择</h3>
                                    <el-form :inline="true">
                                        <el-form-item>
                                            <el-input :placeholder="search_song_form.search_key == 'szSong_name' ?
                                                '请输入歌曲名称' : search_song_form.search_key == 'szClass' ?
                                                    '请输入歌曲分类' : '请输入歌手名称'" v-model="search_song_form.search_value">
                                                <el-select v-model="search_song_form.search_key" slot="prepend">
                                                    <el-option label="歌曲名称" value="szSong_name"></el-option>
                                                    <el-option label="歌曲分类" value="szClass"></el-option>
                                                    <el-option label="歌手" value="szPlayer"></el-option>
                                                </el-select>
                                            </el-input>
                                        </el-form-item>
                                        <el-button type="primary" @click="getSongList(1)">查询</el-button>
                                    </el-form>
                                    <el-table v-loading="search_song_loading" element-loading-text="努力加载中，请稍后..."
                                        element-loading-background="rgba(0, 0, 0, 0.6)" :data="search_song_table">
                                        <el-table-column prop="szSong_name" label="歌曲名称"></el-table-column>
                                        <el-table-column prop="szClass" label="歌曲分类"></el-table-column>
                                        <el-table-column prop="szPlayer" label="歌手"></el-table-column>
                                        <el-table-column prop="songs_version" label="版本"></el-table-column>
                                        <el-table-column label="操作">
                                            <template slot-scope="scope">
                                                <span class="text-blue" @click="addSongToChoosed(scope.row)">添加</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <el-pagination background layout="total, prev, pager, next, jumper"
                                        :page-size="GLOBAL.PAGESIZE" :current-page.sync="search_song_page"
                                        :total="search_song_total" @current-change="getSongList">
                                    </el-pagination>
                                </div>
                                <div class="choosed-table">
                                    <h3>歌曲列表</h3>
                                    <el-table :data="choosed_song_table_for_show">
                                        <el-table-column prop="szSong_name" label="歌曲名称"></el-table-column>
                                        <el-table-column prop="szClass" label="歌曲分类"></el-table-column>
                                        <el-table-column prop="szPlayer" label="歌手"></el-table-column>
                                        <el-table-column prop="songs_version" label="版本"></el-table-column>
                                        <el-table-column label="操作">
                                            <template slot-scope="scope">
                                                <span class="text-blue" @click="delThisSong(scope.$index)">删除</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <el-pagination background layout="total, prev, pager, next, jumper"
                                        :page-size="GLOBAL.PAGESIZE" :current-page.sync="choosed_song_page"
                                        :total="choosed_song_total" @current-change="changeChoosedSongPage">
                                    </el-pagination>
                                </div>
                            </div>
                        </el-form-item>
                        <el-button @click="showLightSetPanel = false">返回</el-button>
                        <el-button type="primary" @click="saveLightSet">保存</el-button>
                    </el-form>
                </div>
            </div>

            <!-- 购买单曲设置 -->
            <div class="buy-song-set" v-show="listShow11">
                <div v-show="showBuySongList">
                    <p class="p-hint">注：新增规则后，付费条件的包厢点歌时，支持按首付费</p>
                    <el-form :inline="true" v-model="buy_song_form">
                        <el-form-item label="门店">
                            <el-select v-model="buy_song_form.shop_id" placeholder="请选择门店" filterable
                                @change="onBuySongShopChange">
                                <el-option v-for="item in shop_list" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="包厢">
                            <el-select v-model="buy_song_form.room_type" placeholder="请选择包厢类型" filterable clearable>
                                <el-option label="全部" value=""></el-option>
                                <el-option v-for="item in room_type_list" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="buy_song_form.status" placeholder="请选择状态" clearable>
                                <el-option label="全部" value=""></el-option>
                                <el-option label="启用" value="1"></el-option>
                                <el-option label="禁用" value="-1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="规则名称">
                            <el-input v-model="buy_song_form.name" placeholder="请输入规则名称" clearable></el-input>
                        </el-form-item>
                        <div class="pull-right">
                            <el-button type="primary" @click="getBuySongRuleList(1)">查询</el-button>
                            <el-button type="primary" @click="onAddBuySongRuleClick">新增规则</el-button>
                            <el-button @click="backFun">返回</el-button>
                        </div>
                    </el-form>
                    <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)" :data="buy_song_table">
                        <el-table-column prop="name" label="规则名称"> </el-table-column>
                        <el-table-column prop="room_type_name" label="适用包厢类型"></el-table-column>
                        <el-table-column prop="price" label="原价"></el-table-column>
                        <el-table-column prop="actual_price" label="优惠价"></el-table-column>
                        <el-table-column prop="week_cycle_str" label="有效星期日"></el-table-column>
                        <el-table-column label="使用时间">
                            <template slot-scope="scope">
                                {{ scope.row.start_time }}-{{ scope.row.end_time }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="updateBuySongStatus(scope.row)">{{ scope.row.status == 1
                                    ? '禁用' : '启用' }}</span>
                                <span class="text-blue" @click="editBuySong(scope.row.id)">修改</span>
                                <span class="text-blue" @click="delBuySongRule(scope.row.id)">删除</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="total, prev, pager, next, jumper" :page-size="GLOBAL.PAGESIZE"
                        :current-page.sync="fire_page" :total="fire_total" @current-change="getFireAlarmList">
                    </el-pagination>
                </div>
                <!-- 新增、修改购买单曲 -->
                <div class="add-buy-song-panel" v-show="!showBuySongList">
                    <h3>{{ add_buy_song.id == '' ? '新增' : '修改' }}购买单曲付费规则</h3>
                    <el-form v-model="add_buy_song" label-width="100px">
                        <el-form-item label="门店">
                            <el-select v-model="add_buy_song.shop_id" placeholder="请选择门店" disabled>
                                <el-option v-for="item in shop_list" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="规则名称">
                            <el-input v-model="add_buy_song.name" placeholder="请输入规则名称"></el-input>
                        </el-form-item>
                        <el-form-item label="适用包厢类型">
                            <el-input v-model="room_types_str" placeholder="请选择适用包厢类型" readonly clearable
                                @focus="openRoomTypePop" @clear="clearRoomTypes"
                                :disabled="add_buy_song.id != ''"></el-input>
                        </el-form-item>
                        <el-form-item label="原价">
                            <el-input v-model="add_buy_song.price" placeholder="请输入划线价金额（仅显示作用，不填写时与优惠价一致）"></el-input>
                        </el-form-item>
                        <el-form-item label="优惠价">
                            <el-input v-model="add_buy_song.actual_price" placeholder="请输入优惠价金额（实际支付金额）"></el-input>
                        </el-form-item>
                        <el-form-item label="会员价">
                            <el-input v-model="add_buy_song.vip_price"
                                placeholder="请输入会员价金额（设置0或不设置时与优惠价一致）"></el-input>
                        </el-form-item>
                        <el-form-item label="使用时间">
                            <el-input v-model="use_time_str" placeholder="请选择使用时间" readonly clearable
                                @focus="openUseTimePop" @clear="clearUseTime"></el-input>
                        </el-form-item>
                        <el-form-item label="有效星期日">
                            <el-input v-model="week_str" placeholder="请选择有效星期日" readonly clearable @focus="openWeekPop"
                                @clear="clearWeek"></el-input>
                        </el-form-item>
                        <el-form-item label="不可用日期">
                            <div class="time-wrapper" ref="disdate">
                                <el-input v-model="disabled_date_str" placeholder="请选择不可使用日期（选填）" clearable
                                    @click.native="clearDisdate"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item label="适用日期">
                            <div class="time-wrapper" ref="enabledate">
                                <el-input v-model="enable_date_str" placeholder="请选择试用日期" clearable
                                    @click.native="clearEnableDate"></el-input>
                            </div>
                        </el-form-item>
                        <div class="sub-title">—————— 不同会员价 ——————</div>
                        <el-row>
                            <el-form-item label="一级会员价">
                                <el-input v-model="add_buy_song.vip_level1_price"
                                    placeholder="填写一级会员等级享受的会员价"></el-input>
                            </el-form-item>
                            <el-form-item label="二级会员价">
                                <el-input v-model="add_buy_song.vip_level2_price"
                                    placeholder="填写二级会员等级享受的会员价"></el-input>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item label="三级会员价">
                                <el-input v-model="add_buy_song.vip_level3_price"
                                    placeholder="填写三级会员等级享受的会员价"></el-input>
                            </el-form-item>
                            <el-form-item label="四级会员价">
                                <el-input v-model="add_buy_song.vip_level4_price"
                                    placeholder="填写四级会员等级享受的会员价"></el-input>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item label="五级会员价">
                                <el-input v-model="add_buy_song.vip_level5_price"
                                    placeholder="填写五级会员等级享受的会员价"></el-input>
                            </el-form-item>
                            <el-form-item label="六级会员价">
                                <el-input v-model="add_buy_song.vip_level6_price"
                                    placeholder="填写六级会员等级享受的会员价"></el-input>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item label="七级会员价">
                                <el-input v-model="add_buy_song.vip_level7_price"
                                    placeholder="填写七级会员等级享受的会员价"></el-input>
                            </el-form-item>
                            <el-form-item label="八级会员价">
                                <el-input v-model="add_buy_song.vip_level8_price"
                                    placeholder="填写八级会员等级享受的会员价"></el-input>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item label="九级会员价">
                                <el-input v-model="add_buy_song.vip_level9_price"
                                    placeholder="填写九级会员等级享受的会员价"></el-input>
                            </el-form-item>
                            <el-form-item label="十级会员价">
                                <el-input v-model="add_buy_song.vip_level10_price"
                                    placeholder="填写十级会员等级享受的会员价"></el-input>
                            </el-form-item>
                        </el-row>
                        <el-button @click="showBuySongList = true">返回</el-button>
                        <el-button type="primary" @click="commitBuySong">确认</el-button>
                    </el-form>
                    <!--包厢类型弹窗-->
                    <div class="ele-hide" ref="boxtype_pop">
                        <div class="multi-select">
                            <div class="clearfix">
                                <li>
                                    <input type='checkbox' v-model='boxtype_all' @click='boxtypeAll'>
                                    <label>全选</label>
                                </li>
                            </div>
                            <ul class="clearfix">
                                <li v-for="item in room_type_list" :key="item.id">
                                    <input type="checkbox" v-model='boxtype_item' :value="item.id">
                                    <label>{{ item.name }}</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- 使用时间弹窗 -->
                    <div class="use-time-wrap ele-hide" ref="usetime_pop">
                        <h2>开始时间：</h2>
                        <el-row>
                            <el-col :span="11">
                                <el-select v-model="hour_start" filterable>
                                    <el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item"
                                        :value="item"></el-option>
                                </el-select>
                            </el-col>
                            <el-col class="el-line" :span="2">:</el-col>
                            <el-col :span="11">
                                <el-select v-model="minute_start" filterable>
                                    <el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item"
                                        :value="item"></el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <h2>结束时间：</h2>
                        <el-row>
                            <el-col :span="11">
                                <el-select v-model="hour_end" filterable>
                                    <el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item"
                                        :value="item"></el-option>
                                </el-select>
                            </el-col>
                            <el-col class="el-line" :span="2">:</el-col>
                            <el-col :span="11">
                                <el-select v-model="minute_end" filterable>
                                    <el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item"
                                        :value="item"></el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                    </div>
                    <!-- 星期几弹窗 -->
                    <div class="week-pop ele-hide" ref="week_pop">
                        <el-checkbox :indeterminate="week_sign" v-model="week_all" @change="weekAll">全选</el-checkbox>
                        <el-checkbox-group v-model="week_ids" @change="weekChange">
                            <el-checkbox label="1">星期一</el-checkbox>
                            <el-checkbox label="2">星期二</el-checkbox>
                            <el-checkbox label="3">星期三</el-checkbox>
                            <el-checkbox label="4">星期四</el-checkbox>
                            <el-checkbox label="5">星期五</el-checkbox>
                            <el-checkbox label="6">星期六</el-checkbox>
                            <el-checkbox label="0">星期日</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
            </div>

            <!-- 三合一效果文件管理 -->
            <div class="three-in-one-manage" v-show="listShow12">
                <div v-show="!showAddFilePanel">
                    <el-form :inline="true">
                        <el-form-item label="门店">
                            <el-select v-model="file_manage_form.shop_id" filterable placeholder="请选择门店"
                                @change="onFileManageShopChange">
                                <el-option v-for="item in file_manage_shop_list" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="包厢号">
                            <el-select v-model="file_manage_form.room_id" filterable clearable placeholder="请输入包厢号">
                                <el-option v-for="item in file_manage_room_list" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="设备型号">
                            <el-select v-model="file_manage_form.tool_id" filterable clearable placeholder="请选择设备型号">
                                <el-option label="全部" value=""></el-option>
                                <el-option v-for="item in device_list" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="文件名称">
                            <el-input v-model="file_manage_form.file_name" clearable placeholder="请输入文件名称"></el-input>
                        </el-form-item>
                        <el-button type="primary" @click="onAddFileClick">新增效果文件</el-button>
                        <el-button type="primary" @click="getFileManageList">查询</el-button>
                        <el-button @click="backFun">返回</el-button>
                    </el-form>
                    <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)" :header-cell-style="{ 'text-align': 'center' }"
                        :cell-style="{ 'text-align': 'center' }" :data="file_manage_list">
                        <el-table-column prop="room_name" label="包厢号"></el-table-column>
                        <el-table-column prop="tool_name" label="设备型号"></el-table-column>
                        <el-table-column prop="structure_desc" label="房间结构"></el-table-column>
                        <el-table-column prop="area_desc" label="房间面积"></el-table-column>
                        <el-table-column prop="speaker_desc" label="音响型号"></el-table-column>
                        <el-table-column prop="file_name" label="文件名称"></el-table-column>
                        <el-table-column prop="file_describe" label="文件描述"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="editFileManage(scope.row)">修改</span>
                                <span class="text-blue" @click="delFileManage(scope.row.id)">删除</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- 新增、修改效果文件 -->
                <div class="add-file-panel" v-show="showAddFilePanel && !showFileManageRoom">
                    <h3>新增效果文件</h3>
                    <el-form label-width="80px">
                        <el-form-item label="包厢号" required>
                            <el-input v-model="add_file_form.room_name" placeholder="请选择包厢号" readonly
                                @click.native="showFileManageRoom = true"></el-input>
                        </el-form-item>
                        <el-form-item label="设备型号" required>
                            <el-select v-model="add_file_form.tool_id" placeholder="请选择设备型号" clearable filterable>
                                <el-option v-for="item in device_list" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="文件名称" required>
                            <el-input v-model="add_file_form.file_name" placeholder="请输入效果文件名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="房间结构" required>
                            <el-select v-model="add_file_form.structure_id" placeholder="请选择房间结构" clearable>
                                <el-option v-for="item in structure_list" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="房间面积" required>
                            <el-select v-model="add_file_form.area_id" placeholder="请选择房间面积" clearable>
                                <el-option v-for="item in area_list" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="音响型号" required>
                            <el-select v-model="add_file_form.speaker_id" placeholder="请选择音响型号" clearable>
                                <el-option v-for="item in speaker_list" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="文件描述">
                            <el-input v-model="add_file_form.file_describe" placeholder="请输入效果文件描述" type="textarea"
                                :rows="3" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="效果1-">
                            <el-input v-model="add_file_form.file_url_name1" placeholder="效果名称（选填）" clearable
                                class="short"></el-input>
                            <el-input v-model="add_file_form.file_url1" placeholder="请上传效果文件" readonly></el-input>
                            <el-button type="primary" id="up-file-1">上传文件</el-button>
                        </el-form-item>
                        <el-form-item label="效果2-">
                            <el-input v-model="add_file_form.file_url_name2" placeholder="效果名称（选填）" clearable
                                class="short"></el-input>
                            <el-input v-model="add_file_form.file_url2" placeholder="请上传效果文件" readonly></el-input>
                            <el-button type="primary" id="up-file-2">上传文件</el-button>
                        </el-form-item>
                        <el-form-item label="效果3-">
                            <el-input v-model="add_file_form.file_url_name3" placeholder="效果名称（选填）" clearable
                                class="short"></el-input>
                            <el-input v-model="add_file_form.file_url3" placeholder="请上传效果文件" readonly></el-input>
                            <el-button type="primary" id="up-file-3">上传文件</el-button>
                        </el-form-item>
                        <el-form-item label="效果4-">
                            <el-input v-model="add_file_form.file_url_name4" placeholder="效果名称（选填）" clearable
                                class="short"></el-input>
                            <el-input v-model="add_file_form.file_url4" placeholder="请上传效果文件" readonly></el-input>
                            <el-button type="primary" id="up-file-4">上传文件</el-button>
                        </el-form-item>
                        <el-form-item label="效果5-">
                            <el-input v-model="add_file_form.file_url_name5" placeholder="效果名称（选填）" clearable
                                class="short"></el-input>
                            <el-input v-model="add_file_form.file_url5" placeholder="请上传效果文件" readonly></el-input>
                            <el-button type="primary" id="up-file-5">上传文件</el-button>
                        </el-form-item>
                        <el-form-item label="效果6-">
                            <el-input v-model="add_file_form.file_url_name6" placeholder="效果名称（选填）" clearable
                                class="short"></el-input>
                            <el-input v-model="add_file_form.file_url6" placeholder="请上传效果文件" readonly></el-input>
                            <el-button type="primary" id="up-file-6">上传文件</el-button>
                        </el-form-item>
                        <el-form-item label="效果7-">
                            <el-input v-model="add_file_form.file_url_name7" placeholder="效果名称（选填）" clearable
                                class="short"></el-input>
                            <el-input v-model="add_file_form.file_url7" placeholder="请上传效果文件" readonly></el-input>
                            <el-button type="primary" id="up-file-7">上传文件</el-button>
                        </el-form-item>
                        <el-form-item label="效果8-">
                            <el-input v-model="add_file_form.file_url_name8" placeholder="效果名称（选填）" clearable
                                class="short"></el-input>
                            <el-input v-model="add_file_form.file_url8" placeholder="请上传效果文件" readonly></el-input>
                            <el-button type="primary" id="up-file-8">上传文件</el-button>
                        </el-form-item>
                        <el-form-item label="效果9-">
                            <el-input v-model="add_file_form.file_url_name9" placeholder="效果名称（选填）" clearable
                                class="short"></el-input>
                            <el-input v-model="add_file_form.file_url9" placeholder="请上传效果文件" readonly></el-input>
                            <el-button type="primary" id="up-file-9">上传文件</el-button>
                        </el-form-item>
                        <el-form-item label="效果10-">
                            <el-input v-model="add_file_form.file_url_name10" placeholder="效果名称（选填）" clearable
                                class="short"></el-input>
                            <el-input v-model="add_file_form.file_url10" placeholder="请上传效果文件" readonly></el-input>
                            <el-button type="primary" id="up-file-10">上传文件</el-button>
                        </el-form-item>
                        <el-button @click="showAddFilePanel = false">返回</el-button>
                        <el-button type="primary" @click="commitAddFile">确认</el-button>
                    </el-form>
                </div>
                <!-- 包厢号 -->
                <div class="room-choose-page" v-show="showFileManageRoom">
                    <h3>选择包厢</h3>
                    <div class="wrapper">
                        <div class="area" v-for="item in file_manage_room_arr">
                            <div class="area-name">{{ item.room_area_name }}</div>
                            <div class="rooms">
                                <div class="room" v-for="room in item.room">
                                    <el-radio v-model="add_file_form.room_id" :label="room.id"
                                        @input="onRoomRadioInput">{{
                                            room.name }}</el-radio>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="btbs">
                        <el-button @click="showFileManageRoom = false">返回</el-button>
                        <el-button type="primary" @click="confirmRoomChoose">确定</el-button>
                    </div>
                </div>
            </div>

            <!-- 智慧交换机设置 -->
            <div class="smart-machine-set" v-show="listShow13">
                <div v-show="!showSmartMachineSetPanel">
                    <h1 class="title">智慧交换机设置</h1>
                    <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)" :header-cell-style="{ 'text-align': 'center' }"
                        :cell-style="{ 'text-align': 'center' }" :data="smart_machine_shop_list">
                        <el-table-column prop="shop_name" label="门店"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="onSmartMachineSetClick(scope.row)">设置</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="total, prev, pager, next, jumper" :page-size="GLOBAL.PAGESIZE"
                        :current-page.sync="smart_machine_shop_page" :total="smart_machine_shop_total"
                        @current-change="getSmartMachineShopList">
                    </el-pagination>
                    <el-button @click="backFun">返回</el-button>
                </div>
                <!-- 设置面板 -->
                <div v-show="showSmartMachineSetPanel">
                    <h1>设置</h1>
                    <div class="shop-name">门店：{{ shop_name }}</div>
                    <div class="module-title">交换机电源线路管理</div>
                    <div class="gray-block">
                        <div class="line" v-for="(item, index) in line_data" :key="item.id">
                            <div class="line-name">线路{{ index + 1 }}</div>
                            <el-input v-model="item.name" placeholder="请输入线路名称" clearable @blur="editLineName">
                            </el-input>
                        </div>
                    </div>
                    <div class="module-title">电源控制</div>
                    <div class="control-block" v-for="(item, index) in switch_control" :key="item.type">
                        <div class="block-title">{{ item.name }}<el-button type="primary"
                                @click="onAddControlClick(item)">新增控制</el-button></div>
                        <el-table :header-cell-style="{ 'text-align': 'center' }"
                            :cell-style="{ 'text-align': 'center' }" :data="item.action">
                            <el-table-column prop="control_type_name" label="控制类型"></el-table-column>
                            <el-table-column prop="control_content" label="控制详情"></el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <span class="text-blue" @click="openEditControlPop(scope.row)">修改</span>
                                    <span class="text-blue" @click="delControl(scope.row)">删除</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="buttons">
                        <el-button @click="showSmartMachineSetPanel = false">返回</el-button>
                    </div>
                </div>
                <!-- 控制弹窗 -->
                <div class="control-pop ele-hide" ref="switch_control_pop">
                    <el-form label-width="80px">
                        <el-form-item label="控制类型">
                            <el-select v-model="switch_control_form.control_type" placeholder="请选择控制类型"
                                popper-class="high-index" @change="onControlTypeChange">
                                <el-option v-for="item in control_types" :key="item.control_type"
                                    :label="item.control_type_name" :value="item.control_type">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="控制详情">
                            <el-select v-model="switch_control_form.action" placeholder="请选择控制详情"
                                :disabled="!switch_control_form.control_type">
                                <el-option v-for="item in control_actions" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label=" ">
                            <el-radio-group v-model="switch_control_form.action_info"
                                v-if="control_action_info.length > 0">
                                <el-radio :label="item.id" v-for="item in control_action_info" :key="item.id">{{
                                    item.name
                                    }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

            <!-- 智慧控制器配置 -->
            <div class="smart-control-set" v-show="listShow14">
                <div v-show="!showSmartControlSetPanel">
                    <h1 class="title">智慧控制器配置</h1>
                    <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)" :header-cell-style="{ 'text-align': 'center' }"
                        :cell-style="{ 'text-align': 'center' }" :data="smart_control_shop_list">
                        <el-table-column prop="shop_name" label="门店"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="onSmartControlSetClick(scope.row)">设置</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="total, prev, pager, next, jumper" :page-size="GLOBAL.PAGESIZE"
                        :current-page.sync="smart_control_shop_page" :total="smart_control_shop_total"
                        @current-change="getSmartControlShopList">
                    </el-pagination>
                    <el-button @click="backFun">返回</el-button>
                </div>
                <!-- 设置面板 -->
                <div v-show="showSmartControlSetPanel">
                    <h1>设置</h1>
                    <div class="shop-name">门店：{{ shop_name }}</div>
                    <div class="module-title">设备管理</div>
                    <div class="gray-block">
                        <div class="block-title">智能控制器电源线路管理</div>
                        <div class="line" v-for="(item, index) in line_data">
                            <div class="line-name">线路{{ index + 1 }}</div>
                            <el-input v-model="item.name" placeholder="请输入线路名称" clearable @blur="editLineName2">
                            </el-input>
                        </div>
                        <div class="block-title have-top-line">易微联设备线路管理</div>
                        <div class="line" v-for="(item, index) in breaker_data">
                            <div class="line-name">线路{{ index + 1 }}</div>
                            <el-input v-model="item.name" placeholder="请输入线路名称" clearable @blur="editBreakerName">
                            </el-input>
                        </div>
                    </div>
                    <div class="module-title">电源控制</div>
                    <div class="control-block" v-for="(item, index) in switch_control" :key="item.type">
                        <div class="block-title">{{ item.name }}<el-button type="primary"
                                @click="onAddControlClick2(item)">新增控制</el-button></div>
                        <el-table :header-cell-style="{ 'text-align': 'center' }"
                            :cell-style="{ 'text-align': 'center' }" :data="item.action">
                            <el-table-column prop="control_type_name" label="控制类型"></el-table-column>
                            <el-table-column prop="control_content" label="控制详情"></el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <span class="text-blue" @click="openEditControlPop2(scope.row)">修改</span>
                                    <span class="text-blue" @click="delControl2(scope.row)">删除</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="buttons">
                        <el-button @click="showSmartControlSetPanel = false">返回</el-button>
                    </div>
                </div>
                <!-- 控制弹窗 -->
                <div class="control-pop ele-hide" ref="switch_control_pop2">
                    <el-form label-width="80px">
                        <el-form-item label="控制类型">
                            <el-select v-model="switch_control_form.control_type" placeholder="请选择控制类型"
                                popper-class="high-index" @change="onControlTypeChange">
                                <el-option v-for="item in control_types" :key="item.control_type"
                                    :label="item.control_type_name" :value="item.control_type">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="控制详情">
                            <el-select v-model="switch_control_form.action" placeholder="请选择控制详情"
                                v-if="switch_control_form.control_type != '4'"
                                :disabled="!switch_control_form.control_type">
                                <el-option v-for="item in control_actions" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                            <!-- 通通锁 -->
                            <el-radio-group v-model="switch_control_form.action_info"
                                v-if="control_action_info.length > 0 && switch_control_form.control_type == '4'">
                                <el-radio :label="item.id" v-for="item in control_action_info" :key="item.id">{{
                                    item.name
                                    }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label=" " v-if="switch_control_form.control_type != '4'">
                            <el-radio-group v-model="switch_control_form.action_info"
                                v-if="control_action_info.length > 0">
                                <el-radio :label="item.id" v-for="item in control_action_info" :key="item.id">{{
                                    item.name
                                    }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

            <!-- 工作歌单 -->
            <div class="work-song-list" v-show="listShow15">
                <h1 class="title">工作歌单</h1>
                <p class="red-tip" style="margin-bottom: 10px;">注：工作歌单设置后，触摸屏-员工操作-员工歌单、智慧商家app-包厢状态-远程点歌可查看及点播工作歌单歌曲
                </p>
                <el-form :inline="true" :model="work_song_list_form">
                    <el-form-item label="门店">
                        <el-select v-model="work_song_list_form.shop_id" placeholder="请选择门店">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="歌星">
                        <el-input v-model="work_song_list_form.song_player" placeholder="请输入歌星"></el-input>
                    </el-form-item>
                    <el-form-item label="歌曲">
                        <el-input v-model="work_song_list_form.song_name" placeholder="请输入歌曲名称"></el-input>
                    </el-form-item>
                    <el-button type="primary" @click="getWorkSongList(1)">查询</el-button>
                    <el-button type="primary" @click="addWorkSong">添加歌曲</el-button>
                    <el-button @click="backFun">返回</el-button>
                </el-form>
                <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)" :header-cell-style="{ 'text-align': 'center' }"
                    :cell-style="{ 'text-align': 'center' }" :data="work_song_list_table">
                    <el-table-column prop="song_player" label="歌星"></el-table-column>
                    <el-table-column prop="song_name" label="歌曲"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="delThisWorkSong(scope.row)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination background layout="total, prev, pager, next, jumper" :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="work_song_list_page" :total="work_song_list_total"
                    @current-change="getWorkSongList">
                </el-pagination>
                <!-- 添加歌曲弹窗 -->
                <div class="add-work-song-pop ele-hide" ref="add_work_song_pop">
                    <div class="pop-row">
                        <el-input :placeholder="work_song_pop_type == 1 ? '请输入歌曲名称' : '请输入歌手名称'"
                            v-model="work_song_pop_key" class="input-with-select">
                            <el-select v-model="work_song_pop_type" slot="prepend" placeholder="请选择"
                                popper-class="high-index">
                                <el-option label="歌曲名称" value="1"></el-option>
                                <el-option label="歌手" value="2"></el-option>
                            </el-select>
                        </el-input>
                        <el-button type="primary" @click="getWorkSongPopList(1)">查询</el-button>
                    </div>
                    <el-table v-loading="work_song_pop_loading" element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)" :header-cell-style="{ 'text-align': 'center' }"
                        :cell-style="{ 'text-align': 'center' }" :data="work_song_pop_table">
                        <el-table-column prop="szSong_name" label="歌曲名称"></el-table-column>
                        <el-table-column prop="szClass" label="歌曲分类"></el-table-column>
                        <el-table-column prop="szPlayer" label="歌手"></el-table-column>
                        <el-table-column prop="songs_version" label="版本"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="addThisWorkSong(scope.row)">添加</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="total, prev, pager, next, jumper" :page-size="GLOBAL.PAGESIZE"
                        :current-page.sync="work_song_pop_page" :total="work_song_pop_total"
                        @current-change="getWorkSongPopList">
                    </el-pagination>
                </div>
            </div>

            <!-- Youtube设置 -->
            <div class="youtube-set" v-show="listShow16">
                <h1 class="title">Youtube设置</h1>
                <el-button @click="backFun">返回</el-button>
                <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)" :header-cell-style="{ 'text-align': 'center' }"
                    :cell-style="{ 'text-align': 'center' }" :data="youtube_set_table">
                    <el-table-column prop="shop_name" label="门店"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="setYoutube(scope.row)">设置</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination background layout="total, prev, pager, next, jumper" :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="youtube_set_page" :total="youtube_set_total"
                    @current-change="getYoutubeSetList">
                </el-pagination>
                <!-- 设置Youtube弹窗 -->
                <div class="set-youtube-pop ele-hide" ref="set_youtube_pop">
                    <el-form label-width="80px">
                        <el-form-item label="密钥设置">
                            <el-input v-model="youtube_key" placeholder="请输入密钥内容" clearable></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

            <!-- 包厢麦克风低电量通知图配置 -->
            <div class="mic-low-power-set" v-show="listShow17">
                <div v-show="!showMicLowPowerAddPanel">
                    <p class="p-hint">注：配置成功后，1 包厢麦克风低电量提醒时，TV页面显示对应配置图片；2 需重启机顶盒后生效；</p>
                    <el-form :inline="true">
                        <el-select v-model="mic_low_power_shop" placeholder="请选择门店" filterable
                            @change="onMicLowPowerShopChange">
                            <el-option v-for="item in mic_low_power_shop_list" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                        <div class="pull-right">
                            <el-button type="primary" @click="getMicLowPowerList(1)">查询</el-button>
                            <el-button type="primary" @click="micLowPowerAdd">新增配置</el-button>
                            <el-button @click="backFun">返回</el-button>
                        </div>
                    </el-form>
                    <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)" :data="mic_low_power_table">
                        <el-table-column label="图片">
                            <template slot-scope="scope">
                                <img class="list-img" :src="scope.row.img_url">
                            </template>
                        </el-table-column>
                        <el-table-column prop="room_str" label="适用包厢"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="micLowPowerModify(scope.row)">修改</span>
                                <span class="text-blue" @click="micLowPowerDel(scope.row.id)">删除</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="total, prev, pager, next, jumper" :page-size="GLOBAL.PAGESIZE"
                        :current-page.sync="mic_low_power_page" :total="mic_low_power_total"
                        @current-change="getMicLowPowerList">
                    </el-pagination>
                </div>
                <div class="mic-low-power-add-panel" v-show="showMicLowPowerAddPanel && !showMicLowPowerBox">
                    <h1>{{ add_mic_low_power_form.id == '' ? '新增' : '修改' }}配置</h1>
                    <el-form label-width="80px">
                        <el-form-item label="门店">
                            <el-select v-model="add_mic_low_power_form.shop_id" placeholder="请选择门店" filterable disabled>
                                <el-option v-for="item in mic_low_power_shop_list" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="适用包厢">
                            <el-input v-model="add_mic_low_power_form.room_str" placeholder="请选择适用包厢" readonly
                                @click.native="openMicLowPowerRoomPanel"></el-input>
                        </el-form-item>
                        <el-form-item label="图片">
                            <span class="red-tip">图片规范：尺寸688*475，格式png</span>
                            <div class="mic-low-power-img-wrapper" id="mic-low-power-img-wrapper">
                                <img :src="add_mic_low_power_form.img_url" alt="" class="mic-low-power-img"
                                    v-if="add_mic_low_power_form.img_url != ''">
                                <img src="../../assets/images/upload_btn.png" alt="" class="mic-low-power-img" v-else>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="showMicLowPowerAddPanel = false">返回</el-button>
                            <el-button type="primary" @click="commitMicLowPowerSet">确认</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 包厢号 -->
                <div class="multi-page" ref="box_area" v-show="showMicLowPowerBox">
                    <div class="page-tit">选择包厢</div>
                    <p>请选择包厢范围</p>
                    <div class="multi-page-main">
                        <div class="multi-page-row">
                            <div>
                                <input type="checkbox" v-model='box_all' @click='boxAll'>
                                <span>全部包厢</span>
                            </div>
                            <ul></ul>
                        </div>
                        <div class="multi-page-row" v-for="(items, index) in box_arr" :key="items.room_area">
                            <div>
                                <input type="checkbox" v-model='box_floor' :value="items.room_area"
                                    @click="boxFloor(items.room_area, index)">
                                <span>{{ items.room_area_name }}</span>
                            </div>
                            <ul class="clearfix">
                                <li v-for="item in items.room" :key="item.id">
                                    <input type="checkbox" v-model='box_item' :value="item.id">
                                    <span>{{ item.name }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row">
                        <el-button @click="showMicLowPowerBox = false">返回</el-button>
                        <el-button type="primary" @click="saveMicLowPowerBox">确定</el-button>
                    </div>
                </div>
            </div>

            <!-- 场景灯光配置 -->
            <div class="vod-scene-set" v-show="listShow18">
                <div class="scene-list" v-show="showScene">
                    <!-- <div class="row row-magin-bottom">
                        <button type="button" class="btn bg-orange btn-flat bigbtn" @click="add_scene()">智能灯光配置</button>
                    </div> -->
                    <el-form :inline="true">
                        <el-form-item label="门店名称">
                            <el-select v-model="scene_shop_id" placeholder="请选择门店">
                                <el-option v-for="item in sceneShop" :key="item.id" :label="item.text"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-button type="primary" @click="innitSceneTable">查询</el-button>
                        <el-button type="primary" @click="add_scene">场景灯光配置</el-button>
                    </el-form>
                    <div class="table-responsive">
                        <table id="sceneList" class="table table-bordered table-hover xqg-list" data-pagination="true"
                            ref="sceneList" style="margin-top:10px"></table>
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="backFun">返回</button>
                    </div>
                </div>
                <!-- 新增/修改 -->
                <div class="scene-set" v-show="showSceneSet">
                    <div class="page-tit">{{ add_scene_header }}</div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">门店：</label>
                        <div class="col-md-4" v-show="sceneVisible">
                            <select class="form-control select2" id="sceneShop" ref="sceneShop"></select>
                        </div>
                        <div class="col-md-4" v-show="!sceneVisible">
                            <span class="col-md-12 shop-cg" ref="sceneShopCg"></span>
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">状态：</label>
                        <div class="col-md-4">
                            <select class="form-control select2" ref="sceneStatus">
                                <option value="1">开启</option>
                                <option value="-1">关闭</option>
                            </select>
                        </div>
                    </div>
                    <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">包厢号：</label>
                        <div class="col-md-4">
                            <input class="form-control input-readonly" placeholder="请选择包厢号" v-model="scene_room_num"
                                ref="scene_room_num" readonly="readonly" @click="scene_room_fun($event)">
                            <span :class="s_objClass" @click="s_clear_input()">×</span>
                            <span class="printer_arrow" role="presentation"><b role="presentation"></b></span>
                        </div>
                    </div>
                    <!-- <div class="row rowpadding">
                        <label class="col-md-1 ctr-label-left">配置参数：</label>
                        <div class="col-md-4">
                            <textarea class="form-control xgq-mp" v-model="scene_mp_cs" placeholder="请输入智能灯光配置参数，例如：paclista=48;49;paclistb=49;paclistc=48;49;paclistd=48;49;pacliste=48;49;paclistn=49;49;49;49;49;"></textarea>
                        </div>
                        <span class="rmarkspan" titles="配置说明：<br>解析：1）paclista是指a类歌曲；paclistb是指b类歌曲，以此类推···<br>2）49数值是通过 先歌协议/灯光1/开/31H 的十六进制转换成十进制得来。<br>3）48数值是通过 先歌协议/灯光1/关/30H 的十六进制转换成十进制得来。<br>4）paclista=49;49;49;49;49; 意思是a类歌曲灯光全开<br>5）paclistb=48;48;48;48;48; 意思是b类歌曲灯光全关<br>6）paclistc=49;48;48;48;48; 意思是c类歌曲灯光1路开，其他4路都关。<br>7）灯光分类标准：<br>A 空白&nbsp; B 迪斯科&nbsp; C 打碟&nbsp; D 华尔兹&nbsp; E 四拍舞曲&nbsp; F 探戈&nbsp; G 恰恰、伦巴、慢摇&nbsp; H 心痛&nbsp; I 伤感&nbsp; J 舒服&nbsp; K 欢快&nbsp; L 激情&nbsp; M 励志&nbsp; N 怀旧&nbsp; O 摇滚&nbsp; P R&B&nbsp; Q Hip-Pop&nbsp; R 电子&nbsp; S 爵士&nbsp; T 蓝调、美声&nbsp; U 乡村、民谣&nbsp; V 生日&nbsp; W 民歌、民族&nbsp; X 戏曲&nbsp; Y 儿歌&nbsp; Z 喜庆&nbsp;" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
                    </div> -->
                    <div class="el-row">
                        <label class="col-md-1 ctr-label-left">场景1</label>
                        <el-radio v-model="scene_paclist1.status" :label="1">开启</el-radio>
                        <el-radio v-model="scene_paclist1.status" :label="-1">关闭<span
                                class="red-tip">（关闭后，则该灯光按键不在点歌页面显示）</span></el-radio>
                    </div>
                    <div class="gray-block" v-if="scene_paclist1.status == '1'">
                        <div class="canshu-setting">
                            <div class="label">场景</div>
                            <el-input class="small" type="text" placeholder="场景名称" v-model="scene_paclist1.name"
                                maxlength="3" show-word-limit></el-input>
                            <div class="label">开启配置参数</div>
                            <el-input type="text" placeholder="请输入场景配置参数，例如：paclist1=48;49;48;48;48;48"
                                v-model="scene_paclist1.open_value"></el-input>
                            <div class="label">关闭配置参数</div>
                            <el-input type="text" placeholder="请输入场景配置参数，例如：paclist1=48;49;48;48;48;48"
                                v-model="scene_paclist1.close_value"></el-input>
                        </div>
                        <div class="default-setting">
                            <div class="label">默认设置</div>
                            <el-radio v-model="scene_paclist1.default_status" :label="1">开启</el-radio>
                            <el-radio v-model="scene_paclist1.default_status" :label="-1">关闭</el-radio>
                        </div>
                    </div>
                    <div class="el-row">
                        <label class="col-md-1 ctr-label-left">场景2</label>
                        <el-radio v-model="scene_paclist2.status" :label="1">开启</el-radio>
                        <el-radio v-model="scene_paclist2.status" :label="-1">关闭<span
                                class="red-tip">（关闭后，则该灯光按键不在点歌页面显示）</span></el-radio>
                    </div>
                    <div class="gray-block" v-if="scene_paclist2.status == '1'">
                        <div>
                            <div class="label">场景</div>
                            <el-input class="small" type="text" placeholder="场景名称" v-model="scene_paclist2.name"
                                maxlength="3" show-word-limit></el-input>
                            <div class="label">开启配置参数</div>
                            <el-input type="text" placeholder="请输入场景配置参数，例如：paclist2=48;48;49;48;48;48"
                                v-model="scene_paclist2.open_value"></el-input>
                            <div class="label">关闭配置参数</div>
                            <el-input type="text" placeholder="请输入场景配置参数，例如：paclist2=48;48;49;48;48;48"
                                v-model="scene_paclist2.close_value"></el-input>
                        </div>
                        <div class="default-setting">
                            <div class="label">默认设置</div>
                            <el-radio v-model="scene_paclist2.default_status" :label="1">开启</el-radio>
                            <el-radio v-model="scene_paclist2.default_status" :label="-1">关闭</el-radio>
                        </div>
                    </div>
                    <div class="el-row">
                        <label class="col-md-1 ctr-label-left">场景3</label>
                        <el-radio v-model="scene_paclist3.status" :label="1">开启</el-radio>
                        <el-radio v-model="scene_paclist3.status" :label="-1">关闭<span
                                class="red-tip">（关闭后，则该灯光按键不在点歌页面显示）</span></el-radio>
                    </div>
                    <div class="gray-block" v-if="scene_paclist3.status == '1'">
                        <div>
                            <div class="label">场景</div>
                            <el-input class="small" type="text" placeholder="场景名称" v-model="scene_paclist3.name"
                                maxlength="3" show-word-limit></el-input>
                            <div class="label">开启配置参数</div>
                            <el-input type="text" placeholder="请输入场景配置参数，例如：paclist3=49;48;48;48;48;48"
                                v-model="scene_paclist3.open_value"></el-input>
                            <div class="label">关闭配置参数</div>
                            <el-input type="text" placeholder="请输入场景配置参数，例如：paclist3=49;48;48;48;48;48"
                                v-model="scene_paclist3.close_value"></el-input>
                        </div>
                        <div>
                            <div class="label">默认设置</div>
                            <el-radio v-model="scene_paclist3.default_status" :label="1">开启</el-radio>
                            <el-radio v-model="scene_paclist3.default_status" :label="-1">关闭</el-radio>
                        </div>
                    </div>
                    <div class="el-row">
                        <label class="col-md-1 ctr-label-left">场景4</label>
                        <el-radio v-model="scene_paclist4.status" :label="1">开启</el-radio>
                        <el-radio v-model="scene_paclist4.status" :label="-1">关闭<span
                                class="red-tip">（关闭后，则该灯光按键不在点歌页面显示）</span></el-radio>
                    </div>
                    <div class="gray-block" v-if="scene_paclist4.status == '1'">
                        <div>
                            <div class="label">场景</div>
                            <el-input class="small" type="text" placeholder="场景名称" v-model="scene_paclist4.name"
                                maxlength="3" show-word-limit></el-input>
                            <div class="label">开启配置参数</div>
                            <el-input type="text" placeholder="请输入场景配置参数，例如：paclist4=48;48;48;49;48;48"
                                v-model="scene_paclist4.open_value"></el-input>
                            <div class="label">关闭配置参数</div>
                            <el-input type="text" placeholder="请输入场景配置参数，例如：paclist4=48;48;48;49;48;48"
                                v-model="scene_paclist4.close_value"></el-input>
                        </div>
                        <div>
                            <div class="label">默认设置</div>
                            <el-radio v-model="scene_paclist4.default_status" :label="1">开启</el-radio>
                            <el-radio v-model="scene_paclist4.default_status" :label="-1">关闭</el-radio>
                        </div>
                    </div>
                    <div class="el-row">
                        <label class="col-md-1 ctr-label-left">场景5</label>
                        <el-radio v-model="scene_paclist5.status" :label="1">开启</el-radio>
                        <el-radio v-model="scene_paclist5.status" :label="-1">关闭<span
                                class="red-tip">（关闭后，则该灯光按键不在点歌页面显示）</span></el-radio>
                    </div>
                    <div class="gray-block" v-if="scene_paclist5.status == '1'">
                        <div>
                            <div class="label">场景</div>
                            <el-input class="small" type="text" placeholder="场景名称" v-model="scene_paclist5.name"
                                maxlength="3" show-word-limit></el-input>
                            <div class="label">开启配置参数</div>
                            <el-input type="text" placeholder="请输入场景配置参数，例如：paclist4=48;48;48;49;48;48"
                                v-model="scene_paclist5.open_value"></el-input>
                            <div class="label">关闭配置参数</div>
                            <el-input type="text" placeholder="请输入场景配置参数，例如：paclist4=48;48;48;49;48;48"
                                v-model="scene_paclist5.close_value"></el-input>
                        </div>
                        <div>
                            <div class="label">默认设置</div>
                            <el-radio v-model="scene_paclist5.default_status" :label="1">开启</el-radio>
                            <el-radio v-model="scene_paclist5.default_status" :label="-1">关闭</el-radio>
                        </div>
                    </div>
                    <div class="el-row">
                        <label class="col-md-1 ctr-label-left">场景6</label>
                        <el-radio v-model="scene_paclist6.status" :label="1">开启</el-radio>
                        <el-radio v-model="scene_paclist6.status" :label="-1">关闭<span
                                class="red-tip">（关闭后，则该灯光按键不在点歌页面显示）</span></el-radio>
                    </div>
                    <div class="gray-block" v-if="scene_paclist6.status == '1'">
                        <div>
                            <div class="label">场景</div>
                            <el-input class="small" type="text" placeholder="场景名称" v-model="scene_paclist6.name"
                                maxlength="3" show-word-limit></el-input>
                            <div class="label">开启配置参数</div>
                            <el-input type="text" placeholder="请输入场景配置参数，例如：paclist4=48;48;48;49;48;48"
                                v-model="scene_paclist6.open_value"></el-input>
                            <div class="label">关闭配置参数</div>
                            <el-input type="text" placeholder="请输入场景配置参数，例如：paclist4=48;48;48;49;48;48"
                                v-model="scene_paclist6.close_value"></el-input>
                        </div>
                        <div>
                            <div class="label">默认设置</div>
                            <el-radio v-model="scene_paclist6.default_status" :label="1">开启</el-radio>
                            <el-radio v-model="scene_paclist6.default_status" :label="-1">关闭</el-radio>
                        </div>
                    </div>
                    <div class="gray-block" v-show="other_scene_room.length > 0">
                        <div class="block-title">
                            资料同步<span class="red-tip">（勾选同步的包厢后，对应的包厢也会同步修改）</span>
                            <div class="other-room-wrapper">
                                <el-checkbox v-model="sceneSyncAllOtherRoom"
                                    @change="handleSceneSyncAllOtherRoomChange">全选</el-checkbox>
                                <el-checkbox-group v-model="choosed_other_scene_room"
                                    @change="handleSceneSyncOtherRoomChange">
                                    <el-checkbox v-for="item in other_scene_room" :key="item.id" :label="item.id">{{
                                        item.room_name
                                        }}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 30px;">
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray"
                            @click="rtnFun('6')">返回</button>
                        <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;"
                            @click="sceneSave(addSceneModify)">保存</button>
                    </div>
                </div>
                <!-- 适用包厢面板 -->
                <div class="rooms-panel" v-show="s_showbox">
                    <h3>选择适用包厢</h3>
                    <div class="room-wrapper">
                        <div class="block-title">
                            <el-checkbox v-model="sceneCheckAllRoom"
                                @change="handleSceneCheckAllRoomChange">全选</el-checkbox>
                        </div>
                        <div class="block" v-for="(item, pindex) in s_room_checkboxdata">
                            <div class="block-title">
                                <el-checkbox @change="checked => handleSceneCheckArea(checked, pindex)"
                                    v-model="item.checked">{{
                                        item.room_area_name }}</el-checkbox>
                            </div>
                            <el-checkbox-group class="rooms" v-model="choosedSceneRoom">
                                <el-checkbox class="room" v-for="(room, cindex) in item.room" :label="room.id"
                                    :key="room.id" @change="checked => handleSceneCheckRoom(checked, pindex, cindex)">{{
                                        room.name }}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                    <el-button @click="s_roomboxbackFun">返回</el-button>
                    <el-button type="primary" @click="commitSceneRoomChoose">确认</el-button>
                </div>
            </div>

            <!-- 广告机设置 -->
            <div class="ad-set-panel" v-show="listShow19">
                <div class="ad-set-list" v-show="ad_set_list_show">
                    <h1 class="title">广告机设置</h1>
                    <p class="p-hint">注：广告机功能仅支持竖屏应用。2 需操作““开启”后，包厢广告机才可配置使用</p>
                    <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)" :header-cell-style="{ 'text-align': 'center' }"
                        :cell-style="{ 'text-align': 'center' }" :data="ad_set_table">
                        <el-table-column prop="shop_name" label="门店"></el-table-column>
                        <el-table-column prop="ad_machine_status" label="状态">
                            <template slot-scope="scope">
                                <el-select @change="adSetStatusChange(scope.row)" size="mini"
                                    v-model="scope.row.ad_machine" placeholder="请选择">
                                    <el-option label="开启" value="1"></el-option>
                                    <el-option label="关闭" value="-1"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" @click="adSetTouchScreen(scope.row)">触摸屏显示内容设置</el-button>
                                <el-button type="text" @click="adSetTvScreen(scope.row)">TV屏显示内容设置</el-button>
                                <el-button type="text" @click="adSetSync(scope.row)">同步</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="total, prev, pager, next, jumper" :page-size="GLOBAL.PAGESIZE"
                        :current-page.sync="ad_set_page" :total="ad_set_total" @current-change="getAdSetList">
                    </el-pagination>
                    <el-button @click="backFun">返回</el-button>
                </div>
                <div class="ad-touch-screen-list" v-show="ad_set_touch_list_show">
                    <div class="title-img">
                        <div class="title-img-left">触摸屏显示内容设置</div>
                        <img @click="previewTouchScreenImage" class="title-img-right"
                            src="../../assets/images/rmark.png" mode="aspectFit|aspectFill|widthFix" lazy-load="false"
                            binderror="" bindload="">
                    </div>
                    <div class="shop-name-ad-set">门店：{{ ad_set_touch_list_shop_name }}</div>
                    <el-form :inline="true">
                        <el-form-item label="状态">
                            <el-select @change="getAdSetTouchScreenList" v-model="ad_set_touch_list_status"
                                placeholder="请输入触摸屏显示内容">
                                <el-option label="全部" value="0"></el-option>
                                <el-option label="启用" value="1"></el-option>
                                <el-option label="禁用" value="-1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="add_ad_set">新增营销位</el-button>
                            <el-button type="primary" @click="bgSet">背景图设置</el-button>
                            <el-button type="primary" @click="screensaverSet">屏保设置</el-button>
                        </el-form-item>
                    </el-form>
                    <el-table :data="ad_set_touch_list_table" v-loading="loading" element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)" :header-cell-style="{ 'text-align': 'center' }"
                        :cell-style="{ 'text-align': 'center' }">
                        <el-table-column prop="listorder" label="排序"></el-table-column>
                        <el-table-column prop="title" label="营销位名称"></el-table-column>
                        <el-table-column prop="type_desc" label="营销位样式"></el-table-column>
                        <el-table-column prop="status_desc" label="状态"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" @click="adSetTouchScreenStatus(scope.row)">{{ scope.row.status ==
                                    1 ? '禁用' : '启用' }}</el-button>
                                <el-button type="text" @click="adSetTouchScreenEdit(scope.row)">修改</el-button>
                                <el-button type="text" @click="adSetTouchScreenDelete(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-button @click="adSetTouchScreenBack">返回</el-button>
                    <!-- 背景图设置 -->
                    <div class="bg-set-form" ref="bg_set_form">
                        <el-form :model="bg_set_form" label-width="120px">
                            <el-form-item label="营销位起始高度">
                                <el-input v-model="bg_set_form.ad_machine_px" placeholder="请输入营销位起始高度"></el-input>
                            </el-form-item>
                            <el-form-item label="触摸屏背景图">
                                <p class="tip">分辨率1080*1920，图片大小不超过2M</p>
                                <img src="../../assets/images/upload_btn.png" alt="" id="ad_machine_img_up"
                                    v-if="bg_set_form.ad_machine_img == ''">
                                <img :src="bg_set_form.ad_machine_img" alt="" style="max-width: 200px;"
                                    id="ad_machine_img_up" v-else>
                                <div class="txt" v-if="bg_set_form.ad_machine_img == ''">点击上传图片</div>
                                <img src="../../assets/images/vod_del.png" alt="" class="del-icon"
                                    v-if="bg_set_form.ad_machine_img != ''" @click.stop="delAdMachineImg()">
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <!-- 新增/修改营销位 -->
                <div class="ad-touch-screen-list" v-show="new_edit_ad_show">
                    <h1>{{ isEdit_ad_touch ? '修改' : '新增' }}营销位</h1>
                    <el-form :model="new_edit_ad_form" label-width="120px">
                        <el-form-item label="排序">
                            <el-input style="width: 200px;" v-model="new_edit_ad_form.listorder"
                                placeholder="请输入排序"></el-input>
                        </el-form-item>
                        <el-form-item label="营销位名称">
                            <el-input style="width: 200px;" v-model="new_edit_ad_form.title"
                                placeholder="请输入营销位名称"></el-input>
                        </el-form-item>
                        <el-form-item label="营销位样式">
                            <el-select v-model="new_edit_ad_form.type" @change="changeType" placeholder="请选择营销位样式">
                                <el-option label="一张长图" :value="1"></el-option>
                                <el-option label="两张大图" :value="2"></el-option>
                                <el-option label="三张图" :value="3"></el-option>
                                <el-option label="多图轮播" :value="4"></el-option>
                                <el-option label="单图轮播" :value="5"></el-option>
                            </el-select>
                        </el-form-item>
                        <div class="block-item" v-for="(item, index) in new_edit_ad_form.content">
                            <p>图{{ index + 1 }}</p>
                            <img class="delete-icon" src="../../assets/images/scrn_del.png"
                                v-if="new_edit_ad_form.type == 4 && new_edit_ad_form.content.length > 1 && index == new_edit_ad_form.content.length - 1"
                                @click="deleteThisImg(index)" />
                            <el-form-item label="广告封面" required>
                                <span>{{ new_edit_ad_form.type == 1 ? '图片比例长1020*宽140，大小不超过2m' : '图片比例1920*1080，大小不超过2M'
                                }}</span>
                                <div class="img-wrapper" :class="{ 'big-img': new_edit_ad_form.type == 1 }"
                                    v-if="item.img == ''" :id="'faceImg' + index">
                                    <img src="../../assets/images/icon_add.png" alt="" class="add-icon">
                                    <div class="add-txt">点击上传图片</div>
                                </div>
                                <div class="img-wrapper" :class="{ 'big-img': new_edit_ad_form.type == 1 }" v-else
                                    :id="'faceImg' + index">
                                    <img :src="item.img" alt="" class="ad-img">
                                </div>
                            </el-form-item>
                            <el-form-item label="广告详情样式" required>
                                <el-radio v-model="item.content_type" label="1"
                                    @change="(val) => contentTypeChange(val, index)">无</el-radio>
                                <el-radio v-model="item.content_type" label="2"
                                    @change="(val) => contentTypeChange(val, index)">图片</el-radio>
                                <div class="red-tip">{{ item.content_type == '1' ? '点击广告封面无任何响应' : item.content_type ==
                                    '2'
                                    ? '点击广告封面后，则进入广告详情页，并显示上传的图片' : '' }}</div>
                            </el-form-item>
                            <el-form-item label="广告详情页内容" v-if="item.content_type == '2'">
                                <span>{{ '图片比例1080*1920，大小不超过2M' }}</span>
                                <div class="img-wrapper normal-img" v-if="item.content_url == ''"
                                    :id="'contentImg' + index">
                                    <img src="../../assets/images/icon_add.png" alt="" class="add-icon">
                                    <div class="add-txt">点击上传图片</div>
                                </div>
                                <div class="img-wrapper normal-img" v-else :id="'contentImg' + index">
                                    <img :src="item.content_url" alt="" class="content-img">
                                </div>
                            </el-form-item>
                        </div>
                        <el-form-item v-if="new_edit_ad_form.type == 4">
                            <el-button type="primary" @click="addImg">新增图片</el-button>
                        </el-form-item>
                    </el-form>
                    <el-button @click="newEditAdBack">返回</el-button>
                    <el-button type="primary" @click="newEditAdConfirm">确认</el-button>
                </div>
                <!-- 屏保设置 -->
                <div class="ad-touch-screen-list" v-show="screensaver_set_show">
                    <h1>屏保设置</h1>
                    <p class="p-hint">注：屏保是在包厢触摸屏无人操作180s后轮播图片。【图片规范：尺寸1080*1920】，图片格式均为png，如您上传图片不符规范，将不能显示或被压缩</p>
                    <div class="img-wrappers">
                        <div class="img-wrapper" v-for="(item, index) in screensaver_set_imgs" :key="index">
                            <img :src="item" alt="" class="ad-img">
                            <div class="delete-btn" @click="deleteScreensaverImage(index)">×</div>
                        </div>
                        <div class="img-wrapper" v-if="screensaver_set_imgs.length < 10"
                            id="screensaver_img_uploader_btn">
                            <div class="upload-placeholder">
                                <div class="upload-icon">+</div>
                                <div class="upload-text">上传图片</div>
                            </div>
                        </div>
                    </div>
                    <el-button @click="screensaverSetBack">返回</el-button>
                    <el-button type="primary" @click="screensaverSetSave">保存</el-button>
                </div>

                <!-- TV屏显示内容设置 -->
                <div class="ad-tv-screen" v-show="ad_set_tv_show">
                    <div class="title-img">
                        <div class="title-img-left">TV屏显示内容设置</div>
                        <img @click="previewTvScreenImage" class="title-img-right" src="../../assets/images/rmark.png"
                            mode="aspectFit|aspectFill|widthFix" lazy-load="false" binderror="" bindload="">
                    </div>
                    <div class="shop-name-ad-set">门店：{{ ad_set_tv_list_shop_name }}</div>
                    <div class="ad-tv-screen-form">
                        <el-form :model="tv_form" label-width="120px">
                            <el-form-item label="内容显示类型">
                                <el-radio v-model="tv_form.type" label="1" @change="changeTvType">图片轮播</el-radio>
                                <el-radio v-model="tv_form.type" label="2" @change="changeTvType">视频播放</el-radio>
                            </el-form-item>
                            <div v-if="tv_form.type == '1'">
                                <el-form-item label="轮播间隔">
                                    <el-input v-model="tv_form.interval" style="width: 200px;" placeholder="请输入轮播间隔">
                                        <template slot="append">秒</template>
                                    </el-input>
                                    <span class="tip-right">注:多张图片时每个图片切换的时间间隔</span>
                                </el-form-item>
                                <el-form-item :label="'图片' + '( ' + tv_form.content.length + '/ 10 )'">
                                    <span class="tip-right">注：图片比例1080*1920，大小不超过2M</span>
                                </el-form-item>
                                <div class="img-wrappers">
                                    <div class="img-wrapper" v-for="(item, index) in tv_form.content" :key="index">
                                        <img :src="item" alt="" class="ad-img">
                                        <div class="delete-btn" @click="deleteTvImage(index)">×</div>
                                    </div>
                                    <div class="img-wrapper" v-if="tv_form.content.length < 10"
                                        id="tv_img_uploader_btn">
                                        <div class="upload-placeholder">
                                            <div class="upload-icon">+</div>
                                            <div class="upload-text">上传图片</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="tv_form.type == '2'">
                                <el-form-item label="视频链接">
                                    <el-input v-model="tv_form.content" disabled style="width: 300px;"
                                        placeholder="请上传视频内容"></el-input>
                                    <el-button type="primary" id="tv_video_uploader_btn">上传视频</el-button>
                                </el-form-item>
                            </div>
                        </el-form>

                    </div>
                    <el-button @click="adSetTvScreenBack">返回</el-button>
                    <el-button type="primary" @click="saveTv">确认</el-button>
                </div>

                <!-- 同步弹窗 -->
                <div class="sync-pop ele-hide" ref="ad_set_sync_pop">
                    <div class="sync-content">
                        <div class="sync-title">将【{{ current_sync_shop_name }}】广告机设置所有数据同步到其他门店!</div>
                        <div class="sync-subtitle">请选择需要同步数据的门店</div>
                        <div class="shop-list">
                            <div class="shop-item">
                                <el-checkbox v-model="selectAll_adSet" @change="handleSelectAll_adSet">全选</el-checkbox>
                            </div>
                            <div class="shop-grid">
                                <div class="shop-item" v-for="shop in ad_set_shop_list" :key="shop.id"
                                    v-if="shop.id != current_sync_shop_id">
                                    <el-checkbox v-model="selectedShops_adSet" :label="shop.id">{{ shop.name
                                        }}</el-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="sync-buttons">
                            <el-button @click="cancelSync_adSet">取消</el-button>
                            <el-button type="primary" @click="confirmSync_adSet">确认</el-button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 智能控制器配置 -->
            <div class="smart-control-panel" v-show="listShow20">
                <div class="smart-control-list" v-show="showSmartControlSetListPanel">
                    <h1 class="title">智能控制器配置</h1>
                    <el-button @click="backFun">返回</el-button>
                    <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)" :header-cell-style="{ 'text-align': 'center' }"
                        :cell-style="{ 'text-align': 'center' }" :data="new_control_shop_list">
                        <el-table-column prop="shop_name" label="门店"></el-table-column>
                        <el-table-column label="智能控制器配置">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.intelligent_control"
                                    @change="changeIntelligentControl(scope.row)" placeholder="请选择智能控制器配置">
                                    <el-option label="开启" value="1"></el-option>
                                    <el-option label="关闭" value="-1"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="goSmartControlDeviceSet(scope.row)">设备管理</span>
                                <span class="text-blue" @click="goSmartControlSequencerSet(scope.row)">时序器管理</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination @current-change="getNewSmartControlShopList" background
                        layout="total, prev, pager, next, jumper" :page-size="GLOBAL.PAGESIZE"
                        :current-page.sync="new_control_shop_page" :total="new_control_shop_total"></el-pagination>
                </div>
                <!-- 设备管理 -->
                <div class="smart-control-device-set" v-show="showSmartControlDeviceSetPanel">
                    <h1 class="title">智能控制器管理</h1>
                    <el-button @click="backToSequencerList">返回</el-button>
                    <div class="module-title" style="margin-top: 20px;">设备管理</div>
                    <div class="gray-block">
                        <div class="block-title">智能控制器电源线路管理</div>
                        <div class="line" v-for="(item, index) in new_control_device_data.line_data">
                            <div class="line-name">线路{{ index + 1 }}</div>
                            <el-input v-model="item.name" placeholder="请输入线路名称" clearable @blur="newEditLineName">
                            </el-input>
                        </div>
                        <div class="block-title have-top-line">易微联设备线路管理</div>
                        <div class="line" v-for="(item, index) in new_control_device_data.breaker_data">
                            <div class="line-name">线路{{ index + 1 }}</div>
                            <el-input v-model="item.name" placeholder="请输入线路名称" clearable @blur="newEditBreakerName">
                            </el-input>
                        </div>
                        <hr>
                        </hr>
                        <div class="block-title have-top-line" v-show="this.activePowerControlTab == 1">
                            时序器设备管理
                            <el-button type="primary" size="mini" @click="addSequencerDevice">新增设备</el-button>
                        </div>
                        <div class="sequencer-device-list" v-show="this.activePowerControlTab == 1">
                            <div class="device-item" v-for="device in new_control_device_data.device_data"
                                :key="device.id">
                                <span class="device-name">{{ device.name }}</span>
                                <el-button type="danger" size="mini" icon="el-icon-delete" circle
                                    @click="deleteSequencerDevice(device.id)">
                                </el-button>
                            </div>
                        </div>

                    </div>
                    <div>
                        <!-- 电源控制配置 -->
                        <div class="power-control-tabs">
                            <el-tabs v-model="activePowerControlTab" @tab-click="handlePowerControlTabClick">
                                <el-tab-pane v-for="item in power_control_config" :key="item.id"
                                    :label="'运营场景-' + item.operational_scene_name" :name="item.id">
                                    <div class="power-control-content">
                                        <!-- 这里可以放置每个tab的具体内容 -->
                                        <div class="block-title have-top-line">电源控制配置</div>
                                        <div class="control-block"
                                            v-for="(item, index) in select_power_control.power_control"
                                            :key="item.type">
                                            <div class="block-title">{{ item.name }}<el-button type="primary"
                                                    @click="onAddControlClick3(item)">新增控制</el-button></div>
                                            <el-table :header-cell-style="{ 'text-align': 'center' }"
                                                :cell-style="{ 'text-align': 'center' }" :data="item.action">
                                                <el-table-column prop="control_type_name"
                                                    label="控制类型"></el-table-column>
                                                <el-table-column prop="notify_name" label="通知方式"></el-table-column>
                                                <el-table-column prop="control_content" label="控制详情"></el-table-column>
                                                <el-table-column label="操作">
                                                    <template slot-scope="scope">
                                                        <span class="text-blue"
                                                            @click="openEditControlPop3(scope.row)">修改</span>
                                                        <span class="text-blue"
                                                            @click="delControl3(scope.row)">删除</span>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                        <!-- 控制弹窗 -->
                        <div class="control-pop ele-hide" ref="control_pop3">
                            <el-form label-width="90px">
                                <el-form-item label="控制类型">
                                    <el-select v-model="control_form.control_type" placeholder="请选择控制类型"
                                        popper-class="high-index" @change="onControlTypeChange3">
                                        <el-option v-for="item in control_device_type_arr" :key="item.control_type"
                                            :label="item.control_type_name" :value="item.control_type">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="控制详情" v-if="control_form.control_type != '5'">
                                    <el-select v-model="control_form.action" placeholder="请选择控制详情"
                                        v-if="control_form.control_type != '4'" :disabled="!control_form.control_type">
                                        <el-option v-for="item in CurrentDeviceActions" :key="item.id"
                                            :label="item.name" :value="item.id">
                                        </el-option>
                                    </el-select>
                                    <!-- 通通锁 -->
                                    <el-radio-group v-model="control_form.action_info"
                                        v-if="CurrentDeviceActionInfos.length > 0 && control_form.control_type == '4'">
                                        <el-radio :label="item.id" v-for="item in CurrentDeviceActionInfos"
                                            :key="item.id">{{
                                                item.name }}</el-radio>
                                    </el-radio-group>
                                </el-form-item>

                                <el-form-item label="通知方式" v-if="control_form.control_type == '2'">
                                    <el-radio-group v-model="control_form.notify_type" @change="onNotifyTypeChange">
                                        <el-radio label="1">包厢机</el-radio>
                                        <el-radio label="2">云端通知</el-radio>
                                        <el-popover placement="top-start" title="说明" width="400" trigger="hover"
                                            content="当包厢机未启动时需要优先开启的，可以使用云端通知方式。">
                                            <img src="../../assets/images/rmark.png" alt=""
                                                style="width: 32px; height: 32px;" slot="reference">
                                        </el-popover>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="通断电方式"
                                    v-if="control_form.control_type == '2' && control_form.notify_type != '2'">
                                    <el-select v-model="control_form.box_notify_config.power_mode"
                                        placeholder="请选择通电方式"
                                        popper-class="high-index"
                                        @change="onPowerModeChange">
                                        <el-option v-for="item in CurrentDeviceBoxPowerModeConfig" :key="item.id"
                                            :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label=""
                                    v-if="control_form.control_type == '2' && control_form.notify_type != '2' && control_form.box_notify_config.power_mode == '2'">
                                    <el-radio-group v-model="control_form.box_notify_config.cycle_mode" @change="onCycleModeChange">
                                        <el-radio v-for="item in CurrentDeviceBoxCycleModeConfig" :key="item.id"
                                            :label="item.id">{{
                                                item.name }}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item
                                    v-if="control_form.control_type == '2' && control_form.notify_type != '2' && control_form.box_notify_config.power_mode == '2' && control_form.box_notify_config.cycle_mode == '1'">
                                    <div style="margin-bottom: 10px; display: flex; align-items: center; gap: 10px;">
                                        每次上电<el-input v-model="control_form.box_notify_config.power_duration"
                                            style="width: 100px;"></el-input>秒后断电
                                    </div>
                                </el-form-item>
                                <el-form-item
                                    v-if="control_form.control_type == '2' && control_form.notify_type != '2' && control_form.box_notify_config.power_mode == '2' && control_form.box_notify_config.cycle_mode == '2'">
                                    <div style="margin-bottom: 10px; display: flex; align-items: center; gap: 10px;">
                                        每次上电<el-input v-model="control_form.box_notify_config.power_duration"
                                            style="width: 10ch;"></el-input>秒后断电
                                    </div>
                                    <div style="display: flex; align-items: center; gap: 10px;">
                                        间隔<el-input v-model="control_form.box_notify_config.interval_duration"
                                            style="width: 100px;"></el-input>秒上电一次
                                    </div>
                                </el-form-item>
                                <el-form-item label=" "
                                    v-if="control_form.control_type != '4' && control_form.box_notify_config.power_mode != 2">
                                    <el-radio-group v-model="control_form.action_info"
                                        v-if="CurrentDeviceActionInfos.length > 0">
                                        <el-radio :label="item.id" v-for="item in CurrentDeviceActionInfos"
                                            :key="item.id">{{
                                                item.name }}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>

                <!-- 时序器管理 -->
                <div class="smart-control-sequencer-set" v-show="showSmartControlSequencerSetPanel">
                    <h1 class="title">时序器管理</h1>
                    <div class="sequencer-select">
                        <div>默认时序器类型</div>
                        <el-radio-group v-model="sequencer_data.type">
                            <el-radio label="1">8路时序器(485)</el-radio>
                            <el-radio label="2">12路时序器</el-radio>
                        </el-radio-group>
                    </div>

                    <!-- 8路时序器线路配置 -->
                    <div class="sequencer-config">
                        <h3>8路时序器线路配置</h3>
                        <div class="config-list">
                            <div v-for="item in sequencer_data.config" :key="item.id" class="config-item">
                                <div class="line-label">{{ item.line }}</div>
                                <div class="name-input">
                                    <el-input v-model="item.name" placeholder="请输入名称" size="small">
                                    </el-input>
                                </div>
                                <div class="device-label">接入设备</div>
                                <div class="device-select">
                                    <el-select v-model="item.device" placeholder="请选择设备" size="small">
                                        <el-option v-for="device in device_arr" :key="device.id" :label="device.name"
                                            :value="device.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 12路时序器线路配置 -->
                    <div class="sequencer-config">
                        <h3>12路时序器线路配置</h3>
                        <div class="config-list">
                            <div v-for="item in sequencer_data.second_config" :key="item.id" class="config-item">
                                <div class="line-label">{{ item.line }}</div>
                                <div class="name-input">
                                    <el-input v-model="item.name" placeholder="请输入名称" size="small">
                                    </el-input>
                                </div>
                                <div class="device-label">接入设备</div>
                                <div class="device-select">
                                    <el-select v-model="item.device" placeholder="请选择设备" size="small">
                                        <el-option v-for="device in device_arr" :key="device.id" :label="device.name"
                                            :value="device.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="sequencer-actions">
                        <el-button type="primary" @click="saveSequencerConfig">保存配置</el-button>
                        <el-button @click="backToSequencerList">返回</el-button>
                    </div>
                </div>

            </div>


            <!--V2.0三合一调音库效果管理  -->
            <div class="smart-control-panel" v-show="listShow21">
                <div v-show="!showEditEffectPanel">
                    <el-form :inline="true">
                        <el-form-item label="门店">
                            <el-select v-model="effect_manage_form.shop_id" filterable placeholder="请选择门店"
                                @change="onFileManageShopChange">
                                <el-option v-for="item in file_manage_shop_list" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="包厢号">
                            <el-select v-model="effect_manage_form.room_id" filterable clearable placeholder="请输入包厢号">
                                <el-option v-for="item in file_manage_room_list" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="设备型号">
                            <el-select v-model="effect_manage_form.tool_id" filterable clearable placeholder="请选择设备型号">
                                <el-option label="全部" value=""></el-option>
                                <el-option v-for="item in device_list" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="效果名称">
                            <el-input v-model="effect_manage_form.effect_name" clearable
                                placeholder="请输入效果名称"></el-input>
                        </el-form-item>
                        <el-form-item label="商家调音库效果">
                            <el-select v-model="effect_manage_form.is_merchant" filterable clearable
                                placeholder="请选择商家调音库效果">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="是" value="1"></el-option>
                                <el-option label="否" value="-1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-button type="primary" @click="getEffectTable(1)">查询</el-button>
                        <el-button @click="backFun">返回</el-button>
                    </el-form>
                    <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)" :header-cell-style="{ 'text-align': 'center' }"
                        :cell-style="{ 'text-align': 'center' }" :data="effect_table_data">
                        <el-table-column prop="room_name" label="包厢号"></el-table-column>
                        <el-table-column prop="tool_name" label="设备型号"></el-table-column>
                        <el-table-column prop="effect_name" label="效果名称"></el-table-column>
                        <el-table-column prop="effect_describe" label="效果描述"></el-table-column>
                        <el-table-column prop="create_time" label="备份时间"></el-table-column>
                        <el-table-column prop="is_merchant_desc" label="是否设置为商家调音库效果"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="editEffect(scope.row)">修改</span>
                                <span class="text-blue" @click="deleteEffect(scope.row)">删除</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="total, prev, pager, next, jumper"
                        :page-size="effect_manage_form.page_size" :current-page.sync="effect_manage_form.page"
                        :total="effect_manage_form.total" @current-change="getEffectTable">
                    </el-pagination>
                </div>
                <div class="add-file-panel" v-show="showEditEffectPanel">
                    <h3>修改效果</h3>
                    <el-form label-width="180px">
                        <el-form-item label="包厢号">
                            <el-input v-model="edit_effect_form.room_name" disabled style="width: 300px;"></el-input>
                        </el-form-item>
                        <el-form-item label="设备型号">
                            <el-input v-model="edit_effect_form.tool_name" disabled style="width: 300px;"></el-input>
                        </el-form-item>
                        <el-form-item label="效果名称" required>
                            <el-input v-model="edit_effect_form.effect_name" placeholder="请输入效果名称" clearable
                                style="width: 300px;"></el-input>
                        </el-form-item>
                        <el-form-item label="效果描述">
                            <el-input type="textarea" v-model="edit_effect_form.effect_describe" placeholder="请输入效果描述"
                                clearable style="width: 300px;"></el-input>
                        </el-form-item>
                        <el-form-item label="是否设置为商家调音库效果">
                            <el-select v-model="edit_effect_form.is_merchant" filterable clearable
                                placeholder="请选择是否设置为商家调音库效果">
                                <el-option label="是" value="1"></el-option>
                                <el-option label="否" value="-1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-button @click="showEditEffectPanel = false">返回</el-button>
                        <el-button type="primary" @click="commitEditEffect">确认</el-button>
                    </el-form>
                </div>
            </div>

        </div>
    </div>



</template>

<script>
import Vue from 'vue';
import touch_screen_img from '../../assets/images/touch_screen.png'
import tv_screen_img from '../../assets/images/tv_screen.png'
export default {
    name: 'order-list',
    data() {
        return {
            loading: false,
            titShow: true,
            listShow1: false,
            listShow2: false,
            listShow3: false,
            listShow4: false,
            listShow5: false,
            listShow6: false,
            listShow7: false,
            listShow8: false,
            listShow9: false,
            listShow10: false,
            listShow11: false,
            listShow12: false,
            listShow13: false,
            listShow14: false,
            listShow15: false,
            listShow16: false,
            listShow17: false,
            listShow18: false,
            listShow19: false,
            listShow20: false,
            listShow21: false,



            // 大厅公视配置
            showSet: false,
            visible: true,
            addModify: 1,
            dtShop: [],
            add_header: '新增大厅公视配置',
            vod_set_cnfrt: '',
            vod_set_cnsnd: '',
            theDetail: {
                type: Object
            },

            // 效果器配置------------
            showXgq: true,
            showXgqSet: false,
            xgqVisible: true,
            addXgqModify: 1,
            xgqShop: [],
            add_xgq_header: '',
            xgq_room_num: '',
            xgq_volup: '',
            xgq_voldown: '',
            xgq_mp_zy: '',
            xgq_mp_bz: '',
            xgq_mp_kg: '',
            xgq_mp_jy: '',
            theXgqDetail: {
                type: Object
            },
            showbox: false,
            room_checkboxdata: [],
            room_checkboxModel: '',
            room_detailcheckboxdata: [],
            objClass: {
                visi_hid: true,
                selection_clear: true
            },

            // 智能灯光配置
            showLamp: true,
            showLampSet: false,
            lampVisible: true,
            addLampModify: 1,
            lampShop: [],
            lamp_shop_id: '',
            add_lamp_header: '新增智能灯光配置',
            lamp_room_num: '',
            lamp_mp_cs: '', // 参数
            paclist1: {
                name: "",//灯光1名称
                status: "1",//灯光1状态 1开启 -1关闭
                value: ""//灯光1的配置
            },
            paclist2: {
                name: "",
                status: "1",
                value: ""
            },
            paclist3: {
                name: "",
                status: "1",
                value: ""
            },
            paclist4: {
                name: "",
                status: "1",
                value: ""
            },
            paclist5: {
                name: "",
                status: "-1",
                value: ""
            },
            paclist6: {
                name: "",
                status: "-1",
                value: ""
            },
            theLampDetail: [],
            l_showbox: false,
            l_room_checkboxdata: [],
            l_room_checkboxModel: [],
            l_objClass: {
                visi_hid: true,
                selection_clear: true
            },
            lampCheckAllRoom: false,
            choosedLampRoom: [],
            lampSyncAllOtherRoom: false,
            other_lamp_room: [],
            choosed_other_lamp_room: [],

            // 开房播放设置
            showRoom: true,
            showRoomSet: false,
            roomVisible: true,
            addRoomModify: 1,
            roomShop: [],
            add_room_header: '开房播放设置',
            room_box_num: '',
            room_all_shops: '1',
            r_showbox: false,
            r_box_allcheck: false,
            r_c_box_allcheck: false,
            r_box_checkboxData: [],
            r_box_detCheckboxData: [],
            r_box_checkboxModel: [],
            r_c_box_checkboxModel: [],
            r_box_allsel: '',
            r_objClass: {
                visi_hid: true,
                selection_clear: true
            },
            room_song_name: '',
            r_song_checkModel: '',
            songData: [],
            room_item_id: '',

            // 开机播放设置
            showWake: true,
            showWakeSet: false,
            wakeVisible: true,
            addWakeModify: 1,
            wakeShop: [],
            add_wake_header: '开机播放设置',
            wake_box_num: '',
            wake_all_shops: '1',
            w_showbox: false,
            w_box_allcheck: false,
            w_c_box_allcheck: false,
            w_box_checkboxData: [],
            w_box_detCheckboxData: [],
            w_box_checkboxModel: [],
            w_c_box_checkboxModel: [],
            w_box_allsel: '',
            w_objClass: {
                visi_hid: true,
                selection_clear: true
            },
            wake_song_name: '',
            w_song_checkModel: '',
            wake_item_id: '',

            // 包厢配置------------
            showBx: true,
            showBxSet: false,
            addBxModify: 1,
            add_bx_header: '新增包厢配置',
            bx_pac: '',
            bx_pac_lists: [],
            bx_rm: '',
            bx_rm_lists: [],
            bx_djp: '',
            bx_djp_lists: [],
            theBxDetail: {
                type: Object
            },
            showBox: false,
            edit_box: '',
            box_all: false,
            c_box_all: false,
            box_item: [],
            c_box_item: [],
            box_floor: [],
            c_box_floor: [],
            box_arr: [],
            box_arr_det: [],
            room_ini_params: '',
            bx_form: {
                shop_id: '',
                room_area: [],
                room_type: [],
                room_name: '',
            },
            bx_shop_list: [],
            room_area_list: [],
            checkAllRoomArea: false,
            room_type_list: [],
            checkAllRoomType: false,
            box_set_list: [],
            box_set_page: 1,
            box_set_page_size: 100,
            box_set_total: 0,
            mult_box_set_form: {
                shop_id: '',
                ids: [],
                pac_setting: [''],
                room_setting: [''],
                dajianpan_setting: [''],
            },
            mult_set_room: [],

            // 息屏背景自定义设置
            showXbzList: true,
            xbz_page: 1,
            xbz_total: 0,
            xbz_table: [],
            xbz_edit_id: '',
            xbz_edit_tit: '',
            unset_shop_list: [],
            xbz_edit_shop_id: '',
            xbz_edit_shop_name: '',
            xbz_edit_img: '',
            xbz_edit_img_done: false,
            xbz_edit_img_uploaders: [],

            // 包厢火警通知设置
            fireShopList: [],
            fire_shop: '',
            fire_table: [],
            fire_page: 1,
            fire_total: 0,
            add_fire_form: {
                id: '',
                shop_id: '',
                room_ids: '',
                room_str: '',
                img_url: '',
            },
            showFireAddPanel: false, // 显示新增配置面板
            showFireBox: false,
            fire_img_uploaders: [],

            // 灯光面板点播设置
            showLightSetPanel: false,
            lightShopList: [], //门店列表
            light_shop: '',
            light_table: [],
            light_edit_form: {
                id: '',
                shop_id: '',
                light: '', // 灯光1-10
                key_name: '',
                tv_mode: '1',  // TV端显示模式，1：全屏，2：壁画，3：画中画
                play_mode: '1', // 歌单播放模式，1：单次+顺序播放，2：单次+随机播放，3：循环+顺序播放，4：循环+随机播放
                songs_code: [], // 歌曲code数组
                songs: [],
            },
            search_song_form: {
                key: 'szSong_name',
                value: ''
            },
            search_song_loading: false,
            search_song_page: 1,
            search_song_total: 0,
            search_song_table: [], // 搜索歌曲列表
            choosed_song_page: 1,
            choosed_song_total: 0,
            choosed_song_table: [],
            choosed_song_table_for_show: [],

            // 购买单曲设置
            showBuySongList: true,
            buy_song_form: {
                shop_id: '',
                room_type: '',
                status: '', // 状态，1：启用，-1：禁用
                name: ''
            },
            buy_song_page: 1,
            buy_song_total: 0,
            buy_song_table: [],
            shop_list: [], // 门店列表
            room_type_list: [], // 包厢类型列表
            add_buy_song: {
                id: "", // 规则id，修改时传
                shop_id: "", // 门店id
                name: "", // 规则名称
                room_type: [], // 适用包厢类型，数组
                price: "", // 原价
                actual_price: "", // 优惠价
                vip_price: "", // 会员价
                start_time: "", // 使用开始时间
                end_time: "", // 使用结束时间
                week_cycle: [], // 有效星期日
                disabled_date: [], // 不可用日期，数组
                enable_date_limit: "", // 适用日期，-1：不限制
                enable_start_time: "", // 适用开始日期，_enable_date_limit=1时生效
                enable_end_time: "", // 适用结束日期，_enable_date_limit=1时生效
                vip_level1_price: "", // 会员等级价格
                vip_level2_price: "",
                vip_level3_price: "",
                vip_level4_price: "",
                vip_level5_price: "",
                vip_level6_price: "",
                vip_level7_price: "",
                vip_level8_price: "",
                vip_level9_price: "",
                vip_level10_price: ""
            },

            room_types_str: '',
            boxtype_all: false,
            c_boxtype_all: false,
            boxtype_item: [],

            use_time_str: '',
            hour_start: '00',
            minute_start: '00',
            hour_end: '00',
            minute_end: '00',

            week_list: [{ id: "1", name: "一" }, { id: "2", name: "二" }, { id: "3", name: "三" }, { id: "4", name: "四" }, { id: "5", name: "五" }, { id: "6", name: "六" }, { id: "0", name: "日" }],
            week_sign: false,
            week_all: false,
            week_ids: [],
            week_str: '',

            disabled_date_str: '',
            enable_date_str: '不限制',

            file_manage_form: {
                shop_id: '',
                room_id: '',
                tool_id: '',
                file_name: '',
            },
            file_manage_shop_list: [],
            file_manage_room_list: [],
            device_list: [],
            file_manage_list: [],
            showAddFilePanel: false,
            add_file_form: {
                id: '',
                room_id: '',
                room_name: '',
                tool_id: '',
                file_name: '',
                file_describe: '',
                structure_id: '', // 房间结构ID
                area_id: '', // 房间面积ID
                speaker_id: '', // 音响型号ID
                file_url_name1: '',
                file_url1: '',
                file_url_name2: '',
                file_url2: '',
                file_url_name3: '',
                file_url3: '',
                file_url_name4: '',
                file_url4: '',
                file_url_name5: '',
                file_url5: '',
                file_url_name6: '',
                file_url6: '',
                file_url_name7: '',
                file_url7: '',
                file_url_name8: '',
                file_url8: '',
                file_url_name9: '',
                file_url9: '',
                file_url_name10: '',
                file_url10: '',
            },
            file_uploaders: [],
            showFileManageRoom: false, // 文件管理包厢配置面板
            file_manage_room_arr: [],
            structure_list: [], // 房间结构列表
            area_list: [], // 房间面积列表
            speaker_list: [], // 音响型号列表

            // 智慧交换机设置
            showSmartMachineSetPanel: false,
            smart_machine_shop_list: [],
            smart_machine_shop_total: 0,
            smart_machine_shop_page: 1,
            shop_id: '',
            shop_name: '',
            line_data: [], // 线路
            switch_control: [], // 电源管理
            control_types: [], // 控制类型
            switch_control_form: {
                id: '',
                shop_id: '',
                type: '',//类型
                control_type: '',//控制类型
                action: '',//控制详情
                action_info: '',//控制详情2
            },
            control_actions: [],
            control_action_info: [],

            // 智慧控制器配置
            showSmartControlSetPanel: false,
            smart_control_shop_list: [],
            smart_control_shop_total: 0,
            smart_control_shop_page: 1,
            breaker_data: [], // 空开线路数据

            // 工作歌单
            work_song_list_form: {
                shop_id: '',
                song_player: '',
                song_name: '',
            },
            work_song_list_page: 1,
            work_song_list_total: 0,
            work_song_list_table: [],
            work_song_pop_key: '',
            work_song_pop_type: '1',
            work_song_pop_loading: false,
            work_song_pop_table: [],
            work_song_pop_total: 0,
            work_song_pop_page: 1,

            // Youtube设置
            youtube_set_table: [],
            youtube_set_page: 1,
            youtube_set_total: 0,
            youtube_key: '', // 密钥

            // 包厢麦克风低电量通知图配置
            mic_low_power_table: [],
            mic_low_power_page: 1,
            mic_low_power_total: 0,
            mic_low_power_shop_list: [],
            mic_low_power_shop: '',
            showMicLowPowerAddPanel: false,
            showMicLowPowerBox: false,
            add_mic_low_power_form: {
                id: '',
                shop_id: '',
                room_str: '',
                img_url: '',
            },
            mic_low_power_img_uploaders: [],

            // 场景灯光配置
            showScene: true,
            showSceneSet: false,
            sceneVisible: true,
            addSceneModify: 1,
            sceneShop: [],
            scene_shop_id: '',
            add_scene_header: '新增场景灯光配置',
            scene_room_num: '',
            // scene_mp_cs: '', 
            scene_paclist1: {
                name: '',
                status: '1',
                open_value: '',
                close_value: '',
                default_status: -1
            },
            scene_paclist2: {
                name: '',
                status: '1',
                open_value: '',
                close_value: '',
                default_status: -1
            },
            scene_paclist3: {
                name: '',
                status: '1',
                open_value: '',
                close_value: '',
                default_status: -1
            },
            scene_paclist4: {
                name: '',
                status: '1',
                open_value: '',
                close_value: '',
                default_status: -1
            },
            scene_paclist5: {
                name: '',
                status: '1',
                open_value: '',
                close_value: '',
                default_status: -1
            },
            scene_paclist6: {
                name: '',
                status: '1',
                open_value: '',
                close_value: '',
                default_status: -1
            },
            theSceneDetail: [],
            s_showbox: false,
            s_room_checkboxdata: [],
            s_room_checkboxModel: [],
            s_objClass: {
                visi_hid: true,
                selection_clear: true
            },
            sceneCheckAllRoom: false,
            choosedSceneRoom: [],
            sceneSyncAllOtherRoom: false,
            other_scene_room: [],
            choosed_other_scene_room: [],

            // 广告机设置
            ad_set_list_show: true,
            ad_set_table: [],
            ad_set_page: 1,
            ad_set_total: 0,

            // 触摸屏显示内容设置
            ad_set_touch_list_show: false,
            ad_set_touch_list_table: [],
            ad_set_touch_list_status: '0',
            ad_set_touch_list_shop_id: '',
            ad_set_touch_list_shop_name: '',
            touch_screen_img,
            tv_screen_img,
            screensaver_set_show: false, // 屏保设置面板显示
            screensaver_set_imgs: [], // 屏保图片列表
            screensaver_img_uploaders: [], // 屏保图片上传器

            // 背景图设置
            bg_set_form: {
                ad_machine_px: '', // 营销位起始高度
                ad_machine_img: '', // 背景图片
            },
            ad_machine_img_uploaders: [],

            // 营销位新增修改
            isEdit_ad_touch: false,
            new_edit_ad_show: false,
            new_edit_ad_form: {
                id: '',
                style: '1', // 固定不变 1：触摸屏，2：tv 
                type: '', // 1 => '一张长图', 2 => '两张大图', 3 => '三张图', 4 => '多图轮播', 5 => '单图轮播'
                shop_id: '',
                title: '',
                listorder: '',
                content: [
                    {
                        img: "",//封面
                        content_type: '1',//详情页内容 1:无 2:图片
                        content_url: ""//详情页内容图片
                    },
                ]
            },
            plupload_list: [],


            ad_set_tv_show: false,
            ad_set_tv_list_shop_name: '',
            ad_set_tv_list_shop_id: '',
            ad_set_shop_list: [],
            ad_set_shop_id: '',
            // 同步相关数据
            selectAll_adSet: false,
            selectedShops_adSet: [],
            current_sync_shop_id: '',
            current_sync_shop_name: '',
            tv_form: {
                id: '',//修改必传
                style: '2',//固定值2 tv屏
                type: '1',//类型 1 => '图片轮播', 2 => '视频播放'
                interval: '',//轮播间隔仅type=1时
                shop_id: '',//门店id
                content: [
                    'https://vodonline.g-hi.com/test-ktv/uploads/system_set/20250716_687707f9a80d2.jpg'
                ]//图片链接
            },
            tv_img_uploader: [],
            tv_video_uploader: [],


            // 智能控制器配置
            new_control_shop_list: [],
            new_control_shop_total: 0,
            new_control_shop_page: 1,
            new_control_shop_id: '',
            new_control_shop_name: '',
            new_control_shop_list_table: [],
            showSmartControlSetListPanel: true,
            showSmartControlDeviceSetPanel: false,
            showSmartControlSequencerSetPanel: false,
            sequencer_data: {
                type: '1',//类型
                config: [],
                second_config: []
            }, // 时序器数据
            current_sequencer_shop_id: '', // 当前时序器管理的门店ID
            device_arr: [], // 设备数据

            new_control_device_data: {
                line_data: [],  //智能控制器电源线路管理
                breaker_data: [],  //易微联设备线路管理
                device_data: [],  //时序设备管理
            },
            sequencer_device_arr: [], // 时序设备数据

            // 控制设备类型数组
            control_device_type_arr: [],
            // 电源控制配置
            power_control_config: [
                {
                    id: "1",
                    operational_scene_name: "KTV",
                    power_control: []
                },
                {
                    id: "2",
                    operational_scene_name: "台球",
                    power_control: []
                },
                {
                    id: "3",
                    operational_scene_name: "棋牌室",
                    power_control: []
                }
            ],
            select_power_control: {},
            activePowerControlTab: "1",
            control_form: {
                shop_id: '',//门店id 
                operational_scene: 1,//运营场景 1:ktv 2:台球 3:棋牌
                type: 1,//电源控制类型 列表返回
                control_type: 1,//控制设备类型 1智能控制器电源 2时序设备 3空开 4通通锁 5新风机
                action: 1,//控制详情线路
                action_info: 1,//控制
                notify_type: 1, // 通知类型 1:包厢机 2:云端通知
                box_notify_config: {//包厢机通知配置
                    power_mode: 2,//通断电方式 1:一次性通断电 2:间歇性通断电
                    cycle_mode: 2,//仅间歇性通断电有意义 循环方式 1:单次 2:循环
                    power_duration: 10,//每次上电x秒断电
                    interval_duration: 120//间隔x秒上电 仅循环cycle_mode=2时有意义
                }
            }, // 新增、修改电源控制配置
            CurrentDeviceActions: [],            // 控制类型
            CurrentDeviceActionInfos: [],        // 控制详情
            CurrentDeviceBoxPowerModeConfig: [], // 通断电方式
            CurrentDeviceBoxCycleModeConfig: [], // 循环方式

            // V2.0三合一调音库效果管理
            effect_manage_form: {
                shop_id: '',
                room_id: '',
                is_merchant: '',
                tool_id: "",
                effect_name: '',
                page: 1,
                page_size: 10,
                total: 0,
            },
            effect_table_data: [],
            showEditEffectPanel: false,
            edit_effect_form: {
                id: '',//修改必传
                tool_name: '',//设备型号
                effect_name: '',//效果名称
                effect_describe: '',//效果描述
                is_merchant: '',//是否设置为商家调音库效果
            }
        }
    },

    watch: {
        xgq_room_num: {

            handler: function (val, oldval) {
                if (val != "") {
                    $(this.$refs.xgq_room_num).parent().find('.selection_clear').show();
                } else {
                    $(this.$refs.xgq_room_num).parent().find('.selection_clear').hide();
                    this.room_checkboxModel = '';
                }
            },
            deep: true
        },
        lamp_room_num: {
            handler: function (val, oldval) {
                if (val != "") {
                    $(this.$refs.lamp_room_num).parent().find('.selection_clear').show();
                } else {
                    $(this.$refs.lamp_room_num).parent().find('.selection_clear').hide();
                    this.l_room_checkboxModel = [];
                }
            },
            deep: true
        },
        scene_room_num: {
            handler: function (val, oldval) {
                if (val != "") {
                    $(this.$refs.scene_room_num).parent().find('.selection_clear').show();
                } else {
                    $(this.$refs.scene_room_num).parent().find('.selection_clear').hide();
                    this.s_room_checkboxModel = [];
                }
            },
            deep: true
        },
        room_box_num: {
            handler: function (val, oldval) {
                if (val != "" && this.addRoomModify == '1') {
                    $(this.$refs.room_box_num).parent().find('.selection_clear').show();
                    $(this.$refs.close_room_box_num).parent().find('.selection_clear').show();
                } else {
                    $(this.$refs.room_box_num).parent().find('.selection_clear').hide();
                    $(this.$refs.close_room_box_num).parent().find('.selection_clear').hide();
                    // this.r_box_checkboxModel = [];
                }
            },
            deep: true
        },
        r_box_checkboxModel: {
            handler: function (val, oldVal) {
                if (this.r_box_checkboxModel.length >= this.r_box_detCheckboxData.length) {
                    this.r_box_allcheck = true;
                    this.r_c_box_allcheck = true;
                } else {
                    this.r_box_allcheck = false;
                    this.r_c_box_allcheck = false;
                }
            },
            deep: true
        },

        wake_box_num: {
            handler: function (val, oldval) {
                console.log(this.addWakeModify);
                if (val != "" && this.addWakeModify == '1') {
                    $(this.$refs.wake_box_num).parent().find('.selection_clear').show();
                } else {
                    $(this.$refs.wake_box_num).parent().find('.selection_clear').hide();
                    this.w_box_checkboxModel = [];
                }
            },
            deep: true
        },
        w_box_checkboxModel: {
            handler: function (val, oldVal) {
                if (this.w_box_checkboxModel.length >= this.w_box_detCheckboxData.length) {
                    this.w_box_allcheck = true;
                    this.w_c_box_allcheck = true;
                } else {
                    this.w_box_allcheck = false;
                    this.w_c_box_allcheck = false;
                }
            },
            deep: true
        },

        edit_box: {
            handler: function (val, oldval) {
                if (val != "" && this.addBxModify == '1') {
                    $(this.$refs.edit_box).parent().find('.selection-clear').show();
                } else {
                    $(this.$refs.edit_box).parent().find('.selection-clear').hide();
                }
            },
            deep: true
        },
        box_item: {
            handler: function (val, oldVal) {
                let _this = this;

                if (_this.box_item.length >= _this.box_arr_det.length) {
                    _this.box_all = true;
                    _this.c_box_all = _this.box_all;
                } else {
                    _this.box_all = false;
                    _this.c_box_all = _this.box_all;
                }

                $.each(_this.box_arr, function (k, v) {
                    if (_this.box_item.length >= v.room.length) {
                        let num = 0;
                        for (let i = 0, len = v.room.length; i < len; i++) {
                            if (_this.box_item.indexOf(v.room[i].id) != -1) {
                                num++;
                            }
                            if (i == v.room.length - 1 && num == v.room.length) {
                                if (_this.box_floor.indexOf(v.room_area) == -1) {
                                    _this.box_floor.push(v.room_area);
                                }
                            } else {
                                let index = '';
                                index = _this.box_floor.indexOf(v.room_area);
                                if (index != -1) {
                                    _this.box_floor.splice(index, 1);
                                }
                            }
                        }
                    } else {
                        let index = '';
                        index = _this.box_floor.indexOf(v.room_area);
                        if (index != -1) {
                            _this.box_floor.splice(index, 1);
                        }
                    }
                });
                _this.c_box_floor = _this.box_floor;
            },
            deep: true
        },

        choosed_song_table: {
            handler: function (val, oldval) {
                let startIndex = (this.choosed_song_page - 1) * this.GLOBAL.PAGESIZE
                let endIndex = this.choosed_song_page * this.GLOBAL.PAGESIZE
                this.choosed_song_table_for_show = val.slice(startIndex, endIndex)
                this.choosed_song_total = val.length
                this.light_edit_form.songs_code = []
                this.light_edit_form.songs = val
                if (val.length > 0) {
                    val.forEach(item => {
                        this.light_edit_form.songs_code.push(item.szSong_code)
                    })
                }
            },
            deep: true
        },
        choosed_song_page: {
            handler: function (val, oldval) {
                let startIndex = (val - 1) * this.GLOBAL.PAGESIZE
                let endIndex = val * this.GLOBAL.PAGESIZE
                this.choosed_song_table_for_show = this.choosed_song_table.slice(startIndex, endIndex)
            },
            deep: true
        },

        boxtype_item: {
            handler: function (val, oldVal) {
                if (this.boxtype_item.length >= this.room_type_list.length) {
                    this.boxtype_all = true;
                    this.c_boxtype_all = this.boxtype_all;
                } else {
                    this.boxtype_all = false;
                    this.c_boxtype_all = this.boxtype_all;
                }
            },
            deep: true
        },
        // 监听选中的门店变化，自动更新全选状态
        selectedShops_adSet: {
            handler(newVal) {
                const otherShops = this.ad_set_shop_list.filter(shop => shop.shop_id != this.current_sync_shop_id);
                this.selectAll_adSet = newVal.length === otherShops.length && otherShops.length > 0;
            },
            deep: true
        },
    },
    computed: {
        light_name_list() {
            let res = []
            for (var i = 1; i <= 10; i++) {
                res.push({
                    id: i + '',
                    name: '灯光' + i
                })
            }
            return res
        },
        business_model() {
            return this.$store.state.business_model
        },

        intelligent_controller_status() {
            console.log(this.$store.state.privinfo)
            return this.$store.state.privinfo.intelligent_controller_status //智能控制器是否开启 1开启 -1关闭
        },

        youtube_status() {
            return this.$store.state.privinfo.youtube_status // youtube是否开启 1开启 -1关闭
        },

        room_area_str() {
            if (this.bx_form.room_area.length == 0) {
                return ''
            } else if (this.bx_form.room_area.length == this.room_area_list.length) {
                return '全部'
            } else {
                let res = []
                this.bx_form.room_area.forEach(v => {
                    this.room_area_list.forEach(item => {
                        if (item.id == v) {
                            res.push(item.name)
                        }
                    })
                })
                return res.join(',')
            }
        },

        room_type_str() {
            if (this.bx_form.room_type.length == 0) {
                return ''
            } else if (this.bx_form.room_type.length == this.room_type_list.length) {
                return '全部'
            } else {
                let res = []
                this.bx_form.room_type.forEach(v => {
                    this.room_type_list.forEach(item => {
                        if (item.id == v) {
                            res.push(item.name)
                        }
                    })
                })
                return res.join(',')
            }
        },

    },
    mounted: function () {
        this.$nextTick(function () {
            // 上传歌曲初始化
            this.uploadNewSong();
            this.uploadNewSongWake();
            this.uploadCloseSong();
        });
        $(this.$refs.lampStatus).select2({
            width: '100%',
            minimumResultsForSearch: -1,
            language: "zh-CN",
        });
        $(this.$refs.sceneStatus).select2({
            width: '100%',
            minimumResultsForSearch: -1,
            language: "zh-CN",
        });
    },
    methods: {
        titClk: function (num) {
            var _this = this;
            _this.titShow = false;
            _this.listShow1 = false;
            _this.listShow2 = false;
            _this.listShow3 = false;
            _this.listShow4 = false;
            _this.listShow5 = false;
            _this.listShow6 = false;
            _this.listShow7 = false;
            _this.listShow8 = false;
            _this.listShow9 = false;
            _this.listShow10 = false;
            _this.listShow11 = false;
            _this.listShow12 = false;
            _this.listShow13 = false;
            _this.listShow14 = false;
            _this.listShow15 = false;
            _this.listShow16 = false;
            _this.listShow17 = false;
            _this.listShow18 = false;
            _this.listShow19 = false;
            if (num == '1') {
                $(_this.$refs.vodList).bootstrapTable('destroy');
                _this.innitTable();
                _this.listShow1 = true;
            } else if (num == '2') {
                $(_this.$refs.xgqList).bootstrapTable('destroy');
                _this.innitXgqTable();
                _this.listShow2 = true;
            } else if (num == '3') {
                $(_this.$refs.lampList).bootstrapTable('destroy');
                // _this.innitLampTable();
                _this.innitLampInput();
                _this.listShow3 = true;
            } else if (num == '4') {
                $(_this.$refs.roomList).bootstrapTable('destroy');
                _this.innitRoomTable();
                _this.listShow4 = true;
            } else if (num == '5') {
                $(_this.$refs.wakeList).bootstrapTable('destroy');
                _this.innitWakeTable();
                _this.listShow5 = true;
            } else if (num == '6') {
                _this.getBxShopData();
                _this.openRmHint();
                _this.listShow6 = true;
            } else if (num == '7') {
                _this.xbzTable(1)
                _this.listShow7 = true
                _this.getUnsetShop()
                _this.xbzUpload()
            } else if (num == '8') {
                _this.getShopList();
                _this.listShow8 = true
                _this.fireImgUpload()
            } else if (num == '9') {
                $(_this.$refs.closeRoomList).bootstrapTable('destroy');
                _this.innitCloseRoomTable();
                _this.listShow9 = true;
            } else if (num == '10') {
                _this.getLightShopList()
                _this.listShow10 = true
            } else if (num == '11') {
                _this.buySongGetShopList()
                _this.listShow11 = true
            } else if (num == '12') {
                _this.listShow12 = true
                _this.fileManageGetShopList()
                _this.getDeviceList()
                _this.initFileUpload() // 初始化上传实例
                _this.getTrinityParam() // 获取下拉框数据
            } else if (num == '13') {
                _this.getSmartMachineShopList(1)
                _this.listShow13 = true
            } else if (num == '14') {
                _this.getSmartControlShopList(1)
                _this.listShow14 = true
            } else if (num == '15') {
                _this.getWorkSongShopList()
                _this.listShow15 = true
            } else if (num == '16') {
                _this.getYoutubeSetList(1)
                _this.listShow16 = true
            } else if (num == '17') {
                _this.getMicLowPowerShopList()
                _this.listShow17 = true
                _this.micLowPowerImgUpload()
            } else if (num == '18') {
                $(_this.$refs.sceneList).bootstrapTable('destroy');
                _this.innitSceneInput();
                _this.listShow18 = true
            } else if (num == '19') {
                _this.listShow19 = true
                _this.getAdSetShopList()
                _this.getAdSetList(1)
            } else if (num == '20') {
                _this.listShow20 = true
                _this.getNewSmartControlShopList(1)
            } else if (num == '21') {
                _this.effect_manage_form = {
                    shop_id: '',
                    room_id: '',
                    is_merchant: '',
                    tool_id: "",
                    effect_name: '',
                    page: 1,
                    page_size: 10,
                    total: 0,
                }
                _this.effect_table_data = []
                _this.listShow21 = true
                _this.showEditEffectPanel = false
                _this.fileManageGetShopList()
                _this.getDeviceList()
            }
        },

        backFun: function () {
            this.titShow = true;
            this.listShow1 = false;
            this.listShow2 = false;
            this.listShow3 = false;
            this.listShow4 = false;
            this.listShow5 = false;
            this.listShow6 = false;
            this.listShow7 = false;
            this.listShow8 = false;
            this.listShow9 = false;
            this.listShow10 = false;
            this.listShow11 = false;
            this.listShow12 = false;
            this.listShow13 = false;
            this.listShow14 = false;
            this.listShow15 = false;
            this.listShow16 = false;
            this.listShow17 = false;
            this.listShow18 = false;
            this.listShow19 = false;
            this.listShow20 = false;
            this.listShow21 = false;
        },
        // 初始化大厅公视配置列表

        innitTable: function () {
            let _this = this;
            $(_this.$refs.vodList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getVodList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "25%"
                }, {
                    field: "chanel1",
                    title: "chanel1",
                    width: "25%"
                }, {
                    field: "chanel2",
                    title: "chanel2",
                    width: "25%"
                }, {
                    title: "操作",
                    events: {
                        'click .modify': function (e, value, row) {
                            _this.getVodDetail(row);
                            _this.addModify = 2;
                            _this.add_header = '修改大厅公视配置';
                            _this.showSet = true;
                            _this.visible = false;
                        },
                        'click .delete': function (e, value, row) {
                            //debugger;
                            layer.confirm('删除后不可恢复，确定删除吗？', {
                                btn: ['确定', '取消'] //按钮
                            }, function () {
                                _this.deleteVod(row.id);
                            });
                        }
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue modify">修改</span>&nbsp;&nbsp;<span class="text-blue delete">删除</span>'
                    }
                }]
            });
        },
        // 获取大厅公视配置列表
        getVodList: function (params) {
            let _self = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getGongShiList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _self);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 点击‘新增大厅公视配置’
        add_vod: function () {
            this.add_header = '新增大厅公视配置';
            // 门店
            this.dtShop = [];
            this.innitInput();
            this.vod_set_cnfrt = "";
            this.vod_set_cnsnd = "";
            this.addModify = 1;
            this.showSet = true;
            this.visible = true;
        },
        // 初始化门店输入框
        innitInput: function () {
            let _this = this;
            let innitSuggest = function () {
                $(_this.$refs.shop).html("");
                $(_this.$refs.shop).select2({
                    data: _this.dtShop,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
            };
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {

                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getGongShiShopList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        $.each(data.response.result, function (k, v) {
                            _this.dtShop.push({
                                id: v.shop_id,
                                text: v.shop_name
                            });
                        });
                        innitSuggest();
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 返回
        rtnFun: function (num) {
            if (num == '0') {
                this.showSet = false;
            } else if (num == '1') {
                this.showXgq = true;
                this.showXgqSet = false;
            } else if (num == '2') {
                this.showLamp = true;
                this.showLampSet = false;
            } else if (num == '3') {
                this.showRoom = true;
                this.showRoomSet = false;
            } else if (num == '4') {
                this.showWake = true;
                this.showWakeSet = false;
            } else if (num == '5') {
                this.showBx = true;
                this.showBxSet = false;
            } else if (num == '6') {
                this.showScene = true;
                this.showSceneSet = false;
            }
        },
        // 保存新增/修改的大厅公视配置
        save: function (addModify) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": $(_this.$refs.shop).val(),
                        "chanel1": _this.vod_set_cnfrt,
                        "chanel2": _this.vod_set_cnsnd
                    }
                },
                "comment": ""
            };
            if (addModify == 2) {
                datas["request"]["param"]["shop_id"] = $(_this.$refs.shopCg).attr('shopID');
                datas["request"]["param"]["id"] = _this.theDetail;
            }
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setGongShi",
                async: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        layer.msg(data["response"]["error_msg"]);
                        $(_this.$refs.vodList).bootstrapTable('destroy');
                        _this.innitTable();
                        _this.showSet = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        getVodDetail: function (row) {
            let _this = this;
            // 门店
            $(_this.$refs.shopCg).text(row.shop_name);
            $(_this.$refs.shopCg).attr('shopID', row.shop_id);
            // chanel1
            _this.vod_set_cnfrt = row.chanel1;
            // chanel2
            _this.vod_set_cnsnd = row.chanel2;
            // id
            _this.theDetail = row.id;
        },
        // 删除
        deleteVod: function (id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "id": id
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/delGongShi",
                async: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        layer.msg(data["response"]["error_msg"]);
                        $(_this.$refs.vodList).bootstrapTable('destroy');
                        _this.innitTable();
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {

                }
            });
        },






        // 11111111111111111-------------------------
        // 初始化效果器配置列表
        innitXgqTable: function () {
            let _this = this;
            $(_this.$refs.xgqList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getXgqList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "11%"
                }, {
                    field: "room_name",
                    title: "包厢",
                    width: "8%"
                }, {
                    field: "volume_up",
                    title: "麦克风音量加",
                    width: "10%"
                }, {
                    field: "volume_down",
                    title: "麦克风音量减",
                    width: "10%"
                }, {
                    field: "professional_sound",
                    title: "专业音效",
                    width: "10%"
                }, {
                    field: "standard_sound",
                    title: "标准音效",
                    width: "10%"
                }, {
                    field: "k_sound",
                    title: "k歌音效",
                    width: "10%"
                }, {
                    field: "theatre_sound",
                    title: "剧院音效",
                    width: "10%"
                }, {
                    title: "操作",
                    width: "10%",
                    events: {
                        'click .modify': function (e, value, row) {
                            _this.getXgqDetail(row);
                            _this.addXgqModify = 2;
                            _this.add_xgq_header = '修改效果器配置';
                            _this.showXgq = false;
                            _this.showXgqSet = true;
                            _this.xgqVisible = false;
                        },
                        'click .delete': function (e, value, row) {
                            //debugger;
                            layer.confirm('删除后不可恢复，确定删除吗？', {
                                btn: ['确定', '取消'] //按钮
                            }, function () {
                                _this.deleteXgq(row.id);
                            });
                        }
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue modify">修改</span>&nbsp;<span class="text-blue delete">删除</span>'
                    }
                }]
            });
        },
        // 获取效果器配置列表
        getXgqList: function (params) {
            let _self = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getEffectorSettingList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _self);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 点击‘新增效果器配置’
        add_xgq: function () {
            this.add_xgq_header = '新增效果器配置';
            // 门店
            this.xgqShop = [];
            this.innitXgqInput();
            this.xgq_room_num = "";
            this.xgq_volup = "";
            this.xgq_voldown = "";
            this.xgq_mp_zy = "";
            this.xgq_mp_bz = "";
            this.xgq_mp_kg = "";
            this.xgq_mp_jy = "";
            this.room_checkboxdata = [],
                this.room_checkboxModel = '';
            this.room_detailcheckboxdata = [];
            $(this.$refs.xgq_room_num).removeClass("canselect");
            this.showXgq = false;
            this.showXgqSet = true;
            this.xgqVisible = true;
            this.objClass = {
                selection_clear: true,
                visi_hid: false
            };
        },
        // 初始化效果器配置门店输入框
        innitXgqInput: function () {
            let _this = this;
            let innitSuggest = function () {
                $(_this.$refs.xgqShop).html("");
                $(_this.$refs.xgqShop).select2({
                    data: _this.xgqShop,
                    minimumResultsForSearch: -1,
                    language: "zh-CN",
                    templateSelection: function (val) {
                        _this.xgq_room_num = '';
                        _this.room_checkboxModel = '';
                        return val.text
                    }
                });
            };
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {

                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        $.each(data.response.result, function (k, v) {
                            _this.xgqShop.push({
                                id: v.id,
                                text: v.name
                            });
                        });
                        _this.xgqShop.splice(0, 1);
                        innitSuggest();
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 点击选择包厢号
        xgq_room_fun: function (e) {
            if (!$(e.currentTarget).hasClass('canselect')) {
                var _this = this;
                let shopid = $(_this.$refs.xgqShop).val();
                _this.getAllRoomByArea(shopid);
                _this.showXgqSet = false;
                _this.showbox = true;
            }
        },
        // 包厢号数据
        getAllRoomByArea: function (shopid) {
            var _this = this;
            var datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": shopid
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getAllRoomByArea",
                async: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        _this.room_checkboxdata = data['response']['result'];
                        let newarray = [];
                        $.each(data['response']['result'], function (k, v) {
                            $.each(v.room, function (m, n) {
                                newarray.push(n);
                            });
                        });
                        _this.room_detailcheckboxdata = newarray;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) { }
            });
        },
        roomboxokFun: function () {
            var _this = this;
            // var texts = '';
            if (_this.room_checkboxModel == '0') {
                _this.xgq_room_num = '全部包厢';
            } else {
                _this.room_detailcheckboxdata.forEach(function (item) {
                    if (item.id == _this.room_checkboxModel) {
                        _this.xgq_room_num = item.name;
                    }
                });
                // _this.xgq_room_num = texts.join(",");
            }
            _this.showXgqSet = true;
            _this.showbox = false;
        },
        roomboxbackFun: function () {
            this.showXgqSet = true;
            this.showbox = false;
        },
        // 清空包厢号
        clear_input: function (name) {
            if (name == 'room_song_fun') {
                this.room_song_name = '';
                this.r_song_checkModel = '';
            } else if (name == 'wake_song_fun') {
                this.wake_song_name = '';
                this.w_song_checkModel = '';
            }
            this.xgq_room_num = '';
            this.room_checkboxModel = '';
        },
        // 保存新增/修改的效果器配置
        xgqSave: function (addModify) {
            let _this = this;
            let room_id = ['0'];
            if (_this.xgq_room_num == '') {
                layer.msg('包厢号不能为空');
                return;
            } else {
                room_id = _this.room_checkboxModel
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": $(_this.$refs.xgqShop).val(),
                        "room_id": room_id,
                        "volume_up": _this.xgq_volup,
                        "volume_down": _this.xgq_voldown,
                        "professional_sound": _this.xgq_mp_zy,
                        "standard_sound": _this.xgq_mp_bz,
                        "k_sound": _this.xgq_mp_kg,
                        "theatre_sound": _this.xgq_mp_jy
                    }
                },
                "comment": ""
            };
            if (addModify == 2) {
                datas["request"]["param"]["shop_id"] = $(_this.$refs.xgqShopCg).attr('shopID');
                datas["request"]["param"]["id"] = _this.theXgqDetail;
            }
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setEffectorSetting",
                async: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas
                },
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        layer.msg(data["response"]["error_msg"]);
                        $(_this.$refs.xgqList).bootstrapTable('destroy');
                        _this.innitXgqTable();
                        _this.showXgq = true;
                        _this.showXgqSet = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        getXgqDetail: function (row) {
            let _this = this;
            // 门店
            $(_this.$refs.xgqShopCg).text(row.shop_name);
            $(_this.$refs.xgqShopCg).attr('shopID', row.shop_id);
            // 包厢号
            _this.objClass = {
                selection_clear: true,
                visi_hid: true
            };
            _this.xgq_room_num = row.room_name;
            _this.room_checkboxModel = row.room_id;
            $(_this.$refs.xgq_room_num).addClass("canselect");
            // 麦克风音量加
            _this.xgq_volup = row.volume_up;
            // 麦克风音量减
            _this.xgq_voldown = row.volume_down;
            // 专业音效
            _this.xgq_mp_zy = row.professional_sound;
            // 标准音效
            _this.xgq_mp_bz = row.standard_sound;
            // k歌音效
            _this.xgq_mp_kg = row.k_sound;
            // 剧院音效
            _this.xgq_mp_jy = row.theatre_sound;

            _this.theXgqDetail = row.id;
        },
        // 删除效果器配置
        deleteXgq: function (id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "id": id
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/delEffectorSetting",
                async: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        layer.msg(data["response"]["error_msg"]);
                        $(_this.$refs.xgqList).bootstrapTable('destroy');
                        _this.innitXgqTable();
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {

                }
            });
        },




        // 22222222222222222222-------------------------
        // 初始化智能灯光配置列表
        innitLampTable: function () {
            let _this = this;
            $(_this.$refs.lampList).bootstrapTable('destroy');
            $(_this.$refs.lampList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getLampList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "11%"
                }, {
                    field: "room_name",
                    title: "包厢号",
                    width: "8%"
                }, {
                    field: "status",
                    title: "状态",
                    width: "10%",
                    formatter: function (value, row, index) {
                        if (value == '1') {
                            return '开启';
                        } else if (value == '-1') {
                            return '关闭';
                        }
                    }
                }, {
                    title: "操作",
                    width: "8%",
                    events: {
                        'click .modify': function (e, value, row) {
                            _this.getLampDetail(row);
                            _this.addLampModify = 2;
                            _this.add_lamp_header = '修改智能灯光配置';
                            _this.showLamp = false;
                            _this.showLampSet = true;
                            _this.lampVisible = false;
                        },
                        'click .delete': function (e, value, row) {
                            //debugger;
                            layer.confirm('删除后不可恢复，确定删除吗？', {
                                btn: ['确定', '取消'] //按钮
                            }, function () {
                                _this.deleteLamp(row.id);
                            });
                        }
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue modify">修改</span>&nbsp;&nbsp;<span class="text-blue delete">删除</span>'
                    }
                }]
            });
        },

        // 获取智能灯光配置列表
        getLampList: function (params) {
            let _self = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _self.lamp_shop_id,
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getLightingSettingList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _self);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 点击'智能灯光配置'
        add_lamp: function () {
            this.addLampModify = 1;
            this.add_lamp_header = '智能灯光配置';
            // 门店
            // this.lampShop = [];
            this.lampVisible = true;
            // this.innitLampInput();
            this.lamp_room_num = "";
            this.lamp_mp_cs = "";
            this.paclist1 = {
                name: '',
                status: '1',
                value: ''
            };
            this.paclist2 = {
                name: '',
                status: '1',
                value: ''
            };
            this.paclist3 = {
                name: '',
                status: '1',
                value: ''
            };
            this.paclist4 = {
                name: '',
                status: '1',
                value: ''
            };
            this.paclist5 = {
                name: '',
                status: '-1',
                value: ''
            };
            this.paclist6 = {
                name: '',
                status: '-1',
                value: ''
            };
            this.l_room_checkboxdata = [],
                this.l_room_checkboxModel = [];
            // 默认选中"全部"门店时，禁用包厢号选择框
            $(this.$refs.lamp_room_num).prop("disabled", true);
            $(this.$refs.lamp_room_num).removeClass("canselect");
            this.showLamp = false;
            this.showLampSet = true;
            this.l_objClass = {
                selection_clear: true,
                visi_hid: false
            };
        },

        // 初始化智能灯光配置门店输入框
        innitLampInput: function () {
            let _this = this;
            let innitSuggest = function () {
                $(_this.$refs.lampShop).html("");
                $(_this.$refs.lampShop).select2({
                    data: _this.lampShop,
                    minimumResultsForSearch: -1,
                    language: "zh-CN",
                    width: '100%',
                    templateSelection: function (val) {
                        _this.lamp_room_num = '';
                        _this.l_room_checkboxModel = [];

                        // 判断是否选择"全部"
                        if (val.id == '0' || val.text == '全部') {
                            // 选择全部时，禁用包厢号选择，不发起请求
                            $(_this.$refs.lamp_room_num).prop("disabled", true);
                            $(_this.$refs.lamp_room_num).removeClass("canselect");
                        } else {
                            // 选择具体门店时，启用包厢号选择
                            $(_this.$refs.lamp_room_num).prop("disabled", false);
                        }
                        return val.text
                    }
                });
            };
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {

                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.lampShop = []
                        $.each(data.response.result, function (k, v) {
                            // if(v.id != '0') {
                            _this.lampShop.push({
                                id: v.id,
                                text: v.name
                            });
                            // }
                        });
                        // _this.lampShop.splice(0, 1);
                        innitSuggest();
                        // 默认选中第一项（全部）
                        $(_this.$refs.lampShop).val('0').trigger('change');
                        _this.lamp_shop_id = _this.lampShop[0].id;
                        _this.innitLampTable()
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 点击选择包厢号
        lamp_room_fun: function (e) {
            if (!$(e.currentTarget).hasClass('canselect')) {
                var _this = this;
                let shopid = $(_this.$refs.lampShop).val();
                _this.getLampRoom(shopid);
                _this.showLampSet = false;
                _this.l_showbox = true;
            }
        },

        // 包厢号数据
        getLampRoom: function (shopid) {
            var _this = this;
            var datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": shopid
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getAllRoomByArea",
                async: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        _this.l_room_checkboxdata = data['response']['result'];
                        // let newarray = [];
                        // $.each(data['response']['result'], function(k, v) {
                        //     $.each(v.room, function(m, n) {
                        //         newarray.push(n);
                        //     });
                        // });
                        // _this.l_room_detailcheckboxdata = newarray;
                        _this.formatChoosedRoom(_this.l_room_checkboxModel)
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) { }
            });
        },


        // 格式化已选择包厢
        formatChoosedRoom(ids) {
            this.choosedLampRoom = ids
            this.lampCheckAllRoom = false

            if (ids.length > 0) { // 判断区域全选状态
                this.l_room_checkboxdata.forEach((item, pindex) => {
                    item.choosedCount = 0
                    this.l_room_checkboxdata[pindex].checked = false
                    item.room.forEach((room, cindex) => {
                        ids.forEach(v => {
                            if (v == room.id) {
                                item.choosedCount++
                            }
                        })
                    })
                    if (item.choosedCount == item.room.length) {
                        this.l_room_checkboxdata[pindex].checked = true
                    }
                })
            }
            this.is_allChoosed()
        },


        // 选择/取消某个区域
        handleLampCheckArea(val, pindex) {
            if (val) {
                this.l_room_checkboxdata[pindex].room.forEach(item => {
                    let cindex = this.choosedLampRoom.findIndex(val => val == item.id)
                    if (cindex < 0) {
                        this.choosedLampRoom.push(item.id)
                    }
                })
                this.is_allChoosed()
            } else {
                this.l_room_checkboxdata[pindex].room.forEach(item => {
                    let cindex = this.choosedLampRoom.findIndex(val => val == item.id)
                    if (cindex > -1) {
                        this.choosedLampRoom.splice(cindex, 1)
                    }
                })
                // 取消全选
                this.lampCheckAllRoom = false
            }
        },


        // 选择/取消某个包厢
        handleLampCheckRoom(val, pindex, cindex) {
            let areaAllRoom = this.l_room_checkboxdata[pindex].room
            let areaRoomCount = 0
            this.l_room_checkboxdata[pindex].room.forEach(item => {
                let chooseIndex = this.choosedLampRoom.findIndex(id => id == item.id)
                if (chooseIndex > -1) {
                    areaRoomCount++
                }
            })
            this.l_room_checkboxdata[pindex].checked = areaRoomCount == areaAllRoom.length

            if (!val) { // 取消全选
                this.lampCheckAllRoom = false
            } else {
                this.is_allChoosed()
            }
        },



        // 适用包厢全选
        handleLampCheckAllRoomChange(val) {
            if (val) {
                this.l_room_checkboxdata.forEach(item => {
                    item.checked = true
                    item.room.forEach(v => {
                        let cindex = this.choosedLampRoom.findIndex(val => val == v.id)
                        if (cindex < 0) {
                            this.choosedLampRoom.push(v.id)
                        }
                    })
                })
            } else {
                this.l_room_checkboxdata.forEach(item => {
                    item.checked = false
                })
                this.choosedLampRoom = []
            }
        },


        // 计算是否全选
        is_allChoosed() {
            let count = 0
            this.l_room_checkboxdata.forEach(item => {
                if (item.checked) {
                    count++
                }
            })
            this.lampCheckAllRoom = count == this.l_room_checkboxdata.length
        },


        // 确认选择包厢
        commitLampRoomChoose() {
            this.l_room_checkboxModel = this.choosedLampRoom
            if (this.l_room_checkboxModel.length < 1) {
                this.lamp_room_num = ''
            } else {
                if (this.lampCheckAllRoom) {
                    this.lamp_room_num = '全部包厢'
                } else {
                    let room_name = []
                    this.l_room_checkboxModel.forEach(item => {
                        this.l_room_checkboxdata.forEach(parent => {
                            parent.room.forEach(v => {
                                if (v.id == item) {
                                    room_name.push(v.name)
                                }
                            })
                        })
                    })
                    this.lamp_room_num = room_name.join(",")
                }
            }
            this.showLampSet = true
            this.l_showbox = false
        },


        // l_roomboxokFun: function() {
        //     var _this = this;
        //     // var texts = '';
        //     if(_this.l_room_checkboxModel == '0') {
        //         _this.lamp_room_num = '全部包厢';
        //     } else {
        //         _this.l_room_detailcheckboxdata.forEach(function(item) {
        //             if(item.id == _this.l_room_checkboxModel) {
        //                 _this.lamp_room_num = item.name;
        //             }
        //         });
        //         // _this.xgq_room_num = texts.join(",");
        //     }
        //     _this.showLampSet = true;
        //     _this.l_showbox = false;
        // },
        l_roomboxbackFun: function () {
            this.showLampSet = true;
            this.l_showbox = false;
        },

        // 清空包厢号
        l_clear_input: function () {
            this.lamp_room_num = '';
            this.l_room_checkboxModel = [];
        },

        // 保存新增/修改的智能灯光配置
        lampSave: function (addLampModify) {
            let _this = this;
            let room_ids = [];
            if (_this.lamp_room_num == '') {
                //如果门店选择了全部，则包厢号设置为 ['0']
                let shop_id = $(_this.$refs.lampShop).val();
                if (shop_id == '0') {
                    room_ids = ['0']
                } else {
                    layer.msg('包厢号不能为空');
                    return;
                }
                // layer.msg('包厢号不能为空');
                // return;
            } else if (_this.lampCheckAllRoom) {
                room_ids = ['0']
            } else {
                room_ids = _this.l_room_checkboxModel
            }
            let setting = {
                "main": _this.lamp_mp_cs,
                "paclist1": _this.paclist1,
                "paclist2": _this.paclist2,
                "paclist3": _this.paclist3,
                "paclist4": _this.paclist4,
                "paclist5": _this.paclist5,
                "paclist6": _this.paclist6,
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": $(_this.$refs.lampShop).val(),
                        'status': $(_this.$refs.lampStatus).val(),
                        "room_ids": room_ids,
                        "setting": setting
                    }
                },
                "comment": ""
            };
            if (addLampModify == 2) {
                datas["request"]["param"]["shop_id"] = $(_this.$refs.lampShopCg).attr('shopID');
                datas["request"]["param"]["ids"] = _this.theLampDetail;
                if (_this.choosed_other_lamp_room.length > 0) {
                    datas["request"]["param"]["ids"] = datas["request"]["param"]["ids"].concat(_this.choosed_other_lamp_room)
                }
            }
            datas = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setLightingSetting",
                // async: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas
                },
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        layer.msg(data["response"]["error_msg"]);
                        $(_this.$refs.lampList).bootstrapTable('destroy');
                        _this.innitLampTable();
                        _this.showLamp = true;
                        _this.showLampSet = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        getLampDetail: function (row) {
            let _this = this;
            var datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "id": row.id
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/showLightingSetting",
                async: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        // 配置参数
                        _this.lamp_mp_cs = data.response.result.setting.main;
                        _this.paclist1 = data.response.result.setting.paclist1;
                        _this.paclist2 = data.response.result.setting.paclist2;
                        _this.paclist3 = data.response.result.setting.paclist3;
                        _this.paclist4 = data.response.result.setting.paclist4;
                        _this.paclist5 = data.response.result.setting.paclist5;
                        _this.paclist6 = data.response.result.setting.paclist6;
                        _this.other_lamp_room = data.response.result.other_room;
                        _this.choosed_other_lamp_room = [];
                        _this.lampSyncAllOtherRoom = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) { }
            });

            // 门店
            $(_this.$refs.lampShopCg).text(row.shop_name);
            $(_this.$refs.lampShopCg).attr('shopID', row.shop_id);
            // 状态
            $(_this.$refs.lampStatus).val(row.status);
            // 包厢号
            _this.l_objClass = {
                selection_clear: true,
                visi_hid: true
            };
            _this.lamp_room_num = row.room_name;
            _this.l_room_checkboxModel = row.room_id;
            $(_this.$refs.lamp_room_num).addClass("canselect");

            _this.theLampDetail = [row.id];
        },


        handleLampSyncAllOtherRoomChange(val) {
            if (val) {
                this.choosed_other_lamp_room = this.other_lamp_room.map(item => item.id)
            } else {
                this.choosed_other_lamp_room = []
            }
        },

        handleLampSyncOtherRoomChange(val) {
            let count = val.length
            this.lampSyncAllOtherRoom = count == this.other_lamp_room.length
        },

        // 删除智能灯光配置
        deleteLamp: function (id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "id": id
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/delLightingSetting",
                async: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        layer.msg(data["response"]["error_msg"]);
                        $(_this.$refs.lampList).bootstrapTable('destroy');
                        _this.innitLampTable();
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {

                }
            });
        },

        // 修改页的提示语
        hint_language: function (e) {
            var contents = "<span class='dots'>·</span>" + $(e.currentTarget).attr("titles");
            layer.tips(contents, $(e.currentTarget), {
                skin: 'hint_language_tip',
                tips: [2, '#fff'],
                time: 2000000,
            });
        },
        // 关闭提示语
        close_hint_language: function () {
            layer.closeAll('tips');
        },

        // 22222222222222222222-------------------------
        // 初始化场景灯光配置列表
        innitSceneTable: function () {
            let _this = this;
            $(_this.$refs.sceneList).bootstrapTable('destroy');
            $(_this.$refs.sceneList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getSceneList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "11%"
                }, {
                    field: "room_name",
                    title: "包厢号",
                    width: "8%"
                }, {
                    field: "status",
                    title: "状态",
                    width: "10%",
                    formatter: function (value, row, index) {
                        if (value == '1') {
                            return '开启';
                        } else if (value == '-1') {
                            return '关闭';
                        }
                    }
                }, {
                    title: "操作",
                    width: "8%",
                    events: {
                        'click .modify': function (e, value, row) {
                            _this.getSceneDetail(row);
                            _this.addSceneModify = 2;
                            _this.add_scene_header = '修改场景灯光配置';
                            _this.showScene = false;
                            _this.showSceneSet = true;
                            _this.sceneVisible = false;
                        },
                        'click .delete': function (e, value, row) {
                            //debugger;
                            layer.confirm('删除后不可恢复，确定删除吗？', {
                                btn: ['确定', '取消'] //按钮
                            }, function () {
                                _this.deleteScene(row.id);
                            });
                        }
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue modify">修改</span>&nbsp;&nbsp;<span class="text-blue delete">删除</span>'
                    }
                }]
            });
        },

        // 获取场景灯光配置列表
        getSceneList: function (params) {
            let _self = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _self.scene_shop_id,
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getLightingSceneSettingList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _self);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 点击‘场景灯光配置’
        add_scene: function () {
            this.addSceneModify = 1;
            this.add_scene_header = '场景灯光配置';
            // 门店
            this.sceneShop = [];
            this.sceneVisible = true;
            // this.innitSceneInput();
            this.other_scene_room = [];
            this.choosed_other_scene_room = [];
            this.sceneSyncAllOtherRoom = false;
            this.scene_room_num = "";
            // this.scene_mp_cs = "";
            this.scene_paclist1 = {
                name: '',
                status: 1,
                open_value: '',
                close_value: '',
                default_status: -1
            };
            this.scene_paclist2 = {
                name: '',
                status: 1,
                open_value: '',
                close_value: '',
                default_status: -1

            };
            this.scene_paclist3 = {
                name: '',
                status: 1,
                open_value: '',
                close_value: '',
                default_status: -1
            };
            this.scene_paclist4 = {
                name: '',
                status: 1,
                open_value: '',
                close_value: '',
                default_status: -1
            };
            this.scene_paclist5 = {
                name: '',
                status: 1,
                open_value: '',
                close_value: '',
                default_status: -1
            };
            this.scene_paclist6 = {
                name: '',
                status: 1,
                open_value: '',
                close_value: '',
                default_status: -1
            };
            this.s_room_checkboxdata = [],
                this.s_room_checkboxModel = [];
            $(this.$refs.scene_room_num).removeClass("canselect");
            this.showScene = false;
            this.showSceneSet = true;
            this.s_objClass = {
                selection_clear: true,
                visi_hid: false
            };
        },

        // 初始化场景灯光配置门店输入框
        innitSceneInput: function () {
            let _this = this;
            let innitSuggest = function () {
                $(_this.$refs.sceneShop).html("");
                $(_this.$refs.sceneShop).select2({
                    data: _this.sceneShop,
                    minimumResultsForSearch: -1,
                    language: "zh-CN",
                    width: '100%',
                    templateSelection: function (val) {
                        _this.scene_room_num = '';
                        _this.s_room_checkboxModel = [];
                        return val.text
                    }
                });
            };
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {

                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.sceneShop = []
                        $.each(data.response.result, function (k, v) {
                            if (v.id != '0') {
                                _this.sceneShop.push({
                                    id: v.id,
                                    text: v.name
                                });
                            }
                        });
                        // _this.lampShop.splice(0, 1);
                        innitSuggest();
                        _this.scene_shop_id = _this.sceneShop[0].id;
                        _this.innitSceneTable()
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 点击选择包厢号
        scene_room_fun: function (e) {
            if (!$(e.currentTarget).hasClass('canselect')) {
                var _this = this;
                let shopid = $(_this.$refs.sceneShop).val();
                _this.getSceneRoom(shopid);
                _this.showSceneSet = false;
                _this.s_showbox = true;
            }
        },

        // 包厢号数据
        getSceneRoom: function (shopid) {
            var _this = this;
            var datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": shopid
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getAllRoomByArea",
                async: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        _this.s_room_checkboxdata = data['response']['result'];
                        // let newarray = [];
                        // $.each(data['response']['result'], function(k, v) {
                        //     $.each(v.room, function(m, n) {
                        //         newarray.push(n);
                        //     });
                        // });
                        // _this.l_room_detailcheckboxdata = newarray;
                        _this.formatChoosedSceneRoom(_this.s_room_checkboxModel)
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) { }
            });
        },

        // 格式化已选择包厢
        formatChoosedSceneRoom(ids) {
            this.choosedSceneRoom = ids
            this.sceneCheckAllRoom = false

            if (ids.length > 0) { // 判断区域全选状态
                this.s_room_checkboxdata.forEach((item, pindex) => {
                    item.choosedCount = 0
                    this.s_room_checkboxdata[pindex].checked = false
                    item.room.forEach((room, cindex) => {
                        ids.forEach(v => {
                            if (v == room.id) {
                                item.choosedCount++
                            }
                        })
                    })
                    if (item.choosedCount == item.room.length) {
                        this.s_room_checkboxdata[pindex].checked = true
                    }
                })
            }
            this.is_allChoosedScene()
        },

        // 选择/取消某个区域
        handleSceneCheckArea(val, pindex) {
            if (val) {
                this.s_room_checkboxdata[pindex].room.forEach(item => {
                    let cindex = this.choosedSceneRoom.findIndex(val => val == item.id)
                    if (cindex < 0) {
                        this.choosedSceneRoom.push(item.id)
                    }
                })
                this.is_allChoosedScene()
            } else {
                this.s_room_checkboxdata[pindex].room.forEach(item => {
                    let cindex = this.choosedSceneRoom.findIndex(val => val == item.id)
                    if (cindex > -1) {
                        this.choosedSceneRoom.splice(cindex, 1)
                    }
                })
                // 取消全选
                this.sceneCheckAllRoom = false
            }
        },

        // 选择/取消某个包厢
        handleSceneCheckRoom(val, pindex, cindex) {
            let areaAllRoom = this.s_room_checkboxdata[pindex].room
            let areaRoomCount = 0
            this.s_room_checkboxdata[pindex].room.forEach(item => {
                let chooseIndex = this.choosedSceneRoom.findIndex(id => id == item.id)
                if (chooseIndex > -1) {
                    areaRoomCount++
                }
            })
            this.s_room_checkboxdata[pindex].checked = areaRoomCount == areaAllRoom.length

            if (!val) { // 取消全选
                this.sceneCheckAllRoom = false
            } else {
                this.is_allChoosedScene()
            }
        },

        // 适用包厢全选
        handleSceneCheckAllRoomChange(val) {
            if (val) {
                this.s_room_checkboxdata.forEach(item => {
                    item.checked = true
                    item.room.forEach(v => {
                        let cindex = this.choosedSceneRoom.findIndex(val => val == v.id)
                        if (cindex < 0) {
                            this.choosedSceneRoom.push(v.id)
                        }
                    })
                })
            } else {
                this.s_room_checkboxdata.forEach(item => {
                    item.checked = false
                })
                this.choosedSceneRoom = []
            }
        },

        // 计算是否全选
        is_allChoosedScene() {
            let count = 0
            this.s_room_checkboxdata.forEach(item => {
                if (item.checked) {
                    count++
                }
            })
            this.sceneCheckAllRoom = count == this.s_room_checkboxdata.length
        },


        // 确认选择包厢
        commitSceneRoomChoose() {
            this.s_room_checkboxModel = this.choosedSceneRoom
            if (this.s_room_checkboxModel.length < 1) {
                this.scene_room_num = ''
            } else {
                if (this.sceneCheckAllRoom) {
                    this.scene_room_num = '全部包厢'
                } else {
                    let room_name = []
                    this.s_room_checkboxModel.forEach(item => {
                        this.s_room_checkboxdata.forEach(parent => {
                            parent.room.forEach(v => {
                                if (v.id == item) {
                                    room_name.push(v.name)
                                }
                            })
                        })
                    })
                    this.scene_room_num = room_name.join(",")
                }
            }
            this.showSceneSet = true
            this.s_showbox = false
        },

        s_roomboxbackFun: function () {
            this.showSceneSet = true;
            this.s_showbox = false;
        },

        // 清空包厢号
        s_clear_input: function () {
            this.scene_room_num = '';
            this.s_room_checkboxModel = [];
        },

        // 保存新增/修改的场景灯光配置
        sceneSave: function (addLampModify) {
            let _this = this;
            let room_ids = [];
            if (_this.scene_room_num == '') {
                layer.msg('包厢号不能为空');
                return;
            } else if (_this.sceneCheckAllRoom) {
                room_ids = ['0']
            } else {
                room_ids = _this.s_room_checkboxModel
            }
            let setting = {
                // "main": _this.scene_mp_cs,
                "scene1": _this.scene_paclist1,
                "scene2": _this.scene_paclist2,
                "scene3": _this.scene_paclist3,
                "scene4": _this.scene_paclist4,
                "scene5": _this.scene_paclist5,
                "scene6": _this.scene_paclist6,
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": $(_this.$refs.sceneShop).val(),
                        'status': $(_this.$refs.sceneStatus).val(),
                        "room_ids": room_ids,
                        "setting": setting
                    }
                },
                "comment": ""
            };
            if (addLampModify == 2) {
                datas["request"]["param"]["shop_id"] = $(_this.$refs.sceneShopCg).attr('shopID');
                datas["request"]["param"]["ids"] = _this.theSceneDetail;
                if (_this.choosed_other_scene_room.length > 0) {
                    datas["request"]["param"]["ids"] = datas["request"]["param"]["ids"].concat(_this.choosed_other_scene_room)
                }
            }
            datas = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setLightingSceneSetting",
                // async: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas
                },
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        layer.msg(data["response"]["error_msg"]);
                        $(_this.$refs.sceneList).bootstrapTable('destroy');
                        _this.innitSceneTable();
                        _this.showScene = true;
                        _this.showSceneSet = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        getSceneDetail: function (row) {
            let _this = this;
            var datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "id": row.id
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/showLightingSceneSetting",
                async: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        console.log('data', data);

                        // 配置参数
                        // _this.scene_mp_cs = data.response.result.setting.main;
                        _this.scene_paclist1 = data.response.result.setting.scene1;
                        _this.scene_paclist2 = data.response.result.setting.scene2;
                        _this.scene_paclist3 = data.response.result.setting.scene3;
                        _this.scene_paclist4 = data.response.result.setting.scene4;
                        _this.scene_paclist5 = data.response.result.setting.scene5;
                        _this.scene_paclist6 = data.response.result.setting.scene6;
                        _this.other_scene_room = data.response.result.other_room;
                        _this.choosed_other_scene_room = [];
                        _this.sceneSyncAllOtherRoom = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) { }
            });

            // 门店
            $(_this.$refs.sceneShopCg).text(row.shop_name);
            $(_this.$refs.sceneShopCg).attr('shopID', row.shop_id);
            // 状态
            $(_this.$refs.sceneStatus).val(row.status);
            // 包厢号
            _this.s_objClass = {
                selection_clear: true,
                visi_hid: true
            };
            _this.scene_room_num = row.room_name;
            _this.s_room_checkboxModel = row.room_id;
            $(_this.$refs.scene_room_num).addClass("canselect");

            _this.theSceneDetail = [row.id];
        },

        handleSceneSyncAllOtherRoomChange(val) {
            if (val) {
                this.choosed_other_scene_room = this.other_scene_room.map(item => item.id)
            } else {
                this.choosed_other_scene_room = []
            }
        },

        handleSceneSyncOtherRoomChange(val) {
            let count = val.length
            this.sceneSyncAllOtherRoom = count == this.other_scene_room.length
        },

        // 删除场景灯光配置
        deleteScene: function (id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "id": id
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/delLightingSceneSetting",
                async: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        layer.msg(data["response"]["error_msg"]);
                        $(_this.$refs.sceneList).bootstrapTable('destroy');
                        _this.innitSceneTable();
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {

                }
            });
        },


        // 333333333333333333333333-------------------------
        // 初始化开房播放设置列表
        innitRoomTable: function () {
            let _this = this;
            $(_this.$refs.roomList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getRoomList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "11%"
                }, {
                    field: "room_info",
                    title: "包厢",
                    width: "10%",
                    formatter: function (value, row, index) {
                        if (row.use_all_room == '1') {
                            return '全部';
                        } else {
                            return row.room_info;
                        }
                    }
                }, {
                    field: "song_name",
                    title: "开房播放歌曲",
                    width: "10%"
                }, {
                    field: "time",
                    title: "操作时间",
                    width: "10%"
                }, {
                    title: "操作",
                    width: "10%",
                    events: {
                        'click .modify': function (e, value, row) {
                            _this.getRoomDetail(row);
                            _this.addRoomModify = 2;
                            _this.add_room_header = '修改开房播放设置';
                            _this.showRoom = false;
                            _this.showRoomSet = true;
                            _this.roomVisible = false;
                        },
                        'click .delete': function (e, value, row) {
                            // debugger;
                            layer.confirm('删除后不可恢复，确定删除吗？', {
                                btn: ['确定', '取消'] //按钮
                            }, function () {
                                _this.deleteRoom(row.id);
                            });
                        }
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue modify">修改</span>&nbsp;&nbsp;<span class="text-blue delete">删除</span>'
                    }
                }]
            });
        },
        // 获取开房播放设置列表
        getRoomList: function (params) {
            let _self = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getOpenRoomSongsSettingList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _self);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 点击‘开房播放设置’
        add_room: function () {
            this.addRoomModify = 1;
            this.add_room_header = '开房播放设置';
            // 门店
            this.roomShop = [];
            this.roomVisible = true;
            this.innitRoomInput();
            this.room_box_num = "";
            this.r_box_checkboxData = [];
            this.r_box_detCheckboxData = [];
            this.r_box_checkboxModel = [];

            this.showRoom = false;
            this.showRoomSet = true;
            this.r_objClass = {
                selection_clear: true,
                visi_hid: false
            };
            $(this.$refs.room_box_num).removeClass("canselect");

            this.r_song_checkModel = '';
            this.room_song_name = '';
            this.songData = [];
            this.getSongsData('room');
        },
        // 初始化门店输入框
        innitRoomInput: function () {
            let _this = this;
            let innitSuggest = function () {
                $(_this.$refs.roomShop).html("");
                $(_this.$refs.roomShop).select2({
                    data: _this.roomShop,
                    minimumResultsForSearch: -1,
                    language: "zh-CN",
                    templateSelection: function (val) {
                        console.log('vvvaaalll', val);

                        if (val.id != '0') {
                            _this.room_all_shops = '-1'
                            _this.r_box_allsel = '-1'
                            $(_this.$refs.room_box_num).prop("disabled", false);
                            _this.room_box_num = '';
                            _this.r_box_checkboxModel = [];
                            // 显示清除按钮
                            _this.r_objClass = {
                                visi_hid: false,
                                selection_clear: true
                            };
                            _this.getRoomBox(val.id);
                            return val.text
                        } else {
                            _this.room_all_shops = '1';
                            _this.r_box_allsel = '1';
                            _this.room_box_num = '全部';
                            _this.r_box_checkboxModel = [];
                            $(_this.$refs.room_box_num).prop("disabled", true);
                            // 隐藏清除按钮
                            _this.r_objClass = {
                                visi_hid: true,
                                selection_clear: true
                            };
                            return val.text
                        }

                    }
                });
            };
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {

                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        $.each(data.response.result, function (k, v) {
                            _this.roomShop.push({
                                id: v.id,
                                text: v.name
                            });
                        });
                        // _this.roomShop.splice(0, 1);
                        innitSuggest();
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 点击选择包厢号
        room_box_fun: function (e) {
            if (!$(e.currentTarget).hasClass('canselect')) {
                var _this = this;
                _this.r_c_box_checkboxModel = _this.r_box_checkboxModel;
                _this.showRoomSet = false;
                _this.r_showbox = true;
            }
        },
        // 包厢号数据
        getRoomBox: function (shopid) {
            var _this = this;
            var datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": shopid
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getAllRoomByArea",
                async: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        _this.r_box_checkboxData = data['response']['result'];
                        let newarray = [];
                        $.each(data['response']['result'], function (k, v) {
                            $.each(v.room, function (m, n) {
                                newarray.push(n);
                            });
                        });
                        _this.r_box_detCheckboxData = newarray;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) { }
            });
        },
        rBoxSubmit: function () {
            var _this = this;
            if (_this.r_box_allcheck) {
                _this.room_box_num = '全部';
                _this.r_box_allsel = '1';
            } else {
                let texts = [];
                _this.r_box_detCheckboxData.forEach(function (item) {
                    _this.r_box_checkboxModel.forEach(function (item2) {
                        if (item.id == item2) {
                            texts.push(item.name);
                        }
                    });
                });
                _this.room_box_num = texts.join(",");
                _this.r_box_allsel = '-1';
            }
            _this.showRoomSet = true;
            _this.r_showbox = false;
        },
        rBoxReturn: function () {
            this.showRoomSet = true;
            this.r_showbox = false;
            if (this.room_box_num != "") {
                this.r_box_checkboxModel = this.r_c_box_checkboxModel;
                return;
            }
            this.r_box_checkboxModel = [];
        },
        // 清空包厢号
        r_clear_input: function () {
            this.room_box_num = '';
            this.r_box_checkboxModel = '';
        },
        // 全选
        rBoxAllcheck: function () {
            let _this = this;
            _this.r_box_allcheck = _this.r_c_box_allcheck;
            if (!_this.r_box_allcheck) { // 实现全选
                _this.r_box_checkboxModel = [];
                _this.r_box_detCheckboxData.forEach(function (item) {
                    _this.r_box_checkboxModel.push(item.id);
                });
            } else { // 实现反选
                this.r_box_checkboxModel = [];
            }
        },
        // 开房、开机播放歌曲数据
        getSongsData: function (name) {
            var _this = this;

            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {

                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getCustomSongsList",
                async: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    _this.songData = [];
                    if (data['response']['result_code'] == "true") {
                        $.each(data.response.result, function (k, v) {
                            _this.songData.push({
                                id: v.song_id,
                                text: v.song_name
                            });
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) { }
            });
        },

        // 点击选择开房播放歌曲
        room_song_fun: function () {
            let _this = this;
            let c_r_song_checkModel = _this.r_song_checkModel;
            layer.confirm('', {
                skin: 'add_printer_area',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['开房播放歌曲', true],
                area: ['700px', ''], // 宽高
                content: $(_this.$refs.roomSong_alert),
                cancel: function () {
                    // 右上角关闭
                    if (_this.room_song_name != "") {
                        _this.r_song_checkModel = c_r_song_checkModel;
                        return;
                    }
                    _this.r_song_checkModel = '';
                }
            }, function () {
                _this.songData.forEach(function (item) {
                    if (item.id == _this.r_song_checkModel) {
                        _this.room_song_name = item.text;
                    }
                });
                layer.closeAll();
            }, function () {
                if (_this.room_song_name != "") {
                    _this.r_song_checkModel = c_r_song_checkModel;
                    return;
                }
                _this.r_song_checkModel = '';
            });
        },

        // 删除开房播放歌曲
        delSong: function (id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "id": id
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/delCustomSong",
                async: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        layer.msg(data["response"]["error_msg"]);
                        _this.getSongsData('room');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },


        // 新增/修改开房播放设置
        roomSave: function (addRoomModify) {
            let _this = this;
            let room_ids = [];
            if (_this.room_box_num == '') {
                layer.msg('包厢号不能为空');
                return;
            } else {
                $.each(_this.r_box_checkboxModel, function (k, v) {
                    room_ids.push(v);
                });
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": $(_this.$refs.roomShop).val(),
                        "song_id": _this.r_song_checkModel,
                        'use_all_room': _this.r_box_allsel,
                        "room_ids": room_ids,
                        "all_shops": _this.room_all_shops
                    }
                },
                "comment": ""
            };
            if (addRoomModify == 2) {
                datas["request"]["param"]["shop_id"] = $(_this.$refs.roomShopCg).attr('shopID');
                datas["request"]["param"]["id"] = _this.room_item_id;
            }
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setOpenRoomSongsSetting",
                async: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        layer.msg(data["response"]["error_msg"]);
                        $(_this.$refs.roomList).bootstrapTable('destroy');
                        _this.innitRoomTable();
                        _this.showRoom = true;
                        _this.showRoomSet = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        openUpdsongs: function (e) {
            let _this = this;
            layer.confirm('', {
                skin: 'add_printer_area upload-songs',
                type: 1,
                btn: ['选择文件'], // 按钮
                title: ['上传歌曲', true],
                area: ['650px', ''], // 宽高
                content: $(_this.$refs.upload_songs),
                cancel: function () {
                    // 右上角关闭
                    document.getElementById('ossfile').innerHTML = '';
                }
            });

            // _this.uploadNewSong();
        },

        // 上传开房播放歌曲
        uploadNewSong: function () {
            var _this = this;
            var accessid = '',
                accesskey = '',
                host = '',
                policyBase64 = '',
                signature = '',
                callbackbody = '',
                filename = '',
                key = '',
                expire = 0,
                g_object_name = '',
                g_object_name_type = 'local_name',  // 上传文件名字保持本地文件名字
                now = Date.parse(new Date()) / 1000;

            var body = '';
            function send_request() {
                var xmlhttp = null;
                if (window.XMLHttpRequest) {
                    xmlhttp = new XMLHttpRequest();
                } else if (window.ActiveXObject) {
                    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
                }
                if (xmlhttp != null) {
                    let datas = {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                // 'file': filename
                            }
                        },
                        "comment": ""
                    };
                    datas = JSON.stringify(datas);
                    $.ajax({
                        type: "POST",
                        dataType: "json",
                        url: Vue.ctUrl + "Setting/getOssSignature",
                        async: false,
                        crossDomain: true,
                        xhrFields: {
                            withCredentials: true
                        },
                        data: datas,
                        success: function (data) {
                            if (data['response']['result_code'] == "true") {
                                body = data.response.result.signature;
                                // g_object_name = data.response.result.file_name;
                            } else {
                                Vue.timeoutfun(data.response.result_status, _this);
                                layer.msg(data["response"]["error_msg"]);
                            }
                        },
                        error: function (err) {

                        }
                    });
                } else {
                    alert("Your browser does not support XMLHTTP.");
                }
            };

            function get_signature() {
                // 可以判断当前expire是否超过了当前时间,如果超过了当前时间,就重新取一下.3s 做为缓冲
                now = Date.parse(new Date()) / 1000;
                if (expire < now + 3) {
                    send_request();  // 返回签名
                    var obj = body;
                    host = obj['host'];
                    policyBase64 = obj['policy'];
                    accessid = obj['accessid'];
                    signature = obj['signature'];
                    expire = parseInt(obj['expire']);
                    callbackbody = obj['callback'];
                    key = obj['dir'];
                    return true;
                }
                return false;
            };

            function get_uploaded_object_name(filename) {
                let tmp_name = key + g_object_name
                tmp_name = tmp_name.replace("${filename}", filename);
                return tmp_name
            }

            function set_upload_param(up, filename, ret) {
                if (ret == false) {
                    ret = get_signature();
                }

                let new_multipart_params = {
                    'key': key + g_object_name,
                    'policy': policyBase64,
                    'OSSAccessKeyId': accessid,
                    'success_action_status': '200', // 让服务端返回200,不然，默认会返回204
                    'callback': callbackbody,
                    'signature': signature,
                };
                up.setOption({
                    'url': host,
                    'multipart_params': new_multipart_params
                });

                up.start();
            }

            function getFileName(filename) {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            'file': filename
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getFileName",
                    async: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function (data) {
                        if (data['response']['result_code'] == "true") {
                            g_object_name = data.response.result.file_name;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function (err) {

                    }
                });
            }

            var uploader = new plupload.Uploader({
                runtimes: 'html5,flash,silverlight,html4',
                browse_button: 'roomSelFile',
                container: document.getElementById('uploadWrap'),
                flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
                silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
                url: Vue.ctUrl + "Setting/saveCustomSongsInfo",

                filters: {
                    mime_types: [ // 只允许上传mkv, mp4, avi文件
                        { title: "Video files", extensions: "mkv,mp4,avi" }
                    ],
                    max_file_size: '200mb', // 最大只能上传200mb的文件
                    prevent_duplicates: true // 不允许选取重复文件
                },

                init: {
                    PostInit: function () {
                        document.getElementById('ossfile').innerHTML = '';
                        document.getElementById('roomSubFile').onclick = function () {
                            // let tagSel = document.getElementById('ossfile').getElementsByTagName('span');
                            // $.each(tagSel, function(k, v) {
                            //     set_upload_param(uploader, $(tagSel)[k].innerHTML, false);
                            // });
                            set_upload_param(uploader, '', false);
                            return false;
                        };
                    },

                    FilesAdded: function (up, files) {
                        plupload.each(files, function (file) {
                            document.getElementById('ossfile').innerHTML += '<div id="' + file.id + '"><span>' + file.name + '</span> (' + plupload.formatSize(file.size) + ')<b></b>'
                                + '<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>'
                                + '</div>';

                            // 获取视频分辨率并检查
                            const url = URL.createObjectURL(file.getNative());
                            const video = document.createElement('video');

                            // 添加处理状态标志
                            let isHandled = false;

                            // 安全地移除DOM元素和文件的函数
                            const safeRemove = (message) => {
                                if (isHandled) return; // 如果已经处理过，直接返回
                                isHandled = true;      // 标记为已处理

                                const element = document.getElementById(file.id);
                                if (element) {
                                    element.remove();
                                }
                                if (up.getFile(file.id)) {
                                    up.removeFile(file);
                                }
                                URL.revokeObjectURL(url);

                                if (message) {
                                    layer.msg(message);
                                }
                            };

                            // 添加错误处理
                            video.onerror = function () {
                                // 视频加载失败，移除文件
                                safeRemove('无法获取视频信息，请检查视频格式是否正确');
                            };

                            // 添加超时处理
                            const timeoutId = setTimeout(() => {
                                // 如果3秒内没有获取到元数据，就认为视频无效
                                video.onerror = null; // 清除错误处理
                                safeRemove('无法获取视频分辨率信息，请检查视频分辨率是否超过限制');
                            }, 3000);

                            video.onloadedmetadata = function () {
                                clearTimeout(timeoutId); // 清除超时计时器

                                let width = video.videoWidth;
                                let height = video.videoHeight;
                                console.log('原始分辨率:', width, height);

                                // 检查是否成功获取到宽高
                                if (!width || !height) {
                                    // 获取不到宽高，当作超过限制处理
                                    safeRemove('无法获取视频分辨率，请检查视频分辨率是否超过限制');
                                    return;
                                }

                                // 处理非方形像素的情况
                                if (video.videoWidth > 1920 && video.videoHeight <= 1080) {
                                    width = Math.round((1920 * video.videoHeight) / 1080);
                                }

                                console.log('计算后分辨率:', width, height);

                                // 检查分辨率 - 区分横屏竖屏
                                let isValid = false;
                                if (width >= height) {
                                    // 横屏视频：宽度不超过1920，高度不超过1080
                                    isValid = width <= 1920 && height <= 1080;
                                } else {
                                    // 竖屏视频：宽度不超过1080，高度不超过1920
                                    isValid = width <= 1080 && height <= 1920;
                                }

                                if (!isValid) {
                                    safeRemove('视频分辨率超出限制：横屏不超过1920x1080，竖屏不超过1080x1920');
                                } else {
                                    // 显示合法分辨率
                                    const element = document.getElementById(file.id);
                                    if (element) {
                                        const span = element.getElementsByTagName('span')[0];
                                        if (span) {
                                            span.innerHTML += ` [${width}x${height}]`;
                                        }
                                    }
                                    URL.revokeObjectURL(url);
                                }
                            };

                            video.src = url;
                        });
                    },

                    BeforeUpload: function (up, file) {
                        getFileName(file.name);
                        set_upload_param(up, '', true);
                    },

                    UploadProgress: function (up, file) {
                        var d = document.getElementById(file.id);
                        d.getElementsByTagName('b')[0].innerHTML = '<span>' + file.percent + "%</span>";
                        var prog = d.getElementsByTagName('div')[0];
                        var progBar = prog.getElementsByTagName('div')[0]
                        progBar.style.width = 5 * file.percent + 'px';
                        progBar.setAttribute('aria-valuenow', file.percent);
                    },

                    FileUploaded: function (up, file, info) {
                        if (info.status == 200) {
                            let finalPath = get_uploaded_object_name(file.name);

                            // 保存上传的文件信息
                            let datas = {
                                "header": Vue.request_header,
                                "request": {
                                    "param": {
                                        "song_down_file": finalPath, // 文件存储路径
                                        "song_name": g_object_name // 文件名
                                    }
                                },
                                "comment": ""
                            };
                            datas = JSON.stringify(datas);
                            $.ajax({
                                type: "POST",
                                dataType: "json",
                                url: Vue.ctUrl + "Setting/saveCustomSongsInfo",
                                async: true,
                                crossDomain: true,
                                xhrFields: {
                                    withCredentials: true
                                },
                                data: datas,
                                success: function (data) {
                                    if (data['response']['result_code'] == "true") {
                                        layer.msg('上传成功');
                                        _this.getSongsData('room');
                                    } else {
                                        Vue.timeoutfun(data.response.result_status, _this);
                                        layer.msg(data["response"]["error_msg"]);
                                    }
                                },
                                error: function (err) {

                                }
                            });

                        } else {
                            document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = info.response;
                        }
                    },

                    Error: function (up, err) {
                        if (err.code == -600) {
                            layer.msg('请选择200mb以内的文件');
                        } else if (err.code == -601) {
                            layer.msg('只允许上传mkv/mp4/avi文件');
                        } else if (err.code == -602) {
                            layer.msg('这个文件已经上传过一遍了');
                        } else {
                            layer.msg(err.response);
                        }
                    }
                }
            });

            uploader.init();
        },





        getRoomDetail: function (row) {
            let _this = this;

            // 门店
            $(_this.$refs.roomShopCg).text(row.shop_name);
            $(_this.$refs.roomShopCg).attr('shopID', row.shop_id);
            // 包厢号
            _this.l_objClass = {
                selection_clear: true,
                visi_hid: true
            };
            if (row.use_all_room == 1) {
                _this.room_box_num = '全部';
                _this.r_box_allsel = row.use_all_room;
            } else {
                _this.room_box_num = row.room_info;
                _this.r_box_allsel = row.use_all_room;
            }
            _this.r_box_checkboxModel = row.room_ids;
            $(_this.$refs.room_box_num).addClass("canselect");
            // 开房播放歌曲
            _this.songData = [];
            _this.getSongsData('room');
            _this.room_song_name = row.song_name;
            _this.r_song_checkModel = row.songs_id;
            // id
            _this.room_item_id = row.id;
        },
        // 删除开房播放设置
        deleteRoom: function (id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "id": id
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/delOpenRoomSongsSetting",
                async: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        layer.msg(data["response"]["error_msg"]);
                        $(_this.$refs.roomList).bootstrapTable('destroy');
                        _this.innitRoomTable();
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {

                }
            });
        },




        // 44444444444444444444444444444444-------------------------
        // 初始化开机播放设置列表
        innitWakeTable: function () {
            let _this = this;
            $(_this.$refs.wakeList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getWakeList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "11%"
                }, {
                    field: "room_info",
                    title: "包厢",
                    width: "10%",
                    formatter: function (value, row, index) {
                        if (row.use_all_room == '1') {
                            return '全部';
                        } else {
                            return row.room_info;
                        }
                    }
                }, {
                    field: "song_name",
                    title: "开机播放歌曲",
                    width: "10%"
                }, {
                    field: "time",
                    title: "操作时间",
                    width: "10%"
                }, {
                    title: "操作",
                    width: "10%",
                    events: {
                        'click .modify': function (e, value, row) {
                            _this.getWakeDetail(row);
                            _this.addWakeModify = 2;
                            _this.add_wake_header = '修改开机播放设置';
                            _this.showWake = false;
                            _this.showWakeSet = true;
                            _this.wakeVisible = false;
                        },
                        'click .delete': function (e, value, row) {
                            //debugger;
                            layer.confirm('删除后不可恢复，确定删除吗？', {
                                btn: ['确定', '取消'] //按钮
                            }, function () {
                                _this.deleteWake(row.id);
                            });
                        }
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue modify">修改</span>&nbsp;&nbsp;<span class="text-blue delete">删除</span>'
                    }
                }]
            });
        },
        // 获取开机播放设置列表
        getWakeList: function (params) {
            let _self = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getPowerOnSongsSettingList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _self);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 点击‘开机播放设置’
        add_wake: function () {
            this.addWakeModify = '1';
            this.add_wake_header = '开机播放设置';
            // 门店
            this.wakeShop = [];
            this.wakeVisible = true;
            this.innitWakeInput();
            this.wake_box_num = "";
            this.w_box_checkboxData = [];
            this.w_box_detCheckboxData = [];
            this.w_box_checkboxModel = [];

            this.showWake = false;
            this.showWakeSet = true;
            this.w_objClass = {
                selection_clear: true,
                visi_hid: false
            };
            $(this.$refs.wake_box_num).removeClass("canselect");
            this.wake_song_name = '';
            this.w_song_checkModel = '';
            this.songData = [];
            this.getSongsData('wake');
        },
        // 初始化门店输入框
        innitWakeInput: function () {
            let _this = this;
            let innitSuggest = function () {
                $(_this.$refs.wakeShop).html("");
                $(_this.$refs.wakeShop).select2({
                    data: _this.wakeShop,
                    minimumResultsForSearch: -1,
                    language: "zh-CN",
                    templateSelection: function (val) {
                        console.log('val', val);
                        if (val.id != '0') {
                            _this.wake_all_shops = '-1';
                            _this.w_box_allsel = '-1';
                            $(_this.$refs.wake_box_num).prop("disabled", false);
                            _this.wake_box_num = '';
                            _this.w_box_checkboxModel = [];
                            // 显示清除按钮
                            _this.w_objClass = {
                                visi_hid: false,
                                selection_clear: true
                            };
                            _this.getWakeBox(val.id);
                            return val.text
                        } else {
                            _this.wake_all_shops = '1';
                            _this.w_box_allsel = '1';
                            _this.wake_box_num = '全部';
                            _this.w_box_checkboxModel = [];
                            $(_this.$refs.wake_box_num).prop("disabled", true);
                            // 隐藏清除按钮
                            _this.w_objClass = {
                                visi_hid: true,
                                selection_clear: true
                            };
                            return val.text
                        }
                    }
                });
            };
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {

                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        $.each(data.response.result, function (k, v) {
                            _this.wakeShop.push({
                                id: v.id,
                                text: v.name
                            });
                        });
                        // _this.wakeShop.splice(0, 1);
                        innitSuggest();
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 点击选择包厢号
        wake_box_fun: function (e) {
            if (!$(e.currentTarget).hasClass('canselect')) {
                var _this = this;
                _this.w_c_box_checkboxModel = _this.w_box_checkboxModel;
                _this.showWakeSet = false;
                _this.w_showbox = true;
            }
        },
        // 包厢号数据
        getWakeBox: function (shopid) {
            var _this = this;
            var datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": shopid
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getAllRoomByArea",
                async: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        _this.w_box_checkboxData = data['response']['result'];
                        let newarray = [];
                        $.each(data['response']['result'], function (k, v) {
                            $.each(v.room, function (m, n) {
                                newarray.push(n);
                            });
                        });
                        _this.w_box_detCheckboxData = newarray;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) { }
            });
        },
        wBoxSubmit: function () {
            var _this = this;
            if (_this.w_box_allcheck) {
                _this.wake_box_num = '全部';
                _this.w_box_allsel = '1';
            } else {
                let texts = [];
                _this.w_box_detCheckboxData.forEach(function (item) {
                    _this.w_box_checkboxModel.forEach(function (item2) {
                        if (item.id == item2) {
                            texts.push(item.name);
                        }
                    });
                });
                _this.wake_box_num = texts.join(",");
                _this.w_box_allsel = '-1';
            }
            _this.showWakeSet = true;
            _this.w_showbox = false;
        },
        wBoxReturn: function () {
            this.showWakeSet = true;
            this.w_showbox = false;
            if (this.wake_box_num != "") {
                this.w_box_checkboxModel = this.w_c_box_checkboxModel;
                return;
            }
            this.w_box_checkboxModel = [];
        },
        // 清空包厢号
        w_clear_input: function () {
            this.wake_box_num = '';
            this.w_box_checkboxModel = '';
        },
        // 全选
        wBoxAllcheck: function () {
            var _this = this;
            _this.w_box_allcheck = _this.w_c_box_allcheck;
            if (!_this.w_box_allcheck) { // 实现全选
                _this.w_box_checkboxModel = [];
                _this.w_box_detCheckboxData.forEach(function (item) {
                    _this.w_box_checkboxModel.push(item.id);
                });
            } else { // 实现反选
                _this.w_box_checkboxModel = [];
            }
        },

        // 点击选择开机播放歌曲
        wake_song_fun: function () {
            let _this = this;
            let c_w_song_checkModel = _this.w_song_checkModel;
            layer.confirm('', {
                skin: 'add_printer_area',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['开机播放歌曲', true],
                area: ['700px', ''], // 宽高
                content: $(_this.$refs.wakeSong_alert),
                cancel: function () {
                    // 右上角关闭
                    if (_this.wake_song_name != "") {
                        _this.w_song_checkModel = c_w_song_checkModel;
                        return;
                    }
                    _this.w_song_checkModel = '';
                }
            }, function () {
                _this.songData.forEach(function (item) {
                    if (item.id == _this.w_song_checkModel) {
                        _this.wake_song_name = item.text;
                    }
                });
                layer.closeAll();
            }, function () {
                if (_this.wake_song_name != "") {
                    _this.w_song_checkModel = c_w_song_checkModel;
                    return;
                }
                _this.w_song_checkModel = '';
            });
        },

        // 新增/修改开机播放设置
        wakeSave: function (addWakeModify) {
            let _this = this;
            let wake_ids = [];
            if (_this.wake_box_num == '') {
                layer.msg('包厢号不能为空');
                return;
            } else {
                $.each(_this.w_box_checkboxModel, function (k, v) {
                    wake_ids.push(v);
                });
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": $(_this.$refs.wakeShop).val(),
                        "song_id": _this.w_song_checkModel,
                        "use_all_room": _this.w_box_allsel,
                        "room_ids": wake_ids,
                        "all_shops": _this.wake_all_shops
                    }
                },
                "comment": ""
            };
            if (addWakeModify == 2) {
                datas["request"]["param"]["shop_id"] = $(_this.$refs.wakeShopCg).attr('shopID');
                datas["request"]["param"]["id"] = _this.wake_item_id;
            }
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setPowerOnSongsSetting",
                async: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        layer.msg(data["response"]["error_msg"]);
                        $(_this.$refs.wakeList).bootstrapTable('destroy');
                        _this.innitWakeTable();
                        _this.showWake = true;
                        _this.showWakeSet = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        openWakeUpdsongs: function (e) {
            let _this = this;
            layer.confirm('', {
                skin: 'add_printer_area upload-songs',
                type: 1,
                btn: ['选择文件'], // 按钮
                title: ['上传歌曲', true],
                area: ['650px', ''], // 宽高
                content: $(_this.$refs.wake_upload_songs),
                cancel: function () {
                    // 右上角关闭
                    document.getElementById('ossfileWake').innerHTML = '';
                }
            });

            // _this.uploadNewSongWake();
        },
        // 上传开机播放歌曲
        uploadNewSongWake: function () {
            var _this = this;
            var accessid = '',
                accesskey = '',
                host = '',
                policyBase64 = '',
                signature = '',
                callbackbody = '',
                filename = '',
                key = '',
                expire = 0,
                g_object_name = '',
                g_object_name_type = 'local_name',  // 上传文件名字保持本地文件名字
                now = Date.parse(new Date()) / 1000;

            var body = '';
            function send_request() {
                var xmlhttp = null;
                if (window.XMLHttpRequest) {
                    xmlhttp = new XMLHttpRequest();
                } else if (window.ActiveXObject) {
                    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
                }
                if (xmlhttp != null) {
                    let datas = {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                // 'file': filename
                            }
                        },
                        "comment": ""
                    };
                    datas = JSON.stringify(datas);
                    $.ajax({
                        type: "POST",
                        dataType: "json",
                        url: Vue.ctUrl + "Setting/getOssSignature",
                        async: false,
                        crossDomain: true,
                        xhrFields: {
                            withCredentials: true
                        },
                        data: datas,
                        success: function (data) {
                            if (data['response']['result_code'] == "true") {
                                body = data.response.result.signature;
                                // g_object_name = data.response.result.file_name;
                            } else {
                                Vue.timeoutfun(data.response.result_status, _this);
                                layer.msg(data["response"]["error_msg"]);
                            }
                        },
                        error: function (err) {

                        }
                    });
                } else {
                    alert("Your browser does not support XMLHTTP.");
                }
            };

            function get_signature() {
                // 可以判断当前expire是否超过了当前时间,如果超过了当前时间,就重新取一下.3s 做为缓冲
                now = Date.parse(new Date()) / 1000;
                if (expire < now + 3) {
                    send_request();  // 返回签名
                    var obj = body;
                    host = obj['host'];
                    policyBase64 = obj['policy'];
                    accessid = obj['accessid'];
                    signature = obj['signature'];
                    expire = parseInt(obj['expire']);
                    callbackbody = obj['callback'];
                    key = obj['dir'];
                    return true;
                }
                return false;
            };

            function get_uploaded_object_name(filename) {
                let tmp_name = key + g_object_name
                tmp_name = tmp_name.replace("${filename}", filename);
                return tmp_name
            }

            function set_upload_param(up, filename, ret) {
                if (ret == false) {
                    ret = get_signature();
                }

                let new_multipart_params = {
                    'key': key + g_object_name,
                    'policy': policyBase64,
                    'OSSAccessKeyId': accessid,
                    'success_action_status': '200', // 让服务端返回200,不然，默认会返回204
                    'callback': callbackbody,
                    'signature': signature,
                };
                up.setOption({
                    'url': host,
                    'multipart_params': new_multipart_params
                });

                up.start();
            }

            function getFileName(filename) {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            'file': filename
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getFileName",
                    async: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function (data) {
                        if (data['response']['result_code'] == "true") {
                            g_object_name = data.response.result.file_name;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function (err) {

                    }
                });
            }

            var uploader = new plupload.Uploader({
                runtimes: 'html5,flash,silverlight,html4',
                browse_button: 'wakeSelFile',
                container: document.getElementById('uploadWrap'),
                flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
                silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
                url: Vue.ctUrl + "Setting/saveCustomSongsInfo",

                filters: {
                    mime_types: [ // 只允许上传mkv, mp4, avi文件
                        { title: "Video files", extensions: "mkv,mp4,avi" }
                    ],
                    max_file_size: '200mb', // 最大只能上传200mb的文件
                    prevent_duplicates: true // 不允许选取重复文件
                },

                init: {
                    PostInit: function () {
                        document.getElementById('ossfileWake').innerHTML = '';
                        document.getElementById('wakeSubFile').onclick = function () {
                            // let tagSel = document.getElementById('ossfileWake').getElementsByTagName('span');
                            // $.each(tagSel, function(k, v) {
                            //     set_upload_param(uploader, $(tagSel)[k].innerHTML, false);
                            // });
                            set_upload_param(uploader, '', false);
                            return false;
                        };
                    },

                    FilesAdded: function (up, files) {
                        plupload.each(files, function (file) {
                            document.getElementById('ossfileWake').innerHTML += '<div id="' + file.id + '"><span>' + file.name + '</span> (' + plupload.formatSize(file.size) + ')<b></b>'
                                + '<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>'
                                + '</div>';

                            // 获取视频分辨率并检查
                            const url = URL.createObjectURL(file.getNative());
                            const video = document.createElement('video');

                            // 添加处理状态标志
                            let isHandled = false;

                            // 安全地移除DOM元素和文件的函数
                            const safeRemove = (message) => {
                                if (isHandled) return; // 如果已经处理过，直接返回
                                isHandled = true;      // 标记为已处理

                                const element = document.getElementById(file.id);
                                if (element) {
                                    element.remove();
                                }
                                if (up.getFile(file.id)) {
                                    up.removeFile(file);
                                }
                                URL.revokeObjectURL(url);

                                if (message) {
                                    layer.msg(message);
                                }
                            };

                            // 添加错误处理
                            video.onerror = function () {
                                // 视频加载失败，移除文件
                                safeRemove('无法获取视频信息，请检查视频格式是否正确');
                            };

                            // 添加超时处理
                            const timeoutId = setTimeout(() => {
                                // 如果3秒内没有获取到元数据，就认为视频无效
                                video.onerror = null; // 清除错误处理
                                safeRemove('无法获取视频分辨率信息，请检查视频分辨率是否超过限制');
                            }, 3000);

                            video.onloadedmetadata = function () {
                                clearTimeout(timeoutId); // 清除超时计时器

                                let width = video.videoWidth;
                                let height = video.videoHeight;
                                console.log('原始分辨率:', width, height);

                                // 检查是否成功获取到宽高
                                if (!width || !height) {
                                    // 获取不到宽高，当作超过限制处理
                                    safeRemove('无法获取视频分辨率，请检查视频分辨率是否超过限制');
                                    return;
                                }

                                // 处理非方形像素的情况
                                if (video.videoWidth > 1920 && video.videoHeight <= 1080) {
                                    width = Math.round((1920 * video.videoHeight) / 1080);
                                }

                                console.log('计算后分辨率:', width, height);

                                // 检查分辨率 - 区分横屏竖屏
                                let isValid = false;
                                if (width >= height) {
                                    // 横屏视频：宽度不超过1920，高度不超过1080
                                    isValid = width <= 1920 && height <= 1080;
                                } else {
                                    // 竖屏视频：宽度不超过1080，高度不超过1920
                                    isValid = width <= 1080 && height <= 1920;
                                }

                                if (!isValid) {
                                    safeRemove('视频分辨率超出限制：横屏不超过1920x1080，竖屏不超过1080x1920');
                                } else {
                                    // 显示合法分辨率
                                    const element = document.getElementById(file.id);
                                    if (element) {
                                        const span = element.getElementsByTagName('span')[0];
                                        if (span) {
                                            span.innerHTML += ` [${width}x${height}]`;
                                        }
                                    }
                                    URL.revokeObjectURL(url);
                                }
                            };

                            video.src = url;
                        });
                    },

                    BeforeUpload: function (up, file) {
                        getFileName(file.name);
                        set_upload_param(up, '', true);
                    },

                    UploadProgress: function (up, file) {
                        var d = document.getElementById(file.id);
                        d.getElementsByTagName('b')[0].innerHTML = '<span>' + file.percent + "%</span>";
                        var prog = d.getElementsByTagName('div')[0];
                        var progBar = prog.getElementsByTagName('div')[0]
                        progBar.style.width = 5 * file.percent + 'px';
                        progBar.setAttribute('aria-valuenow', file.percent);
                    },

                    FileUploaded: function (up, file, info) {
                        if (info.status == 200) {
                            let finalPath = get_uploaded_object_name(file.name);
                            // 保存上传的文件信息
                            let datas = {
                                "header": Vue.request_header,
                                "request": {
                                    "param": {
                                        "song_down_file": finalPath, // 文件存储路径
                                        "song_name": g_object_name // 文件名
                                    }
                                },
                                "comment": ""
                            };
                            datas = JSON.stringify(datas);
                            $.ajax({
                                type: "POST",
                                dataType: "json",
                                url: Vue.ctUrl + "Setting/saveCustomSongsInfo",
                                async: true,
                                crossDomain: true,
                                xhrFields: {
                                    withCredentials: true
                                },
                                data: datas,
                                success: function (data) {
                                    if (data['response']['result_code'] == "true") {
                                        layer.msg('上传成功');
                                        _this.getSongsData('wake');
                                    } else {
                                        Vue.timeoutfun(data.response.result_status, _this);
                                        layer.msg(data["response"]["error_msg"]);
                                    }
                                },
                                error: function (err) {

                                }
                            });

                        } else {
                            document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = info.response;
                        }
                    },

                    Error: function (up, err) {
                        if (err.code == -600) {
                            layer.msg('请选择200mb以内的文件');
                        } else if (err.code == -601) {
                            layer.msg('只允许上传mkv/mp4/avi文件');
                        } else if (err.code == -602) {
                            layer.msg('这个文件已经上传过一遍了');
                        } else {
                            layer.msg(err.response);
                        }
                    }
                }
            });

            uploader.init();
        },

        getWakeDetail: function (row) {
            let _this = this;

            // 门店
            $(_this.$refs.wakeShopCg).text(row.shop_name);
            $(_this.$refs.wakeShopCg).attr('shopID', row.shop_id);
            // 包厢号
            _this.l_objClass = {
                selection_clear: true,
                visi_hid: true
            };
            if (row.use_all_room == 1) {
                _this.wake_box_num = '全部';
                _this.w_box_allsel = row.use_all_room;
            } else {
                _this.wake_box_num = row.room_info;
                _this.w_box_allsel = row.use_all_room;
            }
            _this.w_box_checkboxModel = row.room_ids;
            $(_this.$refs.wake_box_num).addClass("canselect");
            // 开机播放歌曲
            _this.songData = [];
            _this.getSongsData('wake');
            _this.w_song_checkModel = row.songs_id;
            _this.wake_song_name = row.song_name;
            // id
            _this.wake_item_id = row.id;
        },
        // 删除开机播放设置
        deleteWake: function (id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "id": id
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/delPowerOnSongsSetting",
                async: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        layer.msg(data["response"]["error_msg"]);
                        $(_this.$refs.wakeList).bootstrapTable('destroy');
                        _this.innitWakeTable();
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {

                }
            });
        },



        // 555555555555555555555555-------------------------
        // 获取门店数据
        getBxShopData: function () {
            let _this = this;

            let shopDatas = [];
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {}
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        $.each(data.response.result, function (k, v) {
                            shopDatas.push({ id: v.id, text: v.name });
                        });
                        // shopDatas.shift();
                        _this.bx_shop_list = shopDatas;
                        _this.bx_form.shop_id = shopDatas[0].id;
                        if (_this.bx_form.shop_id != 0) {
                            _this.getRoomArea(_this.bx_form.shop_id);
                            _this.getRoomTypes(_this.bx_form.shop_id);
                        }
                        _this.getBoxSetList(1)

                        // $(_this.$refs.bx_shop).select2({
                        //     data: shopDatas,
                        //     allowClear: true,
                        //     minimumResultsForSearch: -1,
                        //     language: "zh-CN"
                        // });
                        // $(_this.$refs.bx_shop).val(shopDatas[1].id).trigger('change');
                        // $(_this.$refs.bxList).bootstrapTable('destroy');
                        // _this.innitBxTable();

                        // shopDatas.shift();
                        $(_this.$refs.bxShop).select2({
                            data: shopDatas,
                            minimumResultsForSearch: -1,
                            language: "zh-CN",
                            width: '100%'
                        }).on("select2:select", function (e) {
                            if (e.params.data.id != 0) {
                                _this.getBoxNum(e.params.data.id);
                                $(_this.$refs.edit_box).prop('disabled', false);
                            } else {
                                $(_this.$refs.edit_box).prop('disabled', true);
                                _this.edit_box = '';
                                _this.box_item = [];
                            }
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        // 门店切换
        onBxShopChange(val) {
            this.bx_form.room_area = [];
            this.bx_form.room_type = [];
            if (val != 0) {
                this.getRoomArea(val);
                this.getRoomTypes(val);
            }
        },

        // 获取包厢区域
        getRoomArea: function (shop_id) {
            const _this = this;
            Vue.axios.post('Shop/getRoomArea', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": shop_id
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        _this.room_area_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
        },

        // 打开包厢区域选择弹窗
        openRoomAreaPop() {
            let _this = this
            let c_room_area = _this.bx_form.room_area
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['选择包厢区域', true],
                area: ['450px', ''], // 宽高
                content: $(_this.$refs.room_area_pop),
                cancel: function () {
                    _this.bx_form.room_area = c_room_area
                }
            }, function () {
                layer.closeAll()
            }, function () {
                _this.bx_form.room_area = c_room_area
                layer.closeAll()
            });
        },

        // 包厢区域全选
        handleCheckAllRoomAreaChange(val) {
            this.bx_form.room_area = []
            this.checkAllRoomArea = val
            if (val) {
                this.room_area_list.forEach(item => {
                    this.bx_form.room_area.push(item.id)
                })
            }
        },

        // 选择包厢区域
        handleCheckRoomAreaChange(val) {
            this.checkAllRoomArea = val.length === this.room_area_list.length
        },

        // 打开包厢类型选择弹窗
        openBxRoomTypePop() {
            let _this = this
            let c_room_type = _this.bx_form.room_type
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['选择包厢类型', true],
                area: ['450px', ''], // 宽高
                content: $(_this.$refs.room_type_pop),
                cancel: function () {
                    _this.bx_form.room_type = c_room_type
                }
            }, function () {
                layer.closeAll()
            }, function () {
                _this.bx_form.room_type = c_room_type
                layer.closeAll()
            });
        },

        // 包厢类型全选
        handleCheckAllRoomTypeChange(val) {
            this.bx_form.room_type = []
            this.checkAllRoomType = val
            if (val) {
                this.room_type_list.forEach(item => {
                    this.bx_form.room_type.push(item.id)
                })
            }
        },

        // 选择包厢类型
        handleCheckRoomTypeChange(val) {
            this.checkAllRoomType = val.length === this.room_type_list.length
        },

        // 点击列表“修改”
        onBoxSetTableModify(row) {
            this.bx_pac_lists = [];
            this.bx_rm_lists = [];
            this.bx_djp_lists = [];
            this.addBxModify = 2;
            this.add_bx_header = '修改包厢配置';
            this.showBx = false;
            this.showBxSet = true;
            this.getBxDetail(row);
        },

        // 点击列表“复制新增”
        onBoxSetTableCopyAdd(row) {
            this.bx_pac_lists = [];
            this.bx_rm_lists = [];
            this.bx_djp_lists = [];
            this.addBxModify = 3;
            this.add_bx_header = '复制新增包厢配置';
            this.showBx = false;
            this.showBxSet = true;
            this.getBxDetail(row);
        },

        // 点击列表“删除”
        onBoxSetTableDelete(row) {
            let _this = this;
            layer.confirm('删除后不可恢复，确定删除吗？', {
                btn: ['确定', '取消']
            }, function () {
                _this.deleteBx(row.id);
            });
        },

        // 初始化包厢配置列表
        // innitBxTable: function() {
        //     let _this = this;
        //     $(_this.$refs.bxList).bootstrapTable({
        //         pageNumber: 1,
        //         pageSize: 10,
        //         pageList: [],
        //         pagination: true,
        //         ajax: function(params) {
        //             _this.getBxList(params);
        //         },
        //         sidePagination: "server",
        //         columns: [{
        //             field: "shop_name",
        //             title: "门店",
        //             width: "11%"
        //         }, {
        //             field: "room_name",
        //             title: "包厢",
        //             width: "8%"
        //         }, {
        //             field: "setting_info",
        //             title: "配置内容",
        //             width: "10%",
        //             formatter: function(value, row, index) {
        //                 if(value.length > 30) {
        //                     return value.slice(0, 30) + '...';
        //                 } else {
        //                     return value;
        //                 }
        //             }
        //         }, {
        //             title: "操作",
        //             width: "8%",
        //             events: {
        //                 'click .modify': function(e, value, row) {
        //                     _this.bx_pac_lists = [];
        //                     _this.bx_rm_lists = [];
        //                     _this.bx_djp_lists = [];
        //                     _this.getBxDetail(row);
        //                     _this.addBxModify = 2;
        //                     _this.add_bx_header = '修改包厢配置';
        //                     _this.showBx = false;
        //                     _this.showBxSet = true;
        //                 },
        //                 'click .delete': function(e, value, row) {
        //                     //debugger;
        //                     layer.confirm('删除后不可恢复，确定删除吗？', {
        //                         btn: ['确定', '取消'] //按钮
        //                     }, function() {
        //                         _this.deleteBx(row.id);
        //                     });
        //                 }
        //             },
        //             formatter: function(value, row, index) {
        //                 return '<span class="text-blue modify">修改</span>&nbsp;&nbsp;<span class="text-blue delete">删除</span>'
        //             }
        //         }]
        //     });
        // },
        // 获取包厢配置列表
        getBoxSetList: function (page) {
            let _self = this
            this.box_set_page = page;
            this.loading = true;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": page,
                        "page_size": _self.box_set_page_size,
                        "shop_id": _self.bx_form.shop_id,
                        "room_area": _self.bx_form.room_area,
                        "room_type": _self.bx_form.room_type,
                        "room_name": _self.bx_form.room_name
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getRoomSettingList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        if (page == 1) {
                            _self.box_set_total = Number(data.response.result.count);
                        }
                        _self.box_set_list = data.response.result.data;
                        _self.loading = false
                    } else {
                        Vue.timeoutfun(data.response.result_status, _self);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 点击“批量修改"
        onMultModifyBoxClick() {
            let _this = this;
            if (this.mult_set_room.length == 0) {
                layer.msg('请选择要修改的包厢');
                return false;
            }

            let ids = [];
            this.mult_set_room.forEach(item => {
                ids.push(item.id);
            });
            _this.mult_box_set_form = {
                shop_id: _this.bx_form.shop_id,
                ids: ids,
                pac_setting: [''],
                room_setting: [''],
                dajianpan_setting: ['']
            }
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['批量修改', true],
                area: ['600px', ''], // 宽高
                content: $(_this.$refs.mult_set_pop),
            }, function () {
                // 检查mult_box_set_for设置项是否是空字符项
                let pacEmpty = _this.mult_box_set_form.pac_setting.every(item => item === '');
                let roomEmpty = _this.mult_box_set_form.room_setting.every(item => item === '');
                let dajianpanEmpty = _this.mult_box_set_form.dajianpan_setting.every(item => item === '');
                if (pacEmpty) {
                    _this.mult_box_set_form.pac_setting = [];
                }
                if (roomEmpty) {
                    _this.mult_box_set_form.room_setting = [];
                }
                if (dajianpanEmpty) {
                    _this.mult_box_set_form.dajianpan_setting = [];
                }

                Vue.axios.post('Setting/batchSetRoomSetting', {
                    "header": Vue.request_header,
                    "request": {
                        "param": _this.mult_box_set_form
                    },
                    "comment": ""
                })
                    .then(res => {
                        if (res.data.response.result_code == "true") {
                            layer.closeAll();
                            layer.msg('修改成功');
                            _this.getBoxSetList(_this.box_set_page);
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
            });
        },

        // 选择列表包厢
        onBoxSetTableSelect(val) {
            this.mult_set_room = val;
        },

        // 更新批量修改配置
        updateMultSet(type, index, val) {
            const newSetting = [...this.mult_box_set_form[type]];
            newSetting[index] = val;
            this.mult_box_set_form[type] = newSetting;
        },

        // 新增批量修改配置
        addMultSet(type) {
            this.mult_box_set_form[type].push('');
        },

        // 删除批量修改配置
        delMultSet(index, type) {
            this.mult_box_set_form[type].splice(index, 1);
        },

        // 查询
        clkBxQuery: function () {
            this.getBoxSetList(1);
        },

        // 点击‘新增包厢配置’
        add_bx: function () {
            this.add_bx_header = '新增包厢配置';
            // 门店
            $(this.$refs.bxShop).val('').trigger('change');
            $(this.$refs.bxShop).prop('disabled', false);
            // 包厢号
            // this.getBoxNum($(this.$refs.bxShop).val());
            $(this.$refs.edit_box).prop('disabled', true);
            this.edit_box = '';
            this.box_item = [];
            this.bx_pac = '';
            this.bx_rm = "";
            this.bx_djp = "";
            this.bx_pac_lists = [];
            this.bx_rm_lists = [];
            this.bx_djp_lists = [];
            this.bx_room_checkboxdata = [];
            this.bx_room_checkboxModel = '';
            this.bx_room_detailcheckboxdata = [];
            this.showBx = false;
            this.showBxSet = true;
            this.addBxModify = 1;
        },

        // 点击选择包厢号
        editBoxFun: function () {
            this.c_box_item = this.box_item;
            this.showBxSet = false;
            this.showBox = true;
        },
        // 包厢号数据
        getBoxNum: function (shop_id) {
            let _this = this;

            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": shop_id
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getAllRoomByArea",
                async: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        _this.box_arr = data['response']['result'];
                        let newarray = [];
                        $.each(data['response']['result'], function (k, v) {
                            $.each(v.room, function (m, n) {
                                newarray.push(n);
                            });
                        });
                        _this.box_arr_det = newarray;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) { }
            });
        },
        // 全选
        boxAll: function () {
            let _this = this;
            _this.box_all = _this.c_box_all;
            if (!_this.box_all) { // 实现全选
                _this.box_item = [];
                _this.box_arr_det.forEach(function (item) {
                    _this.box_item.push(item.id);
                });
            } else { // 实现反选
                _this.box_item = [];
            }
        },
        // 楼层全选/反选
        boxFloor: function (id, index) {
            let _this = this;

            _this.box_floor = _this.c_box_floor;
            if (_this.box_floor.indexOf(id) == -1) {
                $.each(_this.box_arr[index].room, function (k, v) {
                    if (_this.box_item.indexOf(v.id) == -1) {
                        _this.box_item.push(v.id);
                    }
                });
            } else {
                $.each(_this.box_arr[index].room, function (k, v) {
                    let index = '';
                    index = _this.box_item.indexOf(v.id);
                    if (index != -1) {
                        _this.box_item.splice(index, 1);
                    }
                });
            }
        },
        // 清空包厢
        clearInput: function (name) {
            this.edit_box = '';
            this.box_item = [];
        },
        // 确定包厢
        saveBox: function () {
            const _this = this;

            let texts = [];
            if (_this.box_item.length >= _this.box_arr_det.length) {
                _this.edit_box = '全部';
            } else {
                _this.box_arr_det.forEach(function (item) {
                    _this.box_item.forEach(function (sub) {
                        if (item.id == sub) {
                            texts.push(item.name);
                        }
                    });
                });
                _this.edit_box = texts.join(",");
            }
            _this.showBxSet = true;
            _this.showBox = false;
        },
        // 返回
        boxBackEdit: function () {
            this.box_item = this.c_box_item;
            this.showBxSet = true;
            this.showBox = false;
        },
        // 新增pac
        addBxPac: function () {
            this.bx_pac_lists.push({ 'pac_model': '' });
        },
        // 删除pac
        delBxPac: function (index) {
            let _this = this;
            layer.confirm('删除后无法清除包厢已经生效的配置，如果想要配置不生效请重新配置', {
                btn: ['确定', '取消']
            }, function () {
                _this.bx_pac_lists.splice(index, 1);
                layer.closeAll();
            });
        },
        // 新增rm
        addBxRm: function () {
            this.bx_rm_lists.push({ 'rm_model': '' });
        },
        // 删除rm
        delBxRm: function (index) {
            let _this = this;
            layer.confirm('删除后无法清除包厢已经生效的配置，如果想要配置不生效请重新配置', {
                btn: ['确定', '取消']
            }, function () {
                _this.bx_rm_lists.splice(index, 1);
                layer.closeAll();
            });
        },
        // 新增djp
        addBxDjp: function () {
            this.bx_djp_lists.push({ 'djp_model': '' });
        },
        // 删除djp
        delBxDjp: function (index) {
            let _this = this;
            layer.confirm('删除后无法清除包厢已经生效的配置，如果想要配置不生效请重新配置', {
                btn: ['确定', '取消']
            }, function () {
                _this.bx_djp_lists.splice(index, 1);
                layer.closeAll();
            });
        },
        // 保存新增/修改的包厢配置
        bxSave: function (addBxModify) {
            const _this = this;

            let room_id = '0';
            if (_this.edit_box != '全部') {
                room_id = _this.box_item.join(',');
            }
            let pac_setting = [],
                room_setting = [],
                dajianpan_setting = [];
            if (_this.bx_pac != '') {
                pac_setting.push(_this.bx_pac);
            }
            if (_this.bx_rm != '') {
                room_setting.push(_this.bx_rm);
            }
            if (_this.bx_djp != '') {
                dajianpan_setting.push(_this.bx_djp);
            }
            $.each(_this.bx_pac_lists, function (k, v) {
                pac_setting.push(v.pac_model);
            });
            $.each(_this.bx_rm_lists, function (k, v) {
                room_setting.push(v.rm_model);
            });
            $.each(_this.bx_djp_lists, function (k, v) {
                dajianpan_setting.push(v.djp_model);
            });
            // room配置验证
            if (room_setting.length > 0) {
                let isTrue = true
                room_setting.forEach(v => {
                    if (!v.match(/=/g) || v.match(/=/g).length > 1) {
                        isTrue = false
                    }
                })
                if (!isTrue) {
                    layer.open({
                        type: 1,
                        skin: 'public-alert-skin',
                        title: 'room配置错误',
                        area: ['500px', ''],
                        content: $(this.$refs.bxRoomErr)
                    });
                    return false
                }
            }

            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": $(_this.$refs.bxShop).val(),
                        "room_id": room_id,
                        "pac_setting": pac_setting,
                        "room_setting": room_setting,
                        "dajianpan_setting": dajianpan_setting
                    }
                },
                "comment": ""
            };
            if (addBxModify == 2) {
                datas["request"]["param"]["id"] = _this.theBxDetail;
            }
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setRoomSetting",
                async: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas
                },
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        layer.msg(data["response"]["error_msg"]);
                        $(_this.$refs.bxList).bootstrapTable('destroy');
                        // _this.innitBxTable();
                        if (addBxModify != 2) {
                            _this.box_set_page = 1
                        }
                        _this.getBoxSetList(_this.box_set_page);
                        _this.showBx = true;
                        _this.showBxSet = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        getBxDetail: function (row) {
            let _this = this;
            // 门店
            $(_this.$refs.bxShop).val(row.shop_id).trigger('change');
            $(_this.$refs.bxShop).prop('disabled', true);
            // 包厢号
            if ($(_this.$refs.bxShop).val() != '0') { // 非全部门店
                _this.getBoxNum($(_this.$refs.bxShop).val());
            }
            if (_this.addBxModify == 2) {
                _this.edit_box = row.room_name;
                _this.box_item = [row.room_id];
                $(_this.$refs.edit_box).prop('disabled', true);
            } else if (_this.addBxModify == 3) {
                _this.edit_box = '';
                _this.box_item = [];
                $(_this.$refs.edit_box).prop('disabled', false);
            }
            // pac
            $.each(row.pac_setting, function (k, v) {
                if (k == 0) {
                    _this.bx_pac = v;
                } else {
                    _this.bx_pac_lists.push({ 'pac_model': v });
                }
            });
            // room
            $.each(row.room_setting, function (k, v) {
                if (k == 0) {
                    _this.bx_rm = v;
                } else {
                    _this.bx_rm_lists.push({ 'rm_model': v });
                }
            });
            // djp
            $.each(row.dajianpan_setting, function (k, v) {
                if (k == 0) {
                    _this.bx_djp = v;
                } else {
                    _this.bx_djp_lists.push({ 'djp_model': v });
                }
            });

            _this.theBxDetail = row.id;
        },
        // 删除包厢配置
        deleteBx: function (id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "id": id
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/delRoomSetting",
                async: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        layer.msg(data["response"]["error_msg"]);
                        _this.getBoxSetList(_this.box_set_page);
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {

                }
            });
        },
        // 页面提示语
        openRmHint: function () {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {}
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getRoomIniParams",
                async: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.room_ini_params = data.response.result.room_ini_params
                        // layer.open({
                        //     type: 1,
                        //     title: '',
                        //     area: ['700px', '500px'],
                        //     content: $(_this.$refs.bxRmHint)
                        // });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 修改room配置内容
        changeRoomSetInput: function (e) {
            let value = e.target.value;
            if (!value) {
                // 如果value为空,恢复原始文本
                $('.init-params-explain pre').each(function () {
                    $(this).html($(this).text());
                });
                return;
            }

            $('.init-params-explain pre').each(function () {
                let text = $(this).text();
                let index = text.indexOf(value);
                if (index !== -1) {
                    // 将文本分成三部分:value之前、value本身、value之后
                    let before = text.substring(0, index);
                    let after = text.substring(index + value.length);
                    // 使用mark标签包裹value
                    $(this).html(before + '<mark>' + value + '</mark>' + after);

                    // 滚动到mark标签位置
                    $(this).find('mark')[0].scrollIntoView({
                        behavior: 'smooth', // 平滑滚动
                        block: 'center'     // 尽量滚动到视窗中间
                    });

                    return false; // 找到第一个匹配就退出循环
                } else {
                    $(this).html($(this).text());
                }
            });
        },



        /*
         * 息屏背景自定义设置
         */
        // 列表
        xbzTable: function (page) {
            const _this = this

            _this.loading = true
            _this.xbz_page = page
            Vue.axios.post('setting/getScreenLockedResourcesList', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "page": page,
                        "page_size": _this.GLOBAL.PAGESIZE
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        if (page == 1) {
                            _this.xbz_total = Number(res.data.response.result.total);
                        }
                        _this.xbz_table = res.data.response.result.rows;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },
        // 删除
        xbzDel(id) {
            const _this = this;

            layer.confirm('删除后不可恢复，确定删除吗？', {
                btn: ['确定', '取消']
            }, function () {
                Vue.axios.post('setting/delScreenLockedResourcesData', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                })
                    .then(res => {
                        if (res.data.response.result_code == "true") {
                            layer.msg('删除成功');
                            _this.xbzTable(_this.xbz_page);
                            _this.getUnsetShop();
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
            });
        },
        getUnsetShop() {
            const _this = this

            Vue.axios.post('Setting/getUnsetScreenLockedShopList', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {}
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        _this.unset_shop_list = res.data.response.result
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this)
                        layer.msg(res.data.response.error_msg)
                    }
                })
                .catch(err => {
                    layer.msg('出错啦')
                })
        },
        // 点击新增
        xbzAdd() {
            this.xbz_edit_id = ''
            this.xbz_edit_tit = '新增'
            this.xbz_edit_shop_id = ''
            this.xbz_edit_img = require('../../assets/images/upload_btn.png')
            this.xbz_edit_img_done = false
            this.showXbzList = false
        },
        // 点击修改
        xbzModify(row) {
            const _this = this
            this.xbz_edit_id = row.id
            this.xbz_edit_tit = '修改'
            this.xbz_edit_shop_id = row.shop_id
            this.xbz_edit_shop_name = row.shop_name
            this.xbz_edit_img = row.img
            this.xbz_edit_img_done = true
            this.showXbzList = false
        },
        // 背景图
        xbzUpload: function () {
            if (this.xbz_edit_img_uploaders.length > 0) {
                this.xbz_edit_img_uploaders.forEach(item => {
                    item.destroy()
                })
                this.xbz_edit_img_uploaders = []
            }
            let _this = this;
            let host = '',
                dir = '',
                file_name = '';

            setTimeout(function () {
                // 实例化一个plupload上传对象
                let uploader = new plupload.Uploader({
                    browse_button: 'xbzEditImg', // 选择文件id
                    filters: {
                        mime_types: [ // 文件格式限制
                            { title: "Image files", extensions: "jpg,jpeg,png,gif" }
                        ],
                        // max_file_size: '2mb', // 文件大小限制
                        // prevent_duplicates: true // 不允许选取重复文件
                    },
                    // resize: {
                    //  width: 527,
                    //  height: 296
                    // },
                    multi_selection: false, // 单选
                    url: './', // OSS地址
                    init: {
                        // 文件上传前触发
                        BeforeUpload: function (up, file) { },
                        // 文件选择完毕触发
                        FilesAdded: function (up, files) {
                            // 获取签名
                            Vue.axios.post('publicData/api_getOssSignature', {
                                "header": Vue.request_header,
                                "request": {
                                    "version": Vue.version,
                                    "param": {
                                        "file": files[0].name,
                                        "path": 'system_set'
                                    }
                                },
                                "comment": ""
                            })
                                .then(res => {
                                    if (res.data.response.result_code == "true") {
                                        host = res.data.response.data.host;
                                        dir = res.data.response.data.dir;
                                        file_name = res.data.response.data.file_name;
                                        const new_params = {
                                            'key': dir + file_name,
                                            'OSSAccessKeyId': res.data.response.data.accessid,
                                            'policy': res.data.response.data.policy,
                                            'signature': res.data.response.data.signature,
                                            'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
                                        };
                                        up.setOption({
                                            'url': host,
                                            'multipart_params': new_params
                                        });

                                        // 上传文件
                                        uploader.start();
                                    } else {
                                        Vue.timeoutfun(data.response.result_status, _this);
                                        layer.msg(data.response.error_msg);
                                    }
                                })
                                .catch(err => {
                                    layer.msg("出错啦");
                                });
                        },
                        // 文件上传成功触发
                        FileUploaded: function (up, file, data) {
                            _this.xbz_edit_img = host + "/" + dir + file_name
                            _this.xbz_edit_img_done = true
                        },
                        // 错误提示
                        Error: function (up, err) {
                            if (err.code == -600) {
                                layer.msg('请选择2mb以内的文件');
                            } else if (err.code == -601) {
                                layer.msg('只允许上传jpg,jpeg,png,gif文件');
                            } else if (err.code == -602) {
                                layer.msg('这个文件已经上传过一遍了');
                            } else {
                                layer.msg(err.response);
                            }
                        }
                    }
                });
                // 初始化
                uploader.init();
                _this.xbz_edit_img_uploaders.push(uploader)
            }, 20);
        },
        // 新增、修改
        xbzEdit() {
            const _this = this;

            if (!_this.xbz_edit_shop_id) {
                layer.msg('请选择门店')
                return false
            }
            if (!_this.xbz_edit_img_done) {
                layer.msg('请上传背景图')
                return false
            }
            let url = 'setting/addScreenLockedResourcesData'
            let data = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": _this.xbz_edit_shop_id,
                        "img": _this.xbz_edit_img,
                    }
                },
                "comment": ""
            };
            if (_this.xbz_edit_id) {
                data.request.param.id = _this.xbz_edit_id
                url = 'setting/editScreenLockedResourcesData'
            }
            Vue.axios({
                method: 'post',
                url: url,
                data: data
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg('操作成功')
                        _this.xbzTable(_this.xbz_page)
                        _this.showXbzList = true
                        _this.getUnsetShop()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },


        /************************** 包厢火警通知图配置 ************************/
        // 获取门店数据
        getShopList: function () {
            let _this = this;

            let shopDatas = [];
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {}
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        let shops = data.response.result
                        shops.shift()
                        _this.fireShopList = shops
                        _this.fire_shop = _this.fireShopList[0].id
                        // 包厢号
                        _this.getBoxNum(_this.fire_shop);
                        _this.getFireAlarmList(1)
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        // 切换门店
        onShopChange(val) {
            this.fire_shop = val
            this.getBoxNum(this.fire_shop)
        },

        // 获取列表
        getFireAlarmList(page) {
            const _this = this

            _this.loading = true
            _this.fire_page = page
            Vue.axios.post('Setting/getRoomFireWarningList', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "page": page,
                        "page_size": _this.GLOBAL.PAGESIZE,
                        "shop_id": _this.fire_shop
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        if (page == 1) {
                            _this.fire_total = Number(res.data.response.result.count);
                        }
                        _this.fire_table = res.data.response.result.data;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },

        // 点击“删除”
        fireDel(id) {
            const _this = this;

            layer.confirm('删除后不可恢复，确定删除吗？', {
                btn: ['确定', '取消']
            }, function () {
                Vue.axios.post('Setting/delRoomFireWarning', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                })
                    .then(res => {
                        if (res.data.response.result_code == "true") {
                            layer.msg('删除成功');
                            _this.getFireAlarmList(_this.fire_page)
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
            });
        },

        // 点击“修改”
        fireModify(row) {
            this.add_fire_form = {
                id: row.id,
                shop_id: row.shop_id,
                room_ids: row.room_ids,
                room_str: row.room_str,
                img_url: row.img_url,
            }
            if (row.room_ids.length == 1 && row.room_ids[0] == '-1') { // 全选
                this.box_all = true
                this.box_item = []
                this.box_arr_det.forEach(item => {
                    this.box_item.push(item.id)
                })
            } else {
                this.box_item = row.room_ids
            }
            this.showFireAddPanel = true
        },

        // 点击“新增设置”
        fireAdd() {
            this.add_fire_form = {
                id: '',
                shop_id: this.fire_shop,
                room_ids: '',
                room_str: '',
                img_url: '',
            }
            this.box_all = false
            this.box_item = []
            this.showFireAddPanel = true
        },

        // 打开适用包厢选择页面
        openRoomPanel() {
            this.showFireBox = true
        },

        // 保存选择的包厢
        saveFireBox() {
            const _this = this;

            let texts = [];
            if (_this.box_item.length >= _this.box_arr_det.length) {
                _this.add_fire_form.room_str = '全部';
            } else {
                _this.box_arr_det.forEach(function (item) {
                    _this.box_item.forEach(function (sub) {
                        if (item.id == sub) {
                            texts.push(item.name);
                        }
                    });
                });
                _this.add_fire_form.room_str = texts.join(",");
            }
            _this.showFireBox = false;
        },

        fireImgUpload: function () {
            if (this.fire_img_uploaders.length > 0) {
                this.fire_img_uploaders.forEach(item => {
                    item.destroy()
                })
                this.fire_img_uploaders = []
            }
            let _this = this;
            let host = '',
                dir = '',
                file_name = '';

            // 实例化一个plupload上传对象
            let uploader = new plupload.Uploader({
                browse_button: 'fire-img-wrapper', // 选择文件id
                filters: {
                    mime_types: [ // 文件格式限制
                        { title: "Image files", extensions: "jpg,jpeg,png,gif" }
                    ],
                    // max_file_size: '2mb', // 文件大小限制
                    // prevent_duplicates: true // 不允许选取重复文件
                },
                // resize: {
                //  width: 527,
                //  height: 296
                // },
                multi_selection: false, // 单选
                url: './', // OSS地址
                init: {
                    // 文件上传前触发
                    BeforeUpload: function (up, file) { },
                    // 文件选择完毕触发
                    FilesAdded: function (up, files) {
                        // 获取签名
                        Vue.axios.post('publicData/api_getOssSignature', {
                            "header": Vue.request_header,
                            "request": {
                                "version": Vue.version,
                                "param": {
                                    "file": files[0].name,
                                    "path": 'system_set'
                                }
                            },
                            "comment": ""
                        })
                            .then(res => {
                                if (res.data.response.result_code == "true") {
                                    host = res.data.response.data.host;
                                    dir = res.data.response.data.dir;
                                    file_name = res.data.response.data.file_name;
                                    const new_params = {
                                        'key': dir + file_name,
                                        'OSSAccessKeyId': res.data.response.data.accessid,
                                        'policy': res.data.response.data.policy,
                                        'signature': res.data.response.data.signature,
                                        'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
                                    };
                                    up.setOption({
                                        'url': host,
                                        'multipart_params': new_params
                                    });

                                    // 上传文件
                                    uploader.start();
                                } else {
                                    Vue.timeoutfun(data.response.result_status, _this);
                                    layer.msg(data.response.error_msg);
                                }
                            })
                            .catch(err => {
                                layer.msg("出错啦");
                            });
                    },
                    // 文件上传成功触发
                    FileUploaded: function (up, file, data) {
                        _this.add_fire_form.img_url = host + "/" + dir + file_name
                    },
                    // 错误提示
                    Error: function (up, err) {
                        if (err.code == -600) {
                            layer.msg('请选择2mb以内的文件');
                        } else if (err.code == -601) {
                            layer.msg('只允许上传jpg,jpeg,png,gif文件');
                        } else if (err.code == -602) {
                            layer.msg('这个文件已经上传过一遍了');
                        } else {
                            layer.msg(err.response);
                        }
                    }
                }
            });
            // 初始化
            uploader.init();
            _this.fire_img_uploaders.push(uploader)
        },

        commitFireSet() {
            let _this = this
            let room_ids = _this.box_item.length == _this.box_arr_det.length ? ['-1'] : _this.box_item
            Vue.axios.post('Setting/setRoomFireWarning', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": _this.add_fire_form.id,
                        "shop_id": _this.add_fire_form.shop_id,
                        "room_ids": room_ids,
                        "img_url": _this.add_fire_form.img_url
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        if (_this.add_fire_form.id == '') {
                            layer.msg('新增成功！');
                            _this.fire_page = 1
                        } else {
                            layer.msg('修改成功！');
                        }
                        _this.showFireAddPanel = false
                        _this.getFireAlarmList(_this.fire_page)
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
        },

        /********************************* 关房播放设置 *********************************/
        // 初始化开房播放设置列表
        innitCloseRoomTable: function () {
            let _this = this;
            $(_this.$refs.closeRoomList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function (params) {
                    _this.getCloseRoomList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "shop_name",
                    title: "门店",
                    width: "11%"
                }, {
                    field: "room_info",
                    title: "包厢",
                    width: "10%",
                    formatter: function (value, row, index) {
                        if (row.use_all_room == '1') {
                            return '全部';
                        } else {
                            return row.room_info;
                        }
                    }
                }, {
                    field: "song_name",
                    title: "关房播放歌曲",
                    width: "10%"
                }, {
                    field: "time",
                    title: "操作时间",
                    width: "10%"
                }, {
                    title: "操作",
                    width: "10%",
                    events: {
                        'click .modify': function (e, value, row) {
                            _this.getCloseRoomDetail(row);
                            _this.addRoomModify = 2;
                            _this.add_room_header = '修改关房播放设置';
                            _this.showRoom = false;
                            _this.showRoomSet = true;
                            _this.roomVisible = false;
                        },
                        'click .delete': function (e, value, row) {
                            layer.confirm('删除后不可恢复，确定删除吗？', {
                                btn: ['确定', '取消'] //按钮
                            }, function () {
                                _this.deleteCloseRoom(row.id);
                            });
                        }
                    },
                    formatter: function (value, row, index) {
                        return '<span class="text-blue modify">修改</span>&nbsp;&nbsp;<span class="text-blue delete">删除</span>'
                    }
                }]
            });
        },

        // 获取关房播放设置列表
        getCloseRoomList: function (params) {
            let _self = this,
                pageNumber = 1;
            if (params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getClosecRoomSongsSettingList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.count,
                            rows: data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _self);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 点击'关房播放设置'
        add_close_room: function () {
            this.addRoomModify = 1;
            this.add_room_header = '关房播放设置';
            // 门店
            this.roomShop = [];
            this.roomVisible = true;
            this.innitCloseRoomInput();
            this.room_box_num = "";
            this.r_box_checkboxData = [];
            this.r_box_detCheckboxData = [];
            this.r_box_checkboxModel = [];
            // 默认选择全部门店，use_all_room 设置为 1
            this.r_box_allsel = '1';

            this.showRoom = false;
            this.showRoomSet = true;
            this.r_objClass = {
                selection_clear: true,
                visi_hid: false
            };
            // 默认选中"全部"时，禁用包厢号选择框
            $(this.$refs.close_room_box_num).prop("disabled", true);
            $(this.$refs.close_room_box_num).removeClass("canselect");

            this.r_song_checkModel = '';
            this.room_song_name = '';
            this.songData = [];
            this.getSongsData('room');
        },
        // 初始化门店输入框
        innitCloseRoomInput: function () {
            let _this = this;
            let innitSuggest = function () {
                $(_this.$refs.closeRoomShop).html("");
                $(_this.$refs.closeRoomShop).select2({
                    data: _this.roomShop,
                    minimumResultsForSearch: -1,
                    language: "zh-CN",
                    templateSelection: function (val) {
                        _this.close_room_box_num = '';
                        _this.r_box_checkboxModel = [];

                        // 判断是否选择"全部"
                        if (val.id == '0' || val.text == '全部') {
                            // 选择全部时，禁用包厢号选择，不发起请求
                            _this.r_box_allsel = '1'; // 设置 use_all_room 为 1
                            $(_this.$refs.close_room_box_num).prop("disabled", true);
                            $(_this.$refs.close_room_box_num).removeClass("canselect");
                        } else {
                            // 选择具体门店时，启用包厢号选择，发起请求
                            _this.r_box_allsel = ''; // 清空 use_all_room
                            $(_this.$refs.close_room_box_num).prop("disabled", false);
                            _this.getRoomBox(val.id);
                        }
                        return val.text
                    }
                });
            };
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {

                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        $.each(data.response.result, function (k, v) {
                            _this.roomShop.push({
                                id: v.id,
                                text: v.name
                            });
                        });
                        innitSuggest();
                        // 默认选中第一项（全部）
                        $(_this.$refs.closeRoomShop).val('0').trigger('change');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 点击选择包厢号
        close_room_box_fun: function (e) {
            if (!$(e.currentTarget).hasClass('canselect')) {
                var _this = this;
                _this.r_c_box_checkboxModel = _this.r_box_checkboxModel;
                _this.showRoomSet = false;
                _this.r_showbox = true;
            }
        },

        // 点击选择关房播放歌曲
        close_room_song_fun: function () {
            let _this = this;
            let c_r_song_checkModel = _this.r_song_checkModel;
            layer.confirm('', {
                skin: 'add_printer_area',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['关房播放歌曲', true],
                area: ['700px', ''], // 宽高
                content: $(_this.$refs.closeRoomSong_alert),
                cancel: function () {
                    // 右上角关闭
                    if (_this.room_song_name != "") {
                        _this.r_song_checkModel = c_r_song_checkModel;
                        return;
                    }
                    _this.r_song_checkModel = '';
                }
            }, function () {
                _this.songData.forEach(function (item) {
                    if (item.id == _this.r_song_checkModel) {
                        _this.room_song_name = item.text;
                    }
                });
                layer.closeAll();
            }, function () {
                if (_this.room_song_name != "") {
                    _this.r_song_checkModel = c_r_song_checkModel;
                    return;
                }
                _this.r_song_checkModel = '';
            });
        },


        // 新增/修改关房播放设置
        closeRoomSave: function (addRoomModify) {
            let _this = this;
            let room_ids = [];
            if (_this.room_box_num == '') {

            } else {
                $.each(_this.r_box_checkboxModel, function (k, v) {
                    room_ids.push(v);
                });
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": $(_this.$refs.closeRoomShop).val(),
                        "song_id": _this.r_song_checkModel,
                        'use_all_room': _this.r_box_allsel,
                        "room_ids": room_ids,
                    }
                },
                "comment": ""
            };
            if (addRoomModify == 2) {
                datas["request"]["param"]["shop_id"] = $(_this.$refs.closeRoomShopCg).attr('shopID');
                datas["request"]["param"]["id"] = _this.room_item_id;
            }
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setCloseRoomSongsSetting",
                async: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        layer.msg(data["response"]["error_msg"]);
                        $(_this.$refs.closeRoomList).bootstrapTable('destroy');
                        _this.innitCloseRoomTable();
                        _this.showRoom = true;
                        _this.showRoomSet = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },
        openCloseUpdsongs: function (e) {
            let _this = this;
            layer.confirm('', {
                skin: 'add_printer_area upload-songs',
                type: 1,
                btn: ['选择文件'], // 按钮
                title: ['上传歌曲', true],
                area: ['650px', ''], // 宽高
                content: $(_this.$refs.close_upload_songs),
                cancel: function () {
                    // 右上角关闭
                    document.getElementById('closeOssfile').innerHTML = '';
                }
            });
        },

        // 上传关房播放歌曲
        uploadCloseSong: function () {
            var _this = this;
            var accessid = '',
                accesskey = '',
                host = '',
                policyBase64 = '',
                signature = '',
                callbackbody = '',
                filename = '',
                key = '',
                expire = 0,
                g_object_name = '',
                g_object_name_type = 'local_name',  // 上传文件名字保持本地文件名字
                now = Date.parse(new Date()) / 1000;

            var body = '';
            function send_request() {
                var xmlhttp = null;
                if (window.XMLHttpRequest) {
                    xmlhttp = new XMLHttpRequest();
                } else if (window.ActiveXObject) {
                    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
                }
                if (xmlhttp != null) {
                    let datas = {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                // 'file': filename
                            }
                        },
                        "comment": ""
                    };
                    datas = JSON.stringify(datas);
                    $.ajax({
                        type: "POST",
                        dataType: "json",
                        url: Vue.ctUrl + "Setting/getOssSignature",
                        async: false,
                        crossDomain: true,
                        xhrFields: {
                            withCredentials: true
                        },
                        data: datas,
                        success: function (data) {
                            if (data['response']['result_code'] == "true") {
                                body = data.response.result.signature;
                                // g_object_name = data.response.result.file_name;
                            } else {
                                Vue.timeoutfun(data.response.result_status, _this);
                                layer.msg(data["response"]["error_msg"]);
                            }
                        },
                        error: function (err) {

                        }
                    });
                } else {
                    alert("Your browser does not support XMLHTTP.");
                }
            };

            function get_signature() {
                // 可以判断当前expire是否超过了当前时间,如果超过了当前时间,就重新取一下.3s 做为缓冲
                now = Date.parse(new Date()) / 1000;
                if (expire < now + 3) {
                    send_request();  // 返回签名
                    var obj = body;
                    host = obj['host'];
                    policyBase64 = obj['policy'];
                    accessid = obj['accessid'];
                    signature = obj['signature'];
                    expire = parseInt(obj['expire']);
                    callbackbody = obj['callback'];
                    key = obj['dir'];
                    return true;
                }
                return false;
            };

            function get_uploaded_object_name(filename) {
                let tmp_name = key + g_object_name
                tmp_name = tmp_name.replace("${filename}", filename);
                return tmp_name
            }

            function set_upload_param(up, filename, ret) {
                if (ret == false) {
                    ret = get_signature();
                }

                let new_multipart_params = {
                    'key': key + g_object_name,
                    'policy': policyBase64,
                    'OSSAccessKeyId': accessid,
                    'success_action_status': '200', // 让服务端返回200,不然，默认会返回204
                    'callback': callbackbody,
                    'signature': signature,
                };
                up.setOption({
                    'url': host,
                    'multipart_params': new_multipart_params
                });

                up.start();
            }

            function getFileName(filename) {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            'file': filename
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getFileName",
                    async: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function (data) {
                        if (data['response']['result_code'] == "true") {
                            g_object_name = data.response.result.file_name;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function (err) {

                    }
                });
            }

            var uploader = new plupload.Uploader({
                runtimes: 'html5,flash,silverlight,html4',
                browse_button: 'closeRoomSelFile',
                container: document.getElementById('uploadWrap'),
                flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
                silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
                url: Vue.ctUrl + "Setting/saveCustomSongsInfo",

                filters: {
                    mime_types: [ // 只允许上传mkv, mp4, avi文件
                        { title: "Video files", extensions: "mkv,mp4,avi" }
                    ],
                    max_file_size: '200mb', // 最大只能上传200mb的文件
                    prevent_duplicates: true // 不允许选取重复文件
                },

                init: {
                    PostInit: function () {
                        document.getElementById('closeOssfile').innerHTML = '';
                        document.getElementById('closeRoomSubFile').onclick = function () {
                            // let tagSel = document.getElementById('ossfile').getElementsByTagName('span');
                            // $.each(tagSel, function(k, v) {
                            //     set_upload_param(uploader, $(tagSel)[k].innerHTML, false);
                            // });
                            set_upload_param(uploader, '', false);
                            return false;
                        };
                    },

                    FilesAdded: function (up, files) {
                        plupload.each(files, function (file) {
                            document.getElementById('closeOssfile').innerHTML += '<div id="' + file.id + '"><span>' + file.name + '</span> (' + plupload.formatSize(file.size) + ')<b></b>'
                                + '<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>'
                                + '</div>';
                        });
                    },

                    BeforeUpload: function (up, file) {
                        getFileName(file.name);
                        set_upload_param(up, '', true);
                    },

                    UploadProgress: function (up, file) {
                        var d = document.getElementById(file.id);
                        d.getElementsByTagName('b')[0].innerHTML = '<span>' + file.percent + "%</span>";
                        var prog = d.getElementsByTagName('div')[0];
                        var progBar = prog.getElementsByTagName('div')[0]
                        progBar.style.width = 5 * file.percent + 'px';
                        progBar.setAttribute('aria-valuenow', file.percent);
                    },

                    FileUploaded: function (up, file, info) {
                        if (info.status == 200) {
                            let finalPath = get_uploaded_object_name(file.name);

                            // 保存上传的文件信息
                            let datas = {
                                "header": Vue.request_header,
                                "request": {
                                    "param": {
                                        "song_down_file": finalPath, // 文件存储路径
                                        "song_name": g_object_name // 文件名
                                    }
                                },
                                "comment": ""
                            };
                            datas = JSON.stringify(datas);
                            $.ajax({
                                type: "POST",
                                dataType: "json",
                                url: Vue.ctUrl + "Setting/saveCustomSongsInfo",
                                async: true,
                                crossDomain: true,
                                xhrFields: {
                                    withCredentials: true
                                },
                                data: datas,
                                success: function (data) {
                                    if (data['response']['result_code'] == "true") {
                                        layer.msg('上传成功');
                                        _this.getSongsData('room');
                                    } else {
                                        Vue.timeoutfun(data.response.result_status, _this);
                                        layer.msg(data["response"]["error_msg"]);
                                    }
                                },
                                error: function (err) {

                                }
                            });

                        } else {
                            document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = info.response;
                        }
                    },

                    Error: function (up, err) {
                        if (err.code == -600) {
                            layer.msg('请选择200mb以内的文件');
                        } else if (err.code == -601) {
                            layer.msg('只允许上传mkv/mp4/avi文件');
                        } else if (err.code == -602) {
                            layer.msg('这个文件已经上传过一遍了');
                        } else {
                            layer.msg(err.response);
                        }
                    }
                }
            });

            uploader.init();
        },

        getCloseRoomDetail: function (row) {
            let _this = this;

            // 门店
            $(_this.$refs.closeRoomShopCg).text(row.shop_name);
            $(_this.$refs.closeRoomShopCg).attr('shopID', row.shop_id);
            // 包厢号
            _this.l_objClass = {
                selection_clear: true,
                visi_hid: true
            };
            if (row.use_all_room == 1) {
                _this.room_box_num = '全部';
                _this.r_box_allsel = row.use_all_room;
            } else {
                _this.room_box_num = row.room_info;
                _this.r_box_allsel = row.use_all_room;
            }
            _this.r_box_checkboxModel = row.room_ids;
            $(_this.$refs.close_room_box_num).addClass("canselect");
            // 关房播放歌曲
            _this.songData = [];
            _this.getSongsData('room');
            _this.room_song_name = row.song_name;
            _this.r_song_checkModel = row.songs_id;
            // id
            _this.room_item_id = row.id;
        },
        // 删除关房播放设置
        deleteCloseRoom: function (id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "id": id
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Setting/delCloseRoomSongsSetting",
                async: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data['response']['result_code'] == "true") {
                        layer.msg(data["response"]["error_msg"]);
                        $(_this.$refs.closeRoomList).bootstrapTable('destroy');
                        _this.innitCloseRoomTable();
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {

                }
            });
        },



        /************************** 灯光面板点播设置 ************************/
        // 获取门店数据
        getLightShopList: function () {
            let _this = this;

            let shopDatas = [];
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {}
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        let shops = data.response.result
                        shops.shift()
                        _this.lightShopList = shops
                        _this.light_shop = _this.lightShopList[0].id
                        _this.getLightTable();
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        getLightTable() {
            const _this = this

            _this.loading = true
            Vue.axios.post('LightSongs/getList', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": _this.light_shop
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        _this.light_table = res.data.response.result;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },

        // 点击“禁用/启用”
        updateLightStatus(row) {
            const _this = this;

            let title = row.status == '1' ? '确认禁用？' : '确认启用？'
            layer.confirm(title, {
                title: '提示',
                btn: ['确定', '取消']
            }, function () {
                Vue.axios.post('LightSongs/setStatus', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": row.id
                        }
                    },
                    "comment": ""
                })
                    .then(res => {
                        if (res.data.response.result_code == "true") {
                            layer.msg('操作成功！');
                            _this.getLightTable()
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
            });
        },

        addNewLight() {
            this.light_edit_form = {
                id: '',
                shop_id: this.light_shop,
                light: '',
                key_name: '',
                tv_mode: '1',
                play_mode: '1',
                songs_code: [],
            },
                this.getSongList(1)
            this.choosed_song_table = []
            this.choosed_song_page = 1
            this.choosed_song_total = 0
            this.showLightSetPanel = true
        },

        // 获取歌曲列表
        getSongList(page) {
            let _this = this
            _this.search_song_page = page
            _this.search_song_loading = true
            let name = '',
                szClass = '',
                szPlayer = '';
            if (_this.search_song_form.search_key == 'szSong_name') {
                name = _this.search_song_form.search_value;
            } else if (_this.search_song_form.search_key == 'szClass') {
                szClass = _this.search_song_form.search_value;
            } else if (_this.search_song_form.search_key == 'szPlayer') {
                szPlayer = _this.search_song_form.search_value;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": page,
                        "page_size": _this.GLOBAL.PAGESIZE,
                        "name": name,
                        "szClass": szClass,
                        "szPlayer": szPlayer
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getSongsList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    _this.search_song_loading = false
                    if (data.response.result_code == "true") {
                        _this.search_song_total = Number(data.response.data.total)
                        _this.search_song_table = data.response.data.rows
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        addSongToChoosed(song) {
            this.choosed_song_page = 1
            this.choosed_song_table.push(song)
        },

        delThisSong(index) {
            let oriIndex = (this.choosed_song_page - 1) * this.GLOBAL.PAGESIZE + index
            this.choosed_song_table.splice(oriIndex, 1)
        },

        changeChoosedSongPage(val) {
            this.choosed_song_page = val
        },

        // 保存灯光面板设置
        saveLightSet() {
            const _this = this

            Vue.axios.post('LightSongs/editData', {
                "header": Vue.request_header,
                "request": {
                    "param": _this.light_edit_form
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg("操作成功！")
                        _this.showLightSetPanel = false
                        _this.getLightTable()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },

        // 获取详情
        getLightSetDetail(id) {
            const _this = this

            Vue.axios.post('LightSongs/getDatail', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "id": id
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        _this.getSongList(1)
                        _this.choosed_song_page = 1
                        _this.showLightSetPanel = true
                        _this.light_edit_form = res.data.response.result
                        _this.light_edit_form.shop_id = _this.light_shop
                        _this.choosed_song_table = res.data.response.result.songs
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },

        /************************** 购买单曲配置 ************************/
        // 获取门店数据
        buySongGetShopList: function () {
            let _this = this;

            let shopDatas = [];
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {}
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        let shops = data.response.result
                        shops.shift()
                        _this.shop_list = shops
                        _this.buy_song_form.shop_id = _this.shop_list[0].id
                        // 包厢类型
                        _this.getRoomTypes(_this.buy_song_form.shop_id);
                        _this.getBuySongRuleList(1)
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        // 切换门店
        onBuySongShopChange(val) {
            this.buy_song_form.shop_id = val
            this.getRoomTypes(this.buy_song_form.shop_id)
        },

        // 获取门店下包厢类型
        getRoomTypes: function (shop_id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shop_id
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getRoomType",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.room_type_list = data.response.result.data
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.data.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        // 获取购买单曲规则列表
        getBuySongRuleList(page) {
            let _this = this
            _this.buy_song_page = page
            _this.loading = true

            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.buy_song_form.shop_id,
                        "room_type": _this.buy_song_form.room_type, // 包厢类型
                        "status": _this.buy_song_form.status, // 状态，1：启用，-1：禁用
                        "name": _this.buy_song_form.name, // 规则名称
                        "page": page,
                        "page_size": _this.GLOBAL.PAGESIZE,
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "SongsSalesRules/getList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    _this.loading = false
                    if (data.response.result_code == "true") {
                        if (page == 1) {
                            _this.buy_song_total = Number(data.response.result.count)
                        }
                        _this.buy_song_table = data.response.result.data
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 启用、禁用购买单曲规则
        updateBuySongStatus: function (row) {
            let _this = this
            let title = ''

            if (row.status == '-1') { // 启用
                title = '确认启用？'
            } else { // 禁用
                title = '确认禁用？'
            }

            layer.confirm(title, {
                btn: ['确定', '取消'],
                title: ['提示', true],
            }, function () {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": row.id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "SongsSalesRules/setStatus",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.msg("操作成功！")
                            _this.getBuySongRuleList(_this.buy_song_page)
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("网络错误");
                    }
                });
            });
        },

        // 删除
        delBuySongRule(id) {
            let _this = this
            layer.confirm('删除后不可恢复，确定删除？', {
                btn: ['确定', '取消'],
                title: ['提示', true],
            }, function () {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "SongsSalesRules/deleteData",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.msg("操作成功！")
                            _this.getBuySongRuleList(1)
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("网络错误");
                    }
                });
            });
        },

        // 点击“新增规则”按钮
        onAddBuySongRuleClick() {
            this.add_buy_song = {
                id: "", // 规则id，修改时传
                shop_id: this.buy_song_form.shop_id, // 门店id
                name: "", // 规则名称
                room_type: [], // 适用包厢类型，数组
                price: "", // 原价
                actual_price: "", // 优惠价
                vip_price: "", // 会员价
                start_time: "", // 使用开始时间
                end_time: "", // 使用结束时间
                week_cycle: [], // 有效星期日
                disabled_date: [], // 不可用日期，数组
                enable_date_limit: "-1", // 适用日期，-1：不限制
                enable_start_time: "", // 适用开始日期，_enable_date_limit=1时生效
                enable_end_time: "", // 适用结束日期，_enable_date_limit=1时生效
                vip_level1_price: "", // 会员等级价格
                vip_level2_price: "",
                vip_level3_price: "",
                vip_level4_price: "",
                vip_level5_price: "",
                vip_level6_price: "",
                vip_level7_price: "",
                vip_level8_price: "",
                vip_level9_price: "",
                vip_level10_price: ""
            }
            this.showBuySongList = false
            // 包厢类型
            this.room_types_str = ''
            this.boxtype_item = []
            // 使用时间
            this.use_time_str = '00:00-00:00'
            this.add_buy_song.start_time = '00:00'
            this.add_buy_song.end_time = '00:00'
            // 星期几
            this.week_sign = false
            this.week_all = true
            this.week_ids = ['1', '2', '3', '4', '5', '6', '0']
            this.week_str = '一,二,三,四,五,六,日'
            this.add_buy_song.week_cycle = this.week_ids
            // 不适用日期
            this.disabled_date_str = ''
            this.initDisdate()
            // 适用日期
            this.enable_date_str = '不限制'
            this.initEnableDate()
        },

        // 点击包厢类型
        openRoomTypePop: function () {
            let _this = this;

            let c_boxtype_item = _this.boxtype_item;
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['包厢类型', true],
                area: ['600px', ''], // 宽高
                content: $(_this.$refs.boxtype_pop),
                cancel: function () {
                    // 右上角关闭
                    if (_this.add_buy_song.room_type != "") {
                        _this.boxtype_item = c_boxtype_item;
                        return;
                    }
                    _this.boxtype_item = [];
                }
            }, function () {
                let texts = [];
                _this.room_type_list.forEach(function (item) {
                    _this.boxtype_item.forEach(function (item2) {
                        if (item.id == item2) {
                            texts.push(item.name);
                        }
                    });
                });
                _this.room_types_str = texts.join(",");

                _this.add_buy_song.room_type = _this.boxtype_item
                layer.closeAll();
            }, function () {
                if (_this.add_buy_song.room_type != "") {
                    _this.boxtype_item = c_boxtype_item;
                    return;
                }
                _this.boxtype_item = [];
            });
        },
        // 全选
        boxtypeAll: function () {
            let _this = this;

            _this.boxtype_all = _this.c_boxtype_all;
            if (!_this.boxtype_all) { // 实现全选
                _this.boxtype_item = [];
                _this.room_type_list.forEach(function (item) {
                    _this.boxtype_item.push(item.id);
                });
            } else { // 实现反选
                _this.boxtype_item = [];
            }
        },
        clearRoomTypes() {
            this.room_types_str = ''
            this.boxtype_item = ''
            this.add_buy_song.room_types = []
        },

        //使用时间弹窗
        openUseTimePop: function () {
            const _this = this

            _this.hour_start = _this.add_buy_song.start_time.split(':')[0] || '00'
            _this.minute_start = _this.add_buy_song.start_time.split(':')[1] || '00'
            _this.hour_end = _this.add_buy_song.end_time.split(':')[0] || '00'
            _this.minute_end = _this.add_buy_song.end_time.split(':')[1] || '00'
            layer.confirm('', {
                type: 1,
                skin: 'public-alert-skin',
                btn: ['确定', '取消'], // 按钮
                title: '使用时间',
                area: ['450px', ''], // 宽高
                content: $(_this.$refs.usetime_pop)
            }, function () {
                _this.add_buy_song.start_time = _this.hour_start + ":" + _this.minute_start
                _this.add_buy_song.end_time = _this.hour_end + ":" + _this.minute_end
                _this.use_time_str = _this.add_buy_song.start_time + '-' + _this.add_buy_song.end_time
                layer.closeAll()
            })
        },
        clearUseTime() {
            this.use_time_str = ''
            this.add_buy_song.start_time = ''
            this.add_buy_song.end_time = ''
        },

        // 星期几弹窗
        openWeekPop() {
            const _this = this
            const c_week_ids = _this.week_ids,
                c_week_sign = _this.week_sign,
                c_week_all = _this.week_all;
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['选择星期', true],
                area: ['600px', ''], // 宽高
                content: $(_this.$refs.week_pop),
                cancel: function () {
                    // 右上角关闭
                    _this.week_ids = c_week_ids;
                    _this.week_sign = c_week_sign;
                    _this.week_all = c_week_all;
                }
            }, function () {
                let arr = [];
                _this.week_list.forEach(item => {
                    _this.week_ids.forEach(sub => {
                        if (item.id == sub) {
                            arr.push(item.name);
                        }
                    });
                });
                _this.week_str = arr.join(',');
                _this.add_buy_song.week_cycle = _this.week_ids
                layer.closeAll();
            }, function () {
                _this.week_ids = c_week_ids;
                _this.week_sign = c_week_sign;
                _this.week_all = c_week_all;
            });
        },
        weekAll(val) {
            let ids = []
            this.week_list.forEach(v => {
                ids.push(v.id)
            });
            this.week_ids = val ? ids : []
            this.week_sign = false
        },
        weekChange(val) {
            const len = val.length
            this.week_sign = len > 0 && len < this.week_list.length
            this.week_all = len === this.week_list.length
        },
        clearWeek() {
            this.week_sign = false
            this.week_all = false
            this.week_ids = []
            this.week_str = ''
            this.add_buy_song.week_cycle = []
        },

        // 不可用日期
        initDisdate: function () {
            let _this = this;
            $(_this.$refs.disdate).daterangepicker({
                singleDatePicker: true, // 设置成单日历
                buttonClasses: ['btn btn-default'],
                applyClass: 'btn-small btn-orange',
                cancelClass: 'btn-small btn-gray'
            }, function (start, end, label) {
                _this.add_buy_song.disabled_date.push(start.format('YYYY-MM-DD'));
                _this.disabled_date_str = _this.add_buy_song.disabled_date.join(',');
            });
        },
        clearDisdate(event) {
            // 判断点击事件是否来源于清除按钮
            if (event.target.className.includes('el-input__icon')) {
                event.stopPropagation(); // 阻止事件冒泡
                this.add_buy_song.disabled_date = []
                this.disabled_date_str = ''
            }
        },

        // 适用日期
        initEnableDate: function () {
            let _this = this;
            $(_this.$refs.enabledate).daterangepicker({
                timePicker: true,
                timePickerIncrement: 1,
                timePicker12Hour: false,
                buttonClasses: ['btn btn-default'],
                applyClass: 'btn-small btn-orange',
                cancelClass: 'btn-small btn-gray'
            }, function (start, end, label) {
                _this.enable_date_str = start.format('YYYY-MM-DD HH:mm') + ' - ' + end.format('YYYY-MM-DD HH:mm');
                _this.add_buy_song.enable_date_limit = '0'
                _this.add_buy_song.enable_start_time = start.format('YYYY-MM-DD HH:mm');
                _this.add_buy_song.enable_end_time = end.format('YYYY-MM-DD HH:mm');
            });
        },
        clearEnableDate(event) {
            // 判断点击事件是否来源于清除按钮
            if (event.target.className.includes('el-input__icon')) {
                event.stopPropagation(); // 阻止事件冒泡
                this.enable_date_str = '不限制'
                this.add_buy_song.enable_date_limit = '-1'
                this.add_buy_song.enable_start_time = ''
                this.add_buy_song.enable_end_time = ''
            }
        },

        //提交新增、修改单曲购买设置
        commitBuySong() {
            let _this = this
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": _this.add_buy_song
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "SongsSalesRules/editData",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        if (_this.add_buy_song.id == '') {
                            layer.msg("新增成功！")
                            _this.getBuySongRuleList(1)
                        } else {
                            layer.msg("修改成功！")
                            _this.getBuySongRuleList(_this.buy_song_page)
                        }
                        _this.showBuySongList = true
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        // 点击“修改”
        editBuySong(id) {
            let _this = this
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "SongsSalesRules/getDetail",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.add_buy_song = data.response.result
                        _this.room_types_str = data.response.result.room_type_name
                        // 使用时间
                        _this.use_time_str = _this.add_buy_song.start_time + '-' + _this.add_buy_song.end_time
                        // 星期几
                        _this.week_ids = data.response.result.week_cycle
                        _this.week_sign = _this.week_ids.length > 0 && _this.week_ids.length < _this.week_list.length
                        _this.week_all = _this.week_ids.length === _this.week_list.length
                        _this.week_str = data.response.result.week_cycle_str
                        // 不适用日期
                        _this.disabled_date_str = data.response.result.disabled_date.join(",")
                        // 适用日期
                        _this.enable_date_str = data.response.result.enable_start_time + '-' + data.response.result.enable_end_time
                        _this.initDisdate()
                        _this.initEnableDate()
                        _this.showBuySongList = false
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        /************************** 三合一效果文件管理 ************************/
        // 获取门店数据
        fileManageGetShopList: function () {
            let _this = this;

            let shopDatas = [];
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {}
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        let shops = data.response.result
                        shops.shift()
                        _this.file_manage_shop_list = shops
                        _this.file_manage_form.shop_id = _this.file_manage_shop_list[0].id
                        _this.effect_manage_form.shop_id = _this.file_manage_shop_list[0].id
                        // 包厢
                        _this.getFileManageRoom(_this.file_manage_form.shop_id);
                        _this.fileManageGetAllRoomByArea(_this.file_manage_form.shop_id)
                        _this.getFileManageList()
                        _this.getEffectTable()

                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        // 切换门店
        onFileManageShopChange(val) {
            this.file_manage_form.shop_id = val
            this.getFileManageRoom(this.file_manage_form.shop_id)
            this.fileManageGetAllRoomByArea(this.file_manage_form.shop_id)
        },

        // 获取包厢号
        getFileManageRoom: function (shop_id) {
            const _this = this;

            Vue.axios.post('Shop/getAllRoom', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": shop_id
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        _this.file_manage_room_list = res.data.response.result;
                        _this.file_manage_room_list.unshift({
                            id: '',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
        },

        // 获取设备型号
        getDeviceList: function () {
            const _this = this;

            // Vue.axios.post('PublicData/api_getTrinityTool', {
            Vue.axios.post('PublicData/api_version_getToolList', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "version": _this.listShow12 ? 1 : 2
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        _this.device_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
        },

        // 获取效果文件列表
        getFileManageList() {
            let _this = this
            _this.loading = true
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.file_manage_form.shop_id,
                        "room_id": _this.file_manage_form.room_id,
                        "tool_id": _this.file_manage_form.tool_id,
                        "file_name": _this.file_manage_form.file_name
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/TrinityFileList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    _this.loading = false
                    if (data.response.result_code == "true") {
                        _this.file_manage_list = data.response.result.rows
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 点击"新增效果文件"
        onAddFileClick() {
            this.add_file_form = {
                id: '',
                room_id: '',
                room_name: '',
                tool_id: '',
                file_name: '',
                file_describe: '',
                structure_id: '',
                area_id: '',
                speaker_id: '',
                file_url_name1: '',
                file_url1: '',
                file_url_name2: '',
                file_url2: '',
                file_url_name3: '',
                file_url3: '',
                file_url_name4: '',
                file_url4: '',
                file_url_name5: '',
                file_url5: '',
                file_url_name6: '',
                file_url6: '',
                file_url_name7: '',
                file_url7: '',
                file_url_name8: '',
                file_url8: '',
                file_url_name9: '',
                file_url9: '',
                file_url_name10: '',
                file_url10: '',
            }
            this.showAddFilePanel = true
        },

        // 获取下拉框数据（房间结构、面积、音响型号）
        getTrinityParam() {
            var _this = this;
            Vue.axios.post('Setting/getTrinityParam', {
                "header": Vue.request_header,
                "request": {
                    "param": {}
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        _this.structure_list = res.data.response.result.structure || []
                        _this.area_list = res.data.response.result.area || []
                        _this.speaker_list = res.data.response.result.speaker || []
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('获取下拉框数据失败');
                });
        },

        initFileUpload() {
            if (this.file_uploaders.length > 0) {
                this.file_uploaders.forEach(item => {
                    item.destroy()
                })
                this.file_uploaders = []
            }

            for (var i = 1; i <= 10; i++) {
                this.fileUpload('up-file-' + i, i)
            }
        },

        // 效果文件上传
        fileUpload(id, index) {
            let _this = this;
            let host = '',
                dir = '',
                file_name = '';
            // 实例化一个plupload上传对象
            let uploader = new plupload.Uploader({
                browse_button: id, // 选择文件id
                filters: {
                    mime_types: [ // 文件格式限制
                        { title: "Ser files", extensions: "ser" }
                    ],
                    // max_file_size: '2mb', // 文件大小限制
                    // prevent_duplicates: true // 不允许选取重复文件
                },
                // resize: {
                //  width: 527,
                //  height: 296
                // },
                multi_selection: false, // 单选
                url: './', // OSS地址
                init: {
                    // 文件上传前触发
                    BeforeUpload: function (up, file) { },
                    // 文件选择完毕触发
                    FilesAdded: function (up, files) {
                        // 获取签名
                        Vue.axios.post('publicData/api_getOssSignature', {
                            "header": Vue.request_header,
                            "request": {
                                "version": Vue.version,
                                "param": {
                                    "file": files[0].name,
                                    "path": 'trinity_file_manage'
                                }
                            },
                            "comment": ""
                        })
                            .then(res => {
                                if (res.data.response.result_code == "true") {
                                    host = res.data.response.data.host;
                                    dir = res.data.response.data.dir;
                                    file_name = res.data.response.data.file_name;
                                    const new_params = {
                                        'key': dir + file_name,
                                        'OSSAccessKeyId': res.data.response.data.accessid,
                                        'policy': res.data.response.data.policy,
                                        'signature': res.data.response.data.signature,
                                        'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
                                    };
                                    up.setOption({
                                        'url': host,
                                        'multipart_params': new_params
                                    });

                                    // 上传文件
                                    uploader.start();
                                } else {
                                    Vue.timeoutfun(data.response.result_status, _this);
                                    layer.msg(data.response.error_msg);
                                }
                            })
                            .catch(err => {
                                layer.msg("出错啦");
                            });
                    },
                    // 文件上传成功触发
                    FileUploaded: function (up, file, data) {
                        let resUrl = host + "/" + dir + file_name;
                        _this.add_file_form['file_url' + index] = resUrl
                        layer.msg("上传成功")
                    },
                    // 错误提示
                    Error: function (up, err) {
                        if (err.code == -600) {
                            layer.msg('请选择2mb以内的文件');
                        } else if (err.code == -601) {
                            layer.msg('只允许上传jpg,jpeg,png,gif文件');
                        } else if (err.code == -602) {
                            layer.msg('这个文件已经上传过一遍了');
                        } else {
                            layer.msg(err.response);
                        }
                    }
                }
            });
            // 初始化
            uploader.init();
            _this.file_uploaders.push(uploader)
        },

        // 包厢号数据
        fileManageGetAllRoomByArea: function (shopid) {
            var _this = this;
            var datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": shopid
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getAllRoomByArea",
                async: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.file_manage_room_arr = data.response.result
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) { }
            });
        },

        onRoomRadioInput(val) {
            let room_arr = []
            this.file_manage_room_arr.forEach(item => {
                if (item.room.length > 0) {
                    item.room.forEach(room => {
                        room_arr.push(room)
                    })
                }
            })
            let index = room_arr.findIndex(item => val == item.id)
            if (index > -1) {
                this.add_file_form.room_name = room_arr[index].name
            }
        },

        confirmRoomChoose() {
            if (this.add_file_form.room_id == '') {
                layer.msg("请先选择适用包厢")
                return
            }
            this.showFileManageRoom = false
        },

        // 新增、修改文件管理
        commitAddFile() {
            var _this = this;

            // 验证必填项
            if (!this.add_file_form.structure_id) {
                layer.msg("请选择房间结构")
                return
            }
            if (!this.add_file_form.area_id) {
                layer.msg("请选择房间面积")
                return
            }
            if (!this.add_file_form.speaker_id) {
                layer.msg("请选择音响型号")
                return
            }

            let count = 0
            for (var i = 1; i <= 10; i++) {
                if (this.add_file_form['file_url' + i] != '') {
                    count++
                }
            }
            if (count < 1) {
                layer.msg("请至少上传一个效果文件")
                return
            }
            let file_url = {}
            for (var i = 1; i <= 10; i++) {
                file_url[i] = {
                    name: this.add_file_form['file_url_name' + i],
                    url: this.add_file_form['file_url' + i]
                }
            }
            this.add_file_form.file_url = file_url

            // 确保三个ID字段为数字类型
            let param = {
                ...this.add_file_form,
                structure_id: parseInt(this.add_file_form.structure_id),
                area_id: parseInt(this.add_file_form.area_id),
                speaker_id: parseInt(this.add_file_form.speaker_id)
            }

            let url = _this.add_file_form.id == '' ? 'Setting/addTrinityFile' : 'Setting/updateTrinityFile'

            Vue.axios.post(url, {
                "header": Vue.request_header,
                "request": {
                    "param": param
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        if (!!_this.add_file_form.id) {
                            layer.msg("修改成功！")
                        } else {
                            layer.msg("新增成功！")
                        }
                        _this.getFileManageList()
                        _this.showAddFilePanel = false
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
        },

        // 点击列表"修改"
        editFileManage(row) {
            this.add_file_form = {
                id: row.id,
                room_id: row.room_id,
                room_name: row.room_name,
                tool_id: row.tool_id,
                file_name: row.file_name,
                file_describe: row.file_describe,
                structure_id: row.structure_id || '',
                area_id: row.area_id || '',
                speaker_id: row.speaker_id || '',
                file_url_name1: '',
                file_url1: '',
                file_url_name2: '',
                file_url2: '',
                file_url_name3: '',
                file_url3: '',
                file_url_name4: '',
                file_url4: '',
                file_url_name5: '',
                file_url5: '',
                file_url_name6: '',
                file_url6: '',
                file_url_name7: '',
                file_url7: '',
                file_url_name8: '',
                file_url8: '',
                file_url_name9: '',
                file_url9: '',
                file_url_name10: '',
                file_url10: '',
            }
            let file_url_obj = row.file_url
            for (var i = 1; i <= Object.keys(file_url_obj).length; i++) {
                this.add_file_form['file_url_name' + i] = file_url_obj[i].name
                this.add_file_form['file_url' + i] = file_url_obj[i].url
            }

            this.showAddFilePanel = true
        },

        // 点击列表“删除”文件管理
        delFileManage(id) {
            let _this = this
            layer.confirm('删除后不可恢复，确定删除？', {
                btn: ['确定', '取消'],
                title: ['提示', true],
            }, function () {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/delTrinityFile",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.msg("操作成功！")
                            _this.getFileManageList()
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("网络错误");
                    }
                });
            });
        },

        /******************** 智能交换机设置 ******************/
        // 获取门店列表
        getSmartMachineShopList(page) {
            let _this = this
            _this.smart_machine_shop_page = page
            _this.loading = true
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": page,
                        "page_size": _this.GLOBAL.PAGESIZE
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getShopConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        if (page == 1) {
                            _this.smart_machine_shop_total = Number(data.response.result.total)
                        }
                        _this.smart_machine_shop_list = data.response.result.rows;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        // 点击列表“设置”
        onSmartMachineSetClick(row) {
            this.shop_id = row.shop_id
            this.shop_name = row.shop_name
            this.getSmartMachineSet(row.shop_id)
            this.getSwitchControlType(row.shop_id)
            this.showSmartMachineSetPanel = true
        },

        // 获取设置
        getSmartMachineSet(shop_id) {
            let _this = this
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shop_id,
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "SwitchControl/getData",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.line_data = data.response.result.line_data
                        _this.switch_control = data.response.result.switch_control
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        // 获取控制类型
        getSwitchControlType(shop_id) {
            let _this = this
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shop_id,
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "SwitchControl/getTypes",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.control_types = data.response.result
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        // 修改线路名称
        editLineName() {
            let _this = this
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.shop_id,
                        "line_data": _this.line_data
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "SwitchControl/upLine",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg("修改成功！")
                        _this.getSwitchControlType(_this.shop_id)
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        // 点击“新增控制”
        onAddControlClick(item) {
            this.switch_control_form = {
                id: '',
                shop_id: this.shop_id,
                type: item.type,//类型
                control_type: '',//控制类型
                action: '',//控制详情
                action_info: '',//控制详情2
            }
            this.openControlPop()
        },

        // 打开控制弹窗
        openControlPop() {
            let _this = this
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['新增控制', true],
                area: ['500px', ''], // 宽高
                content: $(_this.$refs.switch_control_pop),
            }, function () {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": _this.switch_control_form
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "SwitchControl/addSwitchControl",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.closeAll()
                            layer.msg("新增成功！")
                            _this.getSmartMachineSet(_this.shop_id)
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("网络错误");
                    }
                });
            })

        },

        // 控制类型改变
        onControlTypeChange(val) {
            let index = this.control_types.findIndex(item => item.control_type == val)
            this.control_actions = this.control_types[index].action
            this.control_action_info = this.control_types[index].action_info

        },

        // 控制类型改变3
        onControlTypeChange3(val) {
            let index = this.control_device_type_arr.findIndex(item => item.control_type == val)
            // 重置control_form中的其他参数
            this.control_form.control_type = val
            this.control_form.control_type_name = ''
            this.control_form.action = ''
            this.control_form.action_info = ''
            this.control_form.notify_type = ''
            this.control_form.box_notify_config = {
                power_mode: '',
                cycle_mode: '',
                power_duration: '',
                interval_duration: '',
            }
            this.CurrentDeviceActions = this.control_device_type_arr[index].action
            this.CurrentDeviceActionInfos = this.control_device_type_arr[index].action_info
            this.CurrentDeviceBoxPowerModeConfig = this.control_device_type_arr[index].power_mode || []
            this.CurrentDeviceBoxCycleModeConfig = this.control_device_type_arr[index].cycle_mode || []
        },


        // 点击“修改”控制
        openEditControlPop(row) {
            let _this = this
            let obj = JSON.parse(JSON.stringify(row))
            let index = this.control_types.findIndex(item => item.control_type == obj.control_type)
            this.control_actions = this.control_types[index].action
            this.control_action_info = this.control_types[index].action_info
            _this.switch_control_form = {
                id: obj.id,
                shop_id: _this.shop_id,
                type: obj.type,//类型
                control_type: obj.control_type,//控制类型
                action: obj.action,//控制详情
                action_info: obj.action_info,//控制详情2
            }
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['修改控制', true],
                area: ['500px', ''], // 宽高
                content: $(_this.$refs.switch_control_pop),
            }, function () {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": _this.switch_control_form
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "SwitchControl/upSwitchControl",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.closeAll()
                            layer.msg("修改成功！")
                            _this.getSmartMachineSet(_this.shop_id)
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("网络错误");
                    }
                });
            })
        },

        // 删除控制
        delControl: function (row) {
            let _this = this

            layer.confirm('删除后数据将不可恢复！确认删除？', {
                btn: ['确定', '取消'],
                title: '提示',
            }, function () {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": row.id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "SwitchControl/delSwitchControl",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.msg("删除成功！")
                            _this.getSmartMachineSet(_this.shop_id)
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("网络错误");
                    }
                });
            });
        },

        /******************** 智慧控制器配置 ******************/
        // 获取门店列表
        getSmartControlShopList(page) {
            let _this = this
            _this.smart_control_shop_page = page
            _this.loading = true
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": page,
                        "page_size": _this.GLOBAL.PAGESIZE
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getShopConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        if (page == 1) {
                            _this.smart_control_shop_total = Number(data.response.result.total)
                        }
                        _this.smart_control_shop_list = data.response.result.rows;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        // 点击列表“设置”
        onSmartControlSetClick(row) {
            this.shop_id = row.shop_id
            this.shop_name = row.shop_name
            this.getSmartControlSet(row.shop_id)
            this.getSwitchControlType2(row.shop_id)
            this.showSmartControlSetPanel = true
        },

        // 获取设置
        getSmartControlSet(shop_id) {
            let _this = this
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shop_id,
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "IntelligentController/getData",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.line_data = data.response.result.line_data
                        _this.breaker_data = data.response.result.breaker_data
                        _this.switch_control = data.response.result.switch_control
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        // 获取控制类型
        getSwitchControlType2(shop_id) {
            let _this = this
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shop_id,
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "IntelligentController/getTypes",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.control_types = data.response.result
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        // 修改线路名称
        editLineName2() {
            let _this = this
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.shop_id,
                        "line_data": _this.line_data,
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "IntelligentController/upLine",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg("修改成功！")
                        _this.getSwitchControlType2(_this.shop_id)
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        // 修改智能空开线路名称
        editBreakerName() {
            let _this = this
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.shop_id,
                        "line_data": _this.breaker_data
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "IntelligentController/upBreakerLine",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg("修改成功！")
                        _this.getSwitchControlType2(_this.shop_id)
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },
        // 点击“新增控制”3
        onAddControlClick3(item) {
            console.log('333');

            this.control_form = {
                id: '',
                shop_id: this.current_device_shop_id,
                operational_scene: this.activePowerControlTab,
                type: item.type,
                control_type: '',
                action: '',
                action_info: '',
                notify_type: null,
                box_notify_config: {
                    power_mode: null,
                    cycle_mode: null,
                    power_duration: 0,
                    interval_duration: 0
                }
            }
            this.openControlPop3()
        },
        // 打开控制弹窗3
        openControlPop3() {
            let _this = this
            console.log('3334');
            let title = _this.control_form.id ? '修改控制' : '新增控制'
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: [title, true],
                area: ['500px', ''], // 宽高
                content: $(_this.$refs.control_pop3),
            }, function () {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": _this.control_form
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "NewIntelligentController/setPowerControlData",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.closeAll()
                            layer.msg("操作成功！")
                            // 刷新列表
                            _this.getPowerControlConfig(_this.current_device_shop_id)
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("网络错误");
                    }
                });
            })
        },
        // 点击“修改”控制3
        openEditControlPop3(row) {
            console.log('row', row);
            let _this = this
            let obj = JSON.parse(JSON.stringify(row))
            _this.control_form = {
                id: obj.id,
                shop_id: _this.current_device_shop_id,
                type: obj.type,
                control_type: obj.control_type,
                action: obj.action,
                action_info: obj.action_info,
                notify_type: obj.notify_type,
                box_notify_config: obj.box_notify_config,
                operational_scene: _this.activePowerControlTab,
                control_type_name: obj.control_type_name,
            }
            // 点击修改的时候CurrentDeviceActions没有值
            let index = this.control_device_type_arr.findIndex(item => item.control_type == obj.control_type)
            this.CurrentDeviceActions = this.control_device_type_arr[index].action
            this.CurrentDeviceActionInfos = this.control_device_type_arr[index].action_info
            this.CurrentDeviceBoxPowerModeConfig = this.control_device_type_arr[index].power_mode || []
            this.CurrentDeviceBoxCycleModeConfig = this.control_device_type_arr[index].cycle_mode || []
            // _this.CurrentDeviceActions 

            this.openControlPop3()
        },
        delControl3(row) {
            let _this = this

            layer.confirm('删除后数据将不可恢复！确认删除？', {
                btn: ['确定', '取消'],
                title: '提示',
            }, function () {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": row.id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "NewIntelligentController/delPowerControlData",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.msg("删除成功！")
                            _this.getPowerControlConfig(_this.current_device_shop_id)
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("网络错误");
                    }
                });
            });
        },


        // 点击“新增控制”
        onAddControlClick2(item) {
            this.switch_control_form = {
                id: '',
                shop_id: this.shop_id,
                type: item.type,//类型
                control_type: '',//控制类型
                action: '',//控制详情
                action_info: '',//控制详情2
            }
            this.openControlPop2()
        },

        // 打开控制弹窗
        openControlPop2() {
            let _this = this
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['新增控制', true],
                area: ['500px', ''], // 宽高
                content: $(_this.$refs.switch_control_pop2),
            }, function () {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": _this.switch_control_form
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "IntelligentController/addSwitchControl",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.closeAll()
                            layer.msg("新增成功！")
                            _this.getSmartControlSet(_this.shop_id)
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("网络错误");
                    }
                });
            })

        },

        // 点击“修改”控制
        openEditControlPop2(row) {
            let _this = this
            let obj = JSON.parse(JSON.stringify(row))
            let index = this.control_types.findIndex(item => item.control_type == obj.control_type)
            this.control_actions = this.control_types[index].action
            this.control_action_info = this.control_types[index].action_info
            _this.switch_control_form = {
                id: obj.id,
                shop_id: _this.shop_id,
                type: obj.type,//类型
                control_type: obj.control_type,//控制类型
                action: obj.action,//控制详情
                action_info: obj.action_info,//控制详情2
            }
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['修改控制', true],
                area: ['500px', ''], // 宽高
                content: $(_this.$refs.switch_control_pop2),
            }, function () {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": _this.switch_control_form
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "IntelligentController/upSwitchControl",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.closeAll()
                            layer.msg("修改成功！")
                            _this.getSmartControlSet(_this.shop_id)
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("网络错误");
                    }
                });
            })
        },

        // 删除控制
        delControl2: function (row) {
            let _this = this

            layer.confirm('删除后数据将不可恢复！确认删除？', {
                btn: ['确定', '取消'],
                title: '提示',
            }, function () {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": row.id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "IntelligentController/delSwitchControl",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.msg("删除成功！")
                            _this.getSmartControlSet(_this.shop_id)
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("网络错误");
                    }
                });
            });
        },

        /************************** 工作歌单 ************************/
        // 获取门店数据
        getWorkSongShopList: function () {
            let _this = this;

            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {}
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        let shops = data.response.result
                        shops.shift()
                        _this.shop_list = shops
                        _this.work_song_list_form.shop_id = _this.shop_list[0].id
                        // 获取工作歌单
                        _this.getWorkSongList(1)
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        // 获取工作歌单
        getWorkSongList(page) {
            let _this = this
            _this.work_song_list_page = page
            _this.loading = true
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": page,
                        "page_size": _this.GLOBAL.PAGESIZE,
                        "shop_id": _this.work_song_list_form.shop_id,
                        "song_name": _this.work_song_list_form.song_name,
                        "song_player": _this.work_song_list_form.song_player,
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/getWorkSongList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        if (page == 1) {
                            _this.work_song_list_total = Number(data.response.result.count)
                        }
                        _this.work_song_list_table = data.response.result.data;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        // 添加歌曲
        addWorkSong() {
            let _this = this
            _this.work_song_pop_key = ''
            _this.work_song_pop_type = '1'
            _this.getWorkSongPopList(1)

            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['添加歌曲', true],
                area: ['750px', ''], // 宽高
                content: $(_this.$refs.add_work_song_pop),
            }, function () {
                layer.closeAll()
            })
        },

        // 获取歌曲列表
        getWorkSongPopList(page) {
            let _this = this
            _this.work_song_pop_page = page
            _this.work_song_pop_loading = true;
            Vue.axios.post('PublicData/api_getSongsList', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "page": page,
                        "page_size": _this.GLOBAL.PAGESIZE,
                        "name": _this.work_song_pop_type == 1 ? _this.work_song_pop_key : '',
                        "szPlayer": _this.work_song_pop_type == 2 ? _this.work_song_pop_key : ''
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        if (page == 1) {
                            _this.work_song_pop_total = Number(res.data.response.data.total);
                        }
                        _this.work_song_pop_table = res.data.response.data.rows;
                        _this.work_song_pop_loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },

        // 添加具体歌曲
        addThisWorkSong(row) {
            let _this = this
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.work_song_list_form.shop_id,
                        "song_code": row.szSong_code
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Setting/setWorkSong",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        layer.msg("添加成功！")
                        _this.getWorkSongList(1)
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        // 删除歌曲
        delThisWorkSong(row) {
            let _this = this

            layer.confirm('删除后数据将不可恢复！确认删除？', {
                btn: ['确定', '取消'],
                title: '提示',
            }, function () {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": row.id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/delWorkSong",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.msg("删除成功！")
                            _this.getWorkSongList(_this.work_song_list_page)
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("网络错误");
                    }
                });
            });
        },

        // Youtube设置
        getYoutubeSetList(page) {
            const _this = this;
            _this.loading = true;
            _this.youtube_set_page = page
            Vue.axios.post('Shop/getConfigList', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "page": page,
                        "page_size": _this.GLOBAL.PAGESIZE,
                        "config_type": 'youtube_key'
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        if (page == 1) {
                            _this.youtube_set_total = Number(res.data.response.result.count);
                        }
                        _this.youtube_set_table = res.data.response.result.data;
                        _this.loading = false;

                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },

        // 设置Youtube
        setYoutube(row) {
            let _this = this
            _this.youtube_key = row.youtube_key
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['设置Youtube', true],
                area: ['500px', ''], // 宽高
                content: $(_this.$refs.set_youtube_pop),
            }, function () {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": row.shop_id,
                            "config": _this.youtube_key,
                            "config_type": "youtube_key"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/upConfig",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function (data) {
                        if (data.response.result_code == "true") {
                            layer.closeAll();
                            layer.msg('设置成功');
                            _this.getYoutubeSetList(_this.youtube_set_page)
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function (err) {
                        layer.msg("出错啦");
                    }
                })
            })
        },

        /************************** 包厢麦克风低电量通知图配置 ************************/
        // 获取门店数据
        getMicLowPowerShopList: function () {
            let _this = this;

            let shopDatas = [];
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {}
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        let shops = data.response.result
                        shops.shift()
                        _this.mic_low_power_shop_list = shops
                        _this.mic_low_power_shop = _this.mic_low_power_shop_list[0].id
                        // 包厢号
                        _this.getBoxNum(_this.mic_low_power_shop);
                        _this.getMicLowPowerList(1)
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },

        // 切换门店
        onMicLowPowerShopChange(val) {
            this.mic_low_power_shop = val
            this.getBoxNum(this.mic_low_power_shop)
        },

        // 获取列表
        getMicLowPowerList(page) {
            const _this = this

            _this.loading = true
            _this.mic_low_power_page = page
            Vue.axios.post('Setting/getRoomMicLowPowerNoticeList', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "page": page,
                        "page_size": _this.GLOBAL.PAGESIZE,
                        "shop_id": _this.mic_low_power_shop
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        if (page == 1) {
                            _this.mic_low_power_total = Number(res.data.response.result.count);
                        }
                        _this.mic_low_power_table = res.data.response.result.data;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },

        // 点击“删除”
        micLowPowerDel(id) {
            const _this = this;

            layer.confirm('删除后不可恢复，确定删除吗？', {
                btn: ['确定', '取消']
            }, function () {
                Vue.axios.post('Setting/delRoomMicLowPowerNotice', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                })
                    .then(res => {
                        if (res.data.response.result_code == "true") {
                            layer.msg('删除成功');
                            _this.getMicLowPowerList(_this.mic_low_power_page)
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
            });
        },

        // 点击“修改”
        micLowPowerModify(row) {
            this.add_mic_low_power_form = {
                id: row.id,
                shop_id: row.shop_id,
                room_ids: row.room_ids,
                room_str: row.room_str,
                img_url: row.img_url,
            }
            if (row.room_ids.length == 1 && row.room_ids[0] == '-1') { // 全选
                this.box_all = true
                this.box_item = []
                this.box_arr_det.forEach(item => {
                    this.box_item.push(item.id)
                })
            } else {
                this.box_item = row.room_ids
            }
            this.showMicLowPowerAddPanel = true
        },

        // 点击“新增设置”
        micLowPowerAdd() {
            this.add_mic_low_power_form = {
                id: '',
                shop_id: this.mic_low_power_shop,
                room_ids: '',
                room_str: '',
                img_url: '',
            }
            this.box_all = false
            this.box_item = []
            this.showMicLowPowerAddPanel = true
        },

        // 打开适用包厢选择页面
        openMicLowPowerRoomPanel() {
            this.showMicLowPowerBox = true
        },

        // 保存选择的包厢
        saveMicLowPowerBox() {
            const _this = this;

            let texts = [];
            if (_this.box_item.length >= _this.box_arr_det.length) {
                _this.add_mic_low_power_form.room_str = '全部';
            } else {
                _this.box_arr_det.forEach(function (item) {
                    _this.box_item.forEach(function (sub) {
                        if (item.id == sub) {
                            texts.push(item.name);
                        }
                    });
                });
                _this.add_mic_low_power_form.room_str = texts.join(",");
            }
            _this.showMicLowPowerBox = false;
        },

        micLowPowerImgUpload: function () {
            if (this.mic_low_power_img_uploaders.length > 0) {
                this.mic_low_power_img_uploaders.forEach(item => {
                    item.destroy()
                })
                this.mic_low_power_img_uploaders = []
            }
            let _this = this;
            let host = '',
                dir = '',
                file_name = '';

            // 实例化一个plupload上传对象
            let uploader = new plupload.Uploader({
                browse_button: 'mic-low-power-img-wrapper', // 选择文件id
                filters: {
                    mime_types: [ // 文件格式限制
                        { title: "Image files", extensions: "jpg,jpeg,png,gif" }
                    ],
                    // max_file_size: '2mb', // 文件大小限制
                    // prevent_duplicates: true // 不允许选取重复文件
                },
                resize: {
                    width: 688,
                    height: 475
                },
                multi_selection: false, // 单选
                url: './', // OSS地址
                init: {
                    // 文件上传前触发
                    BeforeUpload: function (up, file) { },
                    // 文件选择完毕触发
                    FilesAdded: function (up, files) {
                        // 获取签名
                        Vue.axios.post('publicData/api_getOssSignature', {
                            "header": Vue.request_header,
                            "request": {
                                "version": Vue.version,
                                "param": {
                                    "file": files[0].name,
                                    "path": 'system_set'
                                }
                            },
                            "comment": ""
                        })
                            .then(res => {
                                if (res.data.response.result_code == "true") {
                                    host = res.data.response.data.host;
                                    dir = res.data.response.data.dir;
                                    file_name = res.data.response.data.file_name;
                                    const new_params = {
                                        'key': dir + file_name,
                                        'OSSAccessKeyId': res.data.response.data.accessid,
                                        'policy': res.data.response.data.policy,
                                        'signature': res.data.response.data.signature,
                                        'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
                                    };
                                    up.setOption({
                                        'url': host,
                                        'multipart_params': new_params
                                    });

                                    // 上传文件
                                    uploader.start();
                                } else {
                                    Vue.timeoutfun(data.response.result_status, _this);
                                    layer.msg(data.response.error_msg);
                                }
                            })
                            .catch(err => {
                                layer.msg("出错啦");
                            });
                    },
                    // 文件上传成功触发
                    FileUploaded: function (up, file, data) {
                        _this.add_mic_low_power_form.img_url = host + "/" + dir + file_name
                    },
                    // 错误提示
                    Error: function (up, err) {
                        if (err.code == -600) {
                            layer.msg('请选择2mb以内的文件');
                        } else if (err.code == -601) {
                            layer.msg('只允许上传jpg,jpeg,png,gif文件');
                        } else if (err.code == -602) {
                            layer.msg('这个文件已经上传过一遍了');
                        } else {
                            layer.msg(err.response);
                        }
                    }
                }
            });
            // 初始化
            uploader.init();
            _this.mic_low_power_img_uploaders.push(uploader)
        },

        commitMicLowPowerSet() {
            let _this = this
            let room_ids = _this.box_item.length == _this.box_arr_det.length ? ['-1'] : _this.box_item
            Vue.axios.post('Setting/setRoomMicLowPowerNotice', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": _this.add_mic_low_power_form.id,
                        "shop_id": _this.add_mic_low_power_form.shop_id,
                        "room_ids": room_ids,
                        "img_url": _this.add_mic_low_power_form.img_url
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        if (_this.add_mic_low_power_form.id == '') {
                            layer.msg('新增成功！');
                            _this.mic_low_power_page = 1
                        } else {
                            layer.msg('修改成功！');
                        }
                        _this.showMicLowPowerAddPanel = false
                        _this.getMicLowPowerList(_this.mic_low_power_page)
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
        },
        // 获取广告机设置
        getAdSetList(page) {
            const _this = this;

            _this.loading = true
            _this.ad_set_page = page
            Vue.axios.post('Shop/getConfigList', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": page,
                        "page_size": _this.GLOBAL.PAGESIZE,
                        "config_type": "ad_machine"
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        if (page == 1) {
                            _this.ad_set_total = Number(res.data.response.result.count);
                        }
                        _this.ad_set_table = res.data.response.result.data;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },
        // 获取门店数据
        getAdSetShopList: function () {
            let _this = this;

            let shopDatas = [];
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {}
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        let shops = data.response.result
                        shops.shift()
                        _this.ad_set_shop_list = shops
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                }
            });
        },
        // 广告机状态改变
        adSetStatusChange(row) {
            const _this = this;
            Vue.axios.post('Shop/upConfig', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": row.shop_id,
                        "config_type": 'ad_machine',
                        "config": row.ad_machine
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg('修改成功！');
                        _this.getAdSetList(_this.ad_set_page)
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
        },
        // 触摸屏显示内容设置
        adSetTouchScreen(row) {
            let _this = this
            console.log('row', row);

            _this.ad_set_list_show = false
            _this.ad_set_touch_list_show = true
            _this.ad_set_touch_list_shop_id = row.shop_id
            _this.ad_set_touch_list_shop_name = row.shop_name
            _this.bg_set_form.ad_machine_px = row.ad_machine_px
            _this.bg_set_form.ad_machine_img = row.ad_machine_img
            _this.getAdSetTouchScreenList()

        },
        // 获取触摸屏显示内容设置列表
        getAdSetTouchScreenList() {
            let _this = this
            _this.loading = true
            _this.ad_set_touch_list_table = []
            Vue.axios.post('Setting/getTouchScreenAdList', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.ad_set_touch_list_shop_id,
                        "status": _this.ad_set_touch_list_status
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        _this.ad_set_touch_list_table = res.data.response.result
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                        _this.adSetTouchScreenBack()
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
            _this.loading = false

        },

        // 触摸屏显示内容设置返回
        adSetTouchScreenBack() {
            let _this = this
            _this.ad_set_list_show = true
            _this.ad_set_touch_list_show = false
            _this.getAdSetList(_this.ad_set_page)
        },
        // 预览触摸屏显示内容设置图片
        previewTouchScreenImage() {
            let _this = this
            layer.open({
                type: 1,
                title: '触摸屏显示内容设置示例',
                content: `<div style="text-align: center; padding: 20px;">
                    <img src="${this.touch_screen_img}" style="max-width: 100%; object-fit: contain;">
                </div>`,
                area: ['400px', '800px'],
                shadeClose: true,
                shade: 0.5,
                anim: 2,
            })
        },
        // 触摸屏背景图设置
        bgSet() {
            let _this = this

            _this.uploadAdMachineImg()
            // 打开一个弹窗，可以上传一张图片，图片上传成功后，显示在弹窗中
            layer.confirm('', {
                skin: 'pb-alert-skin',
                type: 1,
                content: $(_this.$refs.bg_set_form),
                area: ['450px', '600px'],
                btn: ['确定', '取消'],
                title: ['操作指引设置', true],
                cancel: function () {
                }
            }, function () {
                if (_this.bg_set_form.ad_machine_img == '') {
                    layer.msg('请上传触摸屏背景图');
                    return
                }
                if (_this.bg_set_form.ad_machine_px == '') {
                    layer.msg('请输入起始高度');
                    return
                }
                Vue.axios.post('Shop/upConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            'id': _this.ad_set_touch_list_shop_id,
                            'config_type': 'machine_info',
                            'config': _this.bg_set_form
                        }
                    },
                    "comment": ""
                })
                    .then(res => {
                        if (res.data.response.result_code == "true") {
                            layer.msg('设置成功');
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg("出错啦");
                    })
            }, function () {
            });

        },
        // 上传触摸屏背景图
        uploadAdMachineImg() {
            if (this.ad_machine_img_uploaders.length > 0) {
                this.ad_machine_img_uploaders.forEach(item => {
                    item.destroy()
                })
                this.ad_machine_img_uploaders = []
            }
            let _this = this;
            let host = '',
                dir = '',
                file_name = '';

            // 实例化一个plupload上传对象
            let uploader = new plupload.Uploader({
                browse_button: 'ad_machine_img_up', // 选择文件id
                filters: {
                    mime_types: [ // 文件格式限制
                        { title: "Image files", extensions: "jpg,jpeg,png,gif" }
                    ],
                    max_file_size: '2mb', // 文件大小限制
                    // prevent_duplicates: true // 不允许选取重复文件
                },
                resize: {
                    width: 1080,
                    height: 1920
                },
                multi_selection: false, // 单选
                url: './', // OSS地址
                init: {
                    // 文件上传前触发
                    BeforeUpload: function (up, file) { },
                    // 文件选择完毕触发
                    FilesAdded: function (up, files) {
                        // 获取签名
                        Vue.axios.post('publicData/api_getOssSignature', {
                            "header": Vue.request_header,
                            "request": {
                                "version": Vue.version,
                                "param": {
                                    "file": files[0].name,
                                    "path": 'system_set'
                                }
                            },
                            "comment": ""
                        })
                            .then(res => {
                                if (res.data.response.result_code == "true") {
                                    host = res.data.response.data.host;
                                    dir = res.data.response.data.dir;
                                    file_name = res.data.response.data.file_name;
                                    const new_params = {
                                        'key': dir + file_name,
                                        'OSSAccessKeyId': res.data.response.data.accessid,
                                        'policy': res.data.response.data.policy,
                                        'signature': res.data.response.data.signature,
                                        'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
                                    };
                                    up.setOption({
                                        'url': host,
                                        'multipart_params': new_params
                                    });

                                    // 上传文件
                                    uploader.start();
                                } else {
                                    Vue.timeoutfun(data.response.result_status, _this);
                                    layer.msg(data.response.error_msg);
                                }
                            })
                            .catch(err => {
                                layer.msg("出错啦");
                            });
                    },
                    // 文件上传成功触发
                    FileUploaded: function (up, file, data) {
                        _this.bg_set_form.ad_machine_img = host + "/" + dir + file_name
                    },
                    // 错误提示
                    Error: function (up, err) {
                        if (err.code == -600) {
                            layer.msg('请选择2mb以内的文件');
                        } else if (err.code == -601) {
                            layer.msg('只允许上传jpg,jpeg,png,gif文件');
                        } else if (err.code == -602) {
                            layer.msg('这个文件已经上传过一遍了');
                        } else {
                            layer.msg(err.response);
                        }
                    }
                }
            });
            // 初始化
            uploader.init();
            _this.ad_machine_img_uploaders.push(uploader)
        },
        delAdMachineImg() {
            this.bg_set_form.ad_machine_img = ''
        },



        // 屏保设置
        screensaverSet() {
            let _this = this
            _this.ad_set_touch_list_show = false
            _this.screensaver_set_show = true
            _this.getScreensaverSetImgs()
        },
        // 获取屏保图片列表
        getScreensaverSetImgs() {
            let _this = this
            _this.screensaver_set_imgs = []
            _this.screensaver_img_uploaders = []
            Vue.axios.post('AdMachine/getScreensaver', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.ad_set_touch_list_shop_id
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        _this.screensaver_set_imgs = res.data.response.result.screensaver
                        // 初始化上传器
                        _this.uploadScreensaverImg()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
        },

        // 屏保设置返回
        screensaverSetBack() {
            let _this = this
            _this.screensaver_set_show = false
            _this.ad_set_touch_list_show = true
            _this.getAdSetTouchScreenList()
            // 返回的时候清除图片上传器
            if (this.screensaver_img_uploaders.length > 0) {
                this.screensaver_img_uploaders.forEach(v => {
                    v.destroy()
                })
                this.screensaver_img_uploaders = []
            }
        },

        // 屏保设置保存
        screensaverSetSave() {
            let _this = this
            console.log(_this.screensaver_set_imgs)
            Vue.axios.post('AdMachine/setScreensaver', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.ad_set_touch_list_shop_id,
                        "screensaver": _this.screensaver_set_imgs
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg('保存成功')
                        _this.screensaverSetBack()

                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
        },













        // 点击新增营销位
        add_ad_set() {
            let _this = this
            _this.isEdit_ad_touch = false
            _this.ad_set_touch_list_show = false
            _this.new_edit_ad_show = true

            _this.new_edit_ad_form = {
                id: '',
                style: 1, // 固定不变 1：触摸屏，2：tv 
                type: 1, // 1 => '一张长图', 2 => '两张大图', 3 => '三张图', 4 => '多图轮播', 5 => '单图轮播'
                shop_id: _this.ad_set_touch_list_shop_id,
                title: '',
                listorder: '',
                content: [
                    {
                        img: "",//封面
                        content_type: '1',//详情页内容 1:无 2:图片
                        content_url: ""//详情页内容图片
                    },
                ]
            }
            _this._formateUploadDom()

        },


        // 新增修改营销位返回按钮
        newEditAdBack() {
            let _this = this
            _this.new_edit_ad_show = false
            _this.ad_set_touch_list_show = true
            // 返回的时候销毁所有上传器
            _this.destroyPlupload()
            _this.getAdSetTouchScreenList()
        },

        // 切换图片类型
        changeType: function (val) {
            if (val == '1' || val == '4' || val == '5') {
                this.new_edit_ad_form.content = [
                    {
                        img: "",//封面
                        content_type: '1',//详情页内容 1:无 2:图片
                        content_url: ""//详情页内容图片
                    }
                ]
            }
            else if (val == '2') {
                this.new_edit_ad_form.content = [
                    {
                        img: "",//封面
                        content_type: '1',//详情页内容 1:无 2:图片
                        content_url: ""//详情页内容图片
                    },
                    {
                        img: "",//封面
                        content_type: '1',//详情页内容 1:无 2:图片
                        content_url: ""//详情页内容图片
                    }
                ]
            }
            else if (val == '3') {
                this.new_edit_ad_form.content = [
                    {
                        img: "",//封面
                        content_type: '1',//详情页内容 1:无 2:图片
                        content_url: ""//详情页内容图片
                    },
                    {
                        img: "",//封面
                        content_type: '1',//详情页内容 1:无 2:图片
                        content_url: ""//详情页内容图片
                    },
                    {
                        img: "",//封面
                        content_type: '1',//详情页内容 1:无 2:图片
                        content_url: ""//详情页内容图片
                    }
                ]
            }
            this.destroyPlupload()
            this._formateUploadDom()
        },
        // 初始化上传图片/视频
        initUpload: function (btnName, index, type) {

            console.log('initIndex', index);

            let _this = this;
            let host = '',
                dir = '',
                file_name = '';
            let allow_type = type == 'img' ? 'jpg,jpeg,png,gif' : 'mp4,mkv,m4v,avi'
            let resize_width = '',
                resize_height = '';
            if (btnName.indexOf("faceImg") > -1) {
                resize_width = 1920
                resize_height = 1080
            } else if (btnName.indexOf("contentImg") > -1) {
                resize_width = 1080
                resize_height = 1920
            }

            setTimeout(function () {
                // 实例化一个plupload上传对象
                let uploader = new plupload.Uploader({
                    browse_button: btnName, // 选择文件id
                    filters: {
                        mime_types: [ // 文件格式限制
                            { title: "Image files", extensions: allow_type }
                        ],
                        // max_file_size: '2mb', // 文件大小限制
                        // prevent_duplicates: true // 不允许选取重复文件
                    },
                    resize: {
                        width: resize_width,
                        height: resize_height
                    },
                    multi_selection: false, // 单选
                    url: './', // OSS地址
                    init: {
                        // 文件上传前触发
                        BeforeUpload: function (up, file) { },
                        // 文件选择完毕触发
                        FilesAdded: function (up, files) {
                            // 获取签名
                            Vue.axios.post('publicData/api_getOssSignature', {
                                "header": Vue.request_header,
                                "request": {
                                    "version": Vue.version,
                                    "param": {
                                        "file": files[0].name,
                                        "path": 'system_set'
                                    }
                                },
                                "comment": ""
                            })
                                .then(res => {
                                    if (res.data.response.result_code == "true") {
                                        host = res.data.response.data.host;
                                        dir = res.data.response.data.dir;
                                        file_name = res.data.response.data.file_name;
                                        const new_params = {
                                            'key': dir + file_name,
                                            'OSSAccessKeyId': res.data.response.data.accessid,
                                            'policy': res.data.response.data.policy,
                                            'signature': res.data.response.data.signature,
                                            'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
                                        };
                                        up.setOption({
                                            'url': host,
                                            'multipart_params': new_params
                                        });

                                        // 上传文件
                                        uploader.start();
                                    } else {
                                        Vue.timeoutfun(data.response.result_status, _this);
                                        layer.msg(data.response.error_msg);
                                    }
                                })
                                .catch(err => {
                                    layer.msg("出错啦");
                                });
                        },
                        // 文件上传成功触发
                        FileUploaded: function (up, file, data) {
                            let file_url = host + "/" + dir + file_name
                            console.log("文件上传成功：", file_url)
                            if (btnName.indexOf("faceImg") > -1) {
                                _this.new_edit_ad_form.content[index].img = file_url
                            } else if (btnName.indexOf("contentImg") > -1) {
                                _this.new_edit_ad_form.content[index].content_url = file_url
                            } else if (btnName.indexOf("contentVideo") > -1) {
                                _this.new_edit_ad_form.content[index].content_url = file_url
                            }
                        },
                        // 错误提示
                        Error: function (up, err) {
                            if (err.code == -600) {
                                layer.msg('请选择2mb以内的文件');
                            } else if (err.code == -601) {
                                layer.msg('只允许上传' + allow_type + '文件');
                            } else if (err.code == -602) {
                                layer.msg('这个文件已经上传过一遍了');
                            } else {
                                layer.msg(err.response);
                            }
                        },
                        // 初始化完成触发
                        PostInit: function () {
                            if (btnName.indexOf("content") > -1) {
                                if (_this.new_edit_ad_form.content[index].uploader_list && _this.new_edit_ad_form.content[index].uploader_list.length > 0) {
                                    _this._destroyContentUploader(index)
                                    _this.new_edit_ad_form.content[index].uploader_list.push(uploader)
                                } else {
                                    _this.$set(_this.new_edit_ad_form.content[index], 'uploader_list', [uploader])
                                }
                            } else {
                                _this.plupload_list.push(uploader)
                            }
                        }
                    }
                });
                // 初始化
                uploader.init();
            }, 20);
        },

        // 整理需要初始化上传的dom
        _formateUploadDom: function () {
            if (this.new_edit_ad_form.content.length > 0) {
                this.new_edit_ad_form.content.forEach((item, index) => {
                    this.initUpload('faceImg' + index, index, 'img')
                    if (item.style == '1') { // 广告内容是图片
                        this.initUpload('contentImg' + index, index, 'img')
                    }
                })
            }
        },

        // 销毁不必要的Plupload实例
        destroyPlupload: function () {
            console.log('destroyPlupload')
            if (this.plupload_list.length > 0) {
                this.plupload_list.forEach(v => {
                    v.destroy()
                })
                this.plupload_list = []
            }
        },

        // 切换广告内容类型
        contentTypeChange: function (val, index) {

            this.$nextTick(() => {
                if (val == '1') { // 无
                    if (this.new_edit_ad_form.content[index].uploader_list && this.new_edit_ad_form.content[index].uploader_list.length > 0) {
                        this._destroyContentUploader(index)
                    }
                } else if (val == '2') { // 图片
                    this.initUpload("contentImg" + index, index, 'img')
                }
            })
        },

        _destroyContentUploader: function (index) {
            this.new_edit_ad_form.content[index].uploader_list.forEach(v => {
                v.destroy()
            })
            this.new_edit_ad_form.content[index].uploader_list = []
        },
        // 新增图片
        addImg: function () {
            this.new_edit_ad_form.content.push({
                img: '',
                content_type: '1',
                content_url: '',
            })

            this.initUpload('faceImg' + (this.new_edit_ad_form.content.length - 1), this.new_edit_ad_form.content.length - 1, 'img')
        },
        // (多图轮播）删除图片
        deleteThisImg: function (index) {
            this.new_edit_ad_form.content.splice(index, 1)
            this.destroyPlupload()
            this._formateUploadDom()
        },
        // 新增修改营销位确认
        newEditAdConfirm: function () {
            let _this = this
            console.log(_this.new_edit_ad_form)
            if (_this.new_edit_ad_form.listorder == '') {
                layer.msg('请输入排序')
                return
            }
            if (_this.new_edit_ad_form.title == '') {
                layer.msg('请输入营销位名称')
                return
            }
            // 循环判断img是否为空
            for (let i = 0; i < _this.new_edit_ad_form.content.length; i++) {
                if (_this.new_edit_ad_form.content[i].img == '') {
                    layer.msg('请上传图片')
                    return
                }
            }
            // 循环判断当content_type为2时，content_url是否为空
            for (let i = 0; i < _this.new_edit_ad_form.content.length; i++) {
                if (_this.new_edit_ad_form.content[i].content_type == '2') {
                    if (_this.new_edit_ad_form.content[i].content_url == '') {
                        layer.msg('请上传图片')
                        return
                    }
                }
            }
            Vue.axios.post('Setting/setScreenAds', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": _this.new_edit_ad_form
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg(_this.new_edit_ad_form.id == '' ? '新增成功' : '修改成功')
                        _this.newEditAdBack()
                    } else {
                        layer.msg(res.data.response.error_msg)
                        Vue.timeoutfun(res.data.response.result_status, _this);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },
        // 禁用营销位
        adSetTouchScreenStatus(row) {
            let _this = this

            Vue.axios.post('Setting/setAdStatus', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": row.id,
                        "status": row.status == 1 ? 2 : 1
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg('操作成功')
                        _this.getAdSetTouchScreenList()
                    } else {
                        layer.msg(res.data.response.error_msg)
                        Vue.timeoutfun(res.data.response.result_status, _this);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
        },
        // 删除营销位
        adSetTouchScreenDelete(row) {
            let _this = this
            layer.confirm('确定要删除该营销位吗？', {
                btn: ['确定', '取消']
            }, function (index) {
                // 确认删除
                Vue.axios.post('Setting/deleteAd', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": row.id
                        }
                    },
                    "comment": ""
                })
                    .then(res => {
                        if (res.data.response.result_code == "true") {
                            layer.msg('删除成功')
                            _this.getAdSetTouchScreenList()
                        } else {
                            layer.msg(res.data.response.error_msg)
                            Vue.timeoutfun(res.data.response.result_status, _this);
                        }
                    })
                    .catch(err => {
                        layer.msg("出错啦");
                    });
                layer.close(index);
            }, function () {
                // 取消删除
            });
        },
        // 修改运营位
        adSetTouchScreenEdit(row) {
            let _this = this
            _this.isEdit_ad_touch = true
            _this.ad_set_touch_list_show = false
            _this.new_edit_ad_show = true
            _this.new_edit_ad_form.listorder = row.listorder
            _this.new_edit_ad_form.title = row.title
            _this.new_edit_ad_form.id = row.id
            _this.new_edit_ad_form.type = Number(row.type)
            _this.new_edit_ad_form.shop_id = _this.ad_set_touch_list_shop_id
            Vue.axios.post('Setting/getAdDetail', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": row.id
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        _this.new_edit_ad_form.content = res.data.response.result
                        _this._formateUploadDom()
                    } else {
                        layer.msg(res.data.response.error_msg)
                        Vue.timeoutfun(res.data.response.result_status, _this);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
        },

        // TV屏显示内容设置
        adSetTvScreen(row) {
            let _this = this
            console.log('row', row)
            _this.ad_set_tv_show = true
            _this.ad_set_list_show = false
            _this.ad_set_tv_list_shop_name = row.shop_name
            _this.ad_set_tv_list_shop_id = row.shop_id

            Vue.axios.post('Setting/getTvAd', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": row.shop_id
                    }
                },
                "comment": ""
            })
                .then(res => {
                    console.log('res', res)
                    if (res.data.response.result_code == "true") {
                        if (res.data.response.result.id) {
                            if (res.data.response.result.type == '1') {
                                _this.uploadTvImg()
                            } else if (res.data.response.result.type == '2') {
                                _this.uploadTvVideo()
                            }
                            _this.tv_form = res.data.response.result
                        } else {
                            _this.tv_form = {
                                id: '',//修改必传
                                style: '2',//固定值2 tv屏
                                type: '1',//类型 1 => '图片轮播', 2 => '视频播放'
                                interval: '',//轮播间隔仅type=1时
                                shop_id: '',//门店id
                                content: []//图片链接
                            }
                            _this.uploadTvImg()
                        }
                    } else {
                        layer.msg(res.data.response.error_msg)
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        _this.adSetTvScreenBack()
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
        },
        // 预览TV屏显示内容
        previewTvScreenImage() {
            let _this = this
            layer.open({
                type: 1,
                title: '触摸屏显示内容设置示例',
                content: `<div style="text-align: center; padding: 20px;">
                     <img src="${this.tv_screen_img}" style="max-width: 100%; object-fit: contain;">
                 </div>`,
                area: ['400px', '800px'],
                shadeClose: true,
                shade: 0.5,
                anim: 2,
            })
        },
        // 删除TV屏图片
        deleteTvImage(index) {
            let _this = this
            layer.confirm('确定要删除该图片吗？', {
                btn: ['确定', '取消']
            }, function (layerIndex) {
                _this.tv_form.content.splice(index, 1)
                layer.close(layerIndex);
                // 删除后重新初始化上传器，等待DOM更新
                _this.$nextTick(() => {
                    _this.uploadTvImg()
                })
            });
        },

        // 删除屏保图片
        deleteScreensaverImage(index) {
            let _this = this
            layer.confirm('确定要删除该图片吗？', {
                btn: ['确定', '取消']
            }, function (layerIndex) {
                _this.screensaver_set_imgs.splice(index, 1)
                layer.close(layerIndex);
                // 删除后重新初始化上传器，等待DOM更新
                _this.$nextTick(() => {
                    _this.uploadScreensaverImg()
                })
            });
        },

        // 上传触摸屏背景图
        uploadTvImg() {
            if (this.tv_img_uploader.length > 0) {
                this.tv_img_uploader.forEach(item => {
                    item.destroy()
                })
                this.tv_img_uploader = []
            }
            // 已达上限则不再创建上传器，避免遮罩叠盖到其它元素
            if (this.tv_form && Array.isArray(this.tv_form.content) && this.tv_form.content.length >= 10) {
                return
            }
            let _this = this;
            let host = '',
                dir = '',
                file_name = '';

            setTimeout(() => {
                // 实例化一个plupload上传对象
                let uploader = new plupload.Uploader({
                    browse_button: 'tv_img_uploader_btn', // 选择文件id
                    filters: {
                        mime_types: [ // 文件格式限制
                            { title: "Image files", extensions: "jpg,jpeg,png,gif" }
                        ],
                        max_file_size: '2mb', // 文件大小限制
                        // prevent_duplicates: true // 不允许选取重复文件
                    },
                    // resize: {
                    //     width: 688,
                    //     height: 475
                    // },
                    multi_selection: false, // 单选
                    url: './', // OSS地址
                    init: {
                        // 文件上传前触发
                        BeforeUpload: function (up, file) { },
                        // 文件选择完毕触发
                        FilesAdded: function (up, files) {
                            // 检查图片数量限制
                            if (_this.tv_form.content.length >= 10) {
                                layer.msg('最多只能上传10张图片');
                                return;
                            }
                            // 获取签名
                            Vue.axios.post('publicData/api_getOssSignature', {
                                "header": Vue.request_header,
                                "request": {
                                    "version": Vue.version,
                                    "param": {
                                        "file": files[0].name,
                                        "path": 'system_set'
                                    }
                                },
                                "comment": ""
                            })
                                .then(res => {
                                    if (res.data.response.result_code == "true") {
                                        host = res.data.response.data.host;
                                        dir = res.data.response.data.dir;
                                        file_name = res.data.response.data.file_name;
                                        const new_params = {
                                            'key': dir + file_name,
                                            'OSSAccessKeyId': res.data.response.data.accessid,
                                            'policy': res.data.response.data.policy,
                                            'signature': res.data.response.data.signature,
                                            'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
                                        };
                                        up.setOption({
                                            'url': host,
                                            'multipart_params': new_params
                                        });

                                        // 上传文件
                                        uploader.start();
                                    } else {
                                        Vue.timeoutfun(data.response.result_status, _this);
                                        layer.msg(data.response.error_msg);
                                    }
                                })
                                .catch(err => {
                                    layer.msg("出错啦");
                                });
                        },
                        // 文件上传成功触发
                        FileUploaded: function (up, file, data) {
                            let img = host + "/" + dir + file_name
                            _this.tv_form.content.push(img)
                            // DOM 更新后重定位上传器遮罩，防止覆盖到最后一张图片
                            _this.$nextTick(() => {
                                up.refresh()
                                // 如果达到上限，销毁当前上传器，防止遮罩残留
                                if (_this.tv_form.content.length >= 10) {
                                    try { up.destroy() } catch (e) { }
                                    const idx = _this.tv_img_uploader.indexOf(up)
                                    if (idx > -1) { _this.tv_img_uploader.splice(idx, 1) }
                                }
                            })
                        },
                        // 错误提示
                        Error: function (up, err) {
                            if (err.code == -600) {
                                layer.msg('请选择2mb以内的文件');
                            } else if (err.code == -601) {
                                layer.msg('只允许上传jpg,jpeg,png,gif文件');
                            } else if (err.code == -602) {
                                layer.msg('这个文件已经上传过一遍了');
                            } else {
                                layer.msg(err.response);
                            }
                        }
                    }
                });
                // 初始化
                uploader.init();
                _this.tv_img_uploader.push(uploader)
                // 初始化后等待DOM稳定再刷新一次，确保遮罩准确覆盖上传按钮
                _this.$nextTick(() => {
                    uploader.refresh()
                })
            }, 20);
        },

        // 上传屏保图
        uploadScreensaverImg() {
            if (this.screensaver_img_uploaders.length > 0) {
                this.screensaver_img_uploaders.forEach(item => {
                    item.destroy()
                })
                this.screensaver_img_uploaders = []
            }
            // 已达上限则不再创建上传器，避免遮罩叠盖到其它元素
            if (this.screensaver_set_imgs.length >= 10) {
                return
            }
            let _this = this;
            let host = '',
                dir = '',
                file_name = '';

            setTimeout(() => {
                // 实例化一个plupload上传对象
                let uploader = new plupload.Uploader({
                    browse_button: 'screensaver_img_uploader_btn', // 选择文件id
                    filters: {
                        mime_types: [ // 文件格式限制
                            { title: "Image files", extensions: "jpg,jpeg,png,gif" }
                        ],
                        max_file_size: '2mb', // 文件大小限制
                        // prevent_duplicates: true // 不允许选取重复文件
                    },
                    // resize: {
                    //     width: 688,
                    //     height: 475
                    // },
                    multi_selection: false, // 单选
                    url: './', // OSS地址
                    init: {
                        // 文件上传前触发
                        BeforeUpload: function (up, file) { },
                        // 文件选择完毕触发
                        FilesAdded: function (up, files) {
                            // 检查图片数量限制
                            if (_this.screensaver_set_imgs.length >= 10) {
                                layer.msg('最多只能上传10张图片');
                                return;
                            }
                            // 获取签名
                            Vue.axios.post('publicData/api_getOssSignature', {
                                "header": Vue.request_header,
                                "request": {
                                    "version": Vue.version,
                                    "param": {
                                        "file": files[0].name,
                                        "path": 'system_set'
                                    }
                                },
                                "comment": ""
                            })
                                .then(res => {
                                    if (res.data.response.result_code == "true") {
                                        host = res.data.response.data.host;
                                        dir = res.data.response.data.dir;
                                        file_name = res.data.response.data.file_name;
                                        const new_params = {
                                            'key': dir + file_name,
                                            'OSSAccessKeyId': res.data.response.data.accessid,
                                            'policy': res.data.response.data.policy,
                                            'signature': res.data.response.data.signature,
                                            'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
                                        };
                                        up.setOption({
                                            'url': host,
                                            'multipart_params': new_params
                                        });

                                        // 上传文件
                                        uploader.start();
                                    } else {
                                        Vue.timeoutfun(data.response.result_status, _this);
                                        layer.msg(data.response.error_msg);
                                    }
                                })
                                .catch(err => {
                                    layer.msg("出错啦");
                                });
                        },
                        // 文件上传成功触发
                        FileUploaded: function (up, file, data) {
                            let img = host + "/" + dir + file_name
                            _this.screensaver_set_imgs.push(img)
                            // DOM 更新后重定位上传器遮罩，防止覆盖到最后一张图片
                            _this.$nextTick(() => {
                                up.refresh()
                                // 如果达到上限，销毁当前上传器，防止遮罩残留
                                if (_this.screensaver_set_imgs.length >= 10) {
                                    try { up.destroy() } catch (e) { }
                                    const idx = _this.screensaver_img_uploaders.indexOf(up)
                                    if (idx > -1) { _this.screensaver_img_uploaders.splice(idx, 1) }
                                }
                            })
                        },
                        // 错误提示
                        Error: function (up, err) {
                            if (err.code == -600) {
                                layer.msg('请选择2mb以内的文件');
                            } else if (err.code == -601) {
                                layer.msg('只允许上传jpg,jpeg,png,gif文件');
                            } else if (err.code == -602) {
                                layer.msg('这个文件已经上传过一遍了');
                            } else {
                                layer.msg(err.response);
                            }
                        }
                    }
                });
                // 初始化
                uploader.init();
                _this.screensaver_img_uploaders.push(uploader)
                // 初始化后等待DOM稳定再刷新一次，确保遮罩准确覆盖上传按钮
                _this.$nextTick(() => {
                    uploader.refresh()
                })
            }, 20);
        },
        // 上传触摸屏视频
        uploadTvVideo() {
            if (this.tv_video_uploader.length > 0) {
                this.tv_video_uploader.forEach(item => {
                    item.destroy()
                })
                this.tv_video_uploader = []
            }
            let _this = this;
            let host = '',
                dir = '',
                file_name = '';

            setTimeout(() => {
                // 实例化一个plupload上传对象
                let uploader = new plupload.Uploader({
                    browse_button: 'tv_video_uploader_btn', // 选择文件id
                    filters: {
                        mime_types: [ // 文件格式限制
                            { title: "Image files", extensions: 'mp4,mkv,m4v,avi' }
                        ],
                        // max_file_size: '2mb', // 文件大小限制
                        // prevent_duplicates: true // 不允许选取重复文件
                    },
                    // resize: {
                    //     width: 688,
                    //     height: 475
                    // },
                    multi_selection: false, // 单选
                    url: './', // OSS地址
                    init: {
                        // 文件上传前触发
                        BeforeUpload: function (up, file) { },
                        // 文件选择完毕触发
                        FilesAdded: function (up, files) {
                            // 获取签名
                            Vue.axios.post('publicData/api_getOssSignature', {
                                "header": Vue.request_header,
                                "request": {
                                    "version": Vue.version,
                                    "param": {
                                        "file": files[0].name,
                                        "path": 'system_set'
                                    }
                                },
                                "comment": ""
                            })
                                .then(res => {
                                    if (res.data.response.result_code == "true") {
                                        host = res.data.response.data.host;
                                        dir = res.data.response.data.dir;
                                        file_name = res.data.response.data.file_name;
                                        const new_params = {
                                            'key': dir + file_name,
                                            'OSSAccessKeyId': res.data.response.data.accessid,
                                            'policy': res.data.response.data.policy,
                                            'signature': res.data.response.data.signature,
                                            'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
                                        };
                                        up.setOption({
                                            'url': host,
                                            'multipart_params': new_params
                                        });

                                        // 上传文件
                                        uploader.start();
                                    } else {
                                        Vue.timeoutfun(data.response.result_status, _this);
                                        layer.msg(data.response.error_msg);
                                    }
                                })
                                .catch(err => {
                                    layer.msg("出错啦");
                                });
                        },
                        // 文件上传成功触发
                        FileUploaded: function (up, file, data) {
                            let video = host + "/" + dir + file_name
                            _this.tv_form.content = video
                        },
                        // 错误提示
                        Error: function (up, err) {
                            if (err.code == -600) {
                                layer.msg('请选择2mb以内的文件');
                            } else if (err.code == -601) {
                                layer.msg('只允许上传jpg,jpeg,png,gif文件');
                            } else if (err.code == -602) {
                                layer.msg('这个文件已经上传过一遍了');
                            } else {
                                layer.msg(err.response);
                            }
                        }
                    }
                });
                // 初始化
                uploader.init();
                _this.tv_video_uploader.push(uploader)
            }, 20);
            console.log('视频上传器初始化完成');

        },
        // tv屏返回
        adSetTvScreenBack() {
            this.ad_set_tv_show = false
            this.ad_set_list_show = true
            this.getAdSetList()
        },
        // 切换内容显示类型
        changeTvType: function (val) {
            console.log(val)
            if (val == '1') {
                this.tv_form.content = []
                this.tv_form.type = '1'
                this.uploadTvImg()
            } else if (val == '2') {
                this.tv_form.content = ''
                this.tv_form.type = '2'
                this.uploadTvVideo()
            }
        },
        saveTv() {
            let _this = this;

            Vue.axios.post('Setting/setScreenAds', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": _this.tv_form.id,
                        "style": 2,
                        "type": _this.tv_form.type,
                        "interval": _this.tv_form.interval,
                        "shop_id": _this.ad_set_tv_list_shop_id,
                        "content": _this.tv_form.content
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg("保存成功");
                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
        },

        //******************** 广告机设置同步 ******************/
        // 点击同步按钮
        adSetSync(row) {
            if (!row.shop_id) {
                layer.msg('门店信息错误');
                return;
            }

            // 设置当前门店信息
            this.current_sync_shop_id = row.shop_id;
            this.current_sync_shop_name = row.shop_name;

            // 重置选择状态
            this.selectAll_adSet = false;
            this.selectedShops_adSet = [];

            // 打开同步弹窗
            layer.open({
                type: 1,
                title: '同步提示',
                skin: 'public-alert-skin',
                area: ['600px', '600px'],
                content: $(this.$refs.ad_set_sync_pop),
            });
        },

        // 全选/反全选
        handleSelectAll_adSet(checked) {
            if (checked) {
                // 全选：将所有其他门店的id加入数组
                this.selectedShops_adSet = this.ad_set_shop_list
                    .filter(shop => shop.id != this.current_sync_shop_id)
                    .map(shop => shop.id);
            } else {
                // 反全选：清空数组
                this.selectedShops_adSet = [];
            }
        },

        // 取消同步
        cancelSync_adSet() {
            layer.closeAll();
        },

        // 确认同步
        confirmSync_adSet() {
            if (this.selectedShops_adSet.length === 0) {
                layer.msg('请选择要同步的门店');
                return;
            }

            const _this = this;
            layer.confirm('确认要将当前门店的广告机设置同步到选中的门店吗？', {
                btn: ['确定', '取消'],
                title: '确认同步'
            }, function () {
                _this.doSync_adSet();
            });
        },

        // 执行同步
        doSync_adSet() {
            const _this = this;

            // 显示loading遮罩层
            const loadingIndex = layer.load(1, {
                shade: [0.3, '#000'] // 0.3透明度的黑色背景
            });

            Vue.axios.post('Setting/batchSetAd', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "origin_shop_id": _this.current_sync_shop_id,
                        "shop_ids": _this.selectedShops_adSet
                    }
                },
                "comment": ""
            })
                .then(res => {
                    layer.close(loadingIndex); // 关闭loading
                    if (res.data.response.result_code == "true") {
                        layer.closeAll();
                        // 刷新列表
                        _this.getAdSetList(_this.ad_set_page)
                        layer.msg('同步成功！');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.close(loadingIndex); // 关闭loading
                    layer.msg('同步失败，请重试');
                });
        },

        //******************** 智能控制器配置 ******************/
        // 获取门店列表
        getNewSmartControlShopList(page) {
            let _this = this
            _this.new_control_shop_page = page
            _this.loading = true
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": page,
                        "page_size": _this.GLOBAL.PAGESIZE,
                        "config_type": "intelligent_control"
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "Shop/getConfigList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function (data) {
                    if (data.response.result_code == "true") {
                        if (page == 1) {
                            _this.new_control_shop_total = Number(data.response.result.count)
                        }
                        _this.new_control_shop_list = data.response.result.data;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function (err) {
                    layer.msg("网络错误");
                    _this.loading = false;
                }
            });
        },

        // 切换智能控制器配置
        changeIntelligentControl(row) {
            console.log(row)
            let _this = this

            Vue.axios.post('Shop/upConfig', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        'id': row.shop_id,
                        'config_type': 'intelligent_control',
                        'config': row.intelligent_control
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg('设置成功');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
        },
        // 时序器管理
        goSmartControlSequencerSet(row) {
            this.showSmartControlSetListPanel = false
            this.showSmartControlSequencerSetPanel = true
            this.current_sequencer_shop_id = row.shop_id
            // 获取设备数据
            this.getDeviceData(row.shop_id)
            // 获取时序器配置
            this.getSequencerConfig(row.shop_id)
        },
        // 设备管理
        goSmartControlDeviceSet(row) {
            this.showSmartControlSetListPanel = false
            this.showSmartControlDeviceSetPanel = true
            this.current_device_shop_id = row.shop_id
            // 获取时序设备数据
            this.getSequencerDeviceData(row.shop_id)
            // 获取控制器配置
            this.getControlerConfig(row.shop_id)
            // 获取电源控制配置
            this.getPowerControlConfig(row.shop_id)
            // 获取控制类型数组
            this.getControlDeviceTypeArr(row.shop_id)
        },

        // 获取控制器配置
        getControlerConfig(shop_id) {
            let _this = this
            Vue.axios.post('NewIntelligentController/getDeviceLineData', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shop_id
                    }
                },
                "comment": ""
            })
                .then(res => {
                    console.log(res)
                    if (res.data.response.result_code == "true") {
                        _this.new_control_device_data = res.data.response.result
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
        },

        // 获取时序设备数据
        getSequencerDeviceData(shop_id) {
            let _this = this
            _this.sequencer_device_arr = []
            Vue.axios.post('NewIntelligentController/getSequencerDevice', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shop_id
                    }
                },
                "comment": ""
            })
                .then(res => {
                    console.log(res)
                    if (res.data.response.result_code == "true") {
                        _this.sequencer_device_arr = res.data.response.result
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
        },
        // 获取设备数据
        getDeviceData(shop_id) {
            let _this = this
            _this.device_arr = []
            Vue.axios.post('NewIntelligentController/getShopDevice', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shop_id
                    }
                },
                "comment": ""
            })
                .then(res => {
                    console.log(res)
                    if (res.data.response.result_code == "true") {
                        _this.device_arr = res.data.response.result
                        // 清理无效的设备ID
                        _this.cleanInvalidDeviceIds()
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
        },
        // 获取时序器配置
        getSequencerConfig(shop_id) {
            let _this = this
            Vue.axios.post('NewIntelligentController/getSequencerConfig', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shop_id
                    }
                },
                "comment": ""
            })
                .then(res => {
                    console.log(res)
                    if (res.data.response.result_code == "true") {
                        _this.sequencer_data = res.data.response.result
                        // 清理无效的设备ID
                        _this.cleanInvalidDeviceIds()
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
        },

        // 获取智能控制器设备数据
        getNewControlDeviceData() {
            let _this = this
            Vue.axios.post('NewIntelligentController/getDeviceLineData', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.current_device_shop_id
                    }
                },
                "comment": ""
            })
                .then(res => {
                    console.log(res)
                    if (res.data.response.result_code == "true") {
                        _this.new_control_device_data = res.data.response.result
                    }
                })
                .catch(err => {
                    layer.msg("获取设备数据失败");
                })
        },
        // 保存时序器配置
        saveSequencerConfig() {
            let _this = this
            // 这里可以添加保存配置的API调用

            Vue.axios.post('NewIntelligentController/setSequencerConfig', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.current_sequencer_shop_id,
                        "type": _this.sequencer_data.type,
                        "config": _this.sequencer_data.config,
                        "second_config": _this.sequencer_data.second_config
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg("配置保存成功");
                        _this.backToSequencerList()
                    } else {
                        layer.msg("保存失败：" + res.data.response.result_msg);
                    }
                })
                .catch(err => {
                    layer.msg("保存失败，请重试");
                })
        },
        // 返回时序器列表
        backToSequencerList() {
            this.showSmartControlDeviceSetPanel = false
            this.showSmartControlSequencerSetPanel = false
            this.showSmartControlSetListPanel = true
        },
        newEditLineName() {
            let _this = this
            Vue.axios.post('NewIntelligentController/upLine', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.current_device_shop_id,
                        "line_data": _this.new_control_device_data.line_data
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg("保存成功");
                        _this.getControlDeviceTypeArr(_this.current_device_shop_id)
                    }
                })
                .catch(err => {
                    layer.msg("保存失败，请重试");
                })
        },
        newEditBreakerName() {
            let _this = this
            Vue.axios.post('NewIntelligentController/upBreakerLine', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": _this.current_device_shop_id,
                        "line_data": _this.new_control_device_data.breaker_data
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg("保存成功");
                        _this.getControlDeviceTypeArr(_this.current_device_shop_id)
                    }
                })
                .catch(err => {
                    layer.msg("保存失败，请重试");
                })
        },

        // 新增时序设备
        addSequencerDevice() {
            let _this = this;

            // 构建设备选项HTML
            let deviceOptions = '';
            _this.sequencer_device_arr.forEach(device => {
                deviceOptions += `<option value="${device.id}">${device.name}</option>`;
            });

            // 使用layer.confirm显示设备选择
            layer.confirm(`
                    <div style="padding: 20px;">
                        <div style="margin-bottom: 15px;">
                            <label style="display: block; margin-bottom: 5px; font-weight: bold;">选择设备：</label>
                            <select id="deviceSelect" style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px;">
                                <option value="">请选择设备</option>
                                ${deviceOptions}
                            </select>
                        </div>
                    </div>
                `, {
                title: '新增时序设备',
                btn: ['确定', '取消'],
                area: ['400px', '200px']
            }, function (index) {
                // 确定按钮点击事件
                let selectedDeviceId = document.getElementById('deviceSelect').value;
                if (!selectedDeviceId) {
                    layer.msg("请选择设备");
                    return;
                }

                // 查找选中的设备信息
                let selectedDevice = _this.sequencer_device_arr.find(device => device.id == selectedDeviceId);
                if (!selectedDevice) {
                    layer.msg("设备信息不存在");
                    return;
                }

                // 检查设备是否已存在
                let existingDevice = _this.new_control_device_data.device_data.find(device => device.id == selectedDevice.id);
                if (existingDevice) {
                    layer.msg("该设备已存在");
                    return;
                }

                // 构建完整的设备数据数组（当前设备 + 新设备）
                let updatedDeviceData = [..._this.new_control_device_data.device_data, {
                    "id": selectedDevice.id,
                    "name": selectedDevice.name
                }];

                // 调用接口新增设备（发送完整的更新后数组）
                Vue.axios.post('NewIntelligentController/setDeviceLineData', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": _this.current_device_shop_id,
                            "device_data": updatedDeviceData
                        }
                    },
                    "comment": ""
                })
                    .then(res => {
                        if (res.data.response.result_code == "true") {
                            layer.msg("新增设备成功");
                            layer.close(index);
                            // 刷新设备列表
                            _this.getControlerConfig(_this.current_device_shop_id);
                            _this.getControlDeviceTypeArr(_this.current_device_shop_id)
                        } else {
                            layer.msg("新增失败：" + res.data.response.result_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg("新增失败，请重试");
                    })
            });
        },

        // 清理无效的设备ID
        cleanInvalidDeviceIds() {
            let _this = this
            // 获取有效的设备ID列表
            let validDeviceIds = _this.device_arr.map(device => device.id)

            // 清理 config 中的无效设备ID
            if (_this.sequencer_data.config && _this.sequencer_data.config.length > 0) {
                _this.sequencer_data.config.forEach(item => {
                    if (item.device !== undefined && item.device !== null && !validDeviceIds.includes(item.device)) {
                        item.device = ''
                    }
                })
            }

            // 清理 second_config 中的无效设备ID
            if (_this.sequencer_data.second_config && _this.sequencer_data.second_config.length > 0) {
                _this.sequencer_data.second_config.forEach(item => {
                    if (item.device !== undefined && item.device !== null && !validDeviceIds.includes(item.device)) {
                        item.device = ''
                    }
                })
            }
        },

        // 通知方式改变
        onNotifyTypeChange(val) {
            if (val == '2') {
                this.control_form.box_notify_config.power_mode = ''
                this.control_form.box_notify_config.cycle_mode = ''
                this.control_form.box_notify_config.power_duration = ''
                this.control_form.box_notify_config.interval_duration = ''
            }else {
                this.control_form.box_notify_config = {
                    power_mode: null,
                    cycle_mode: null,
                    power_duration: 0,
                    interval_duration: 0
                }
            }
        },

        // 通电方式改变
        onPowerModeChange(val) {
            if (val == '1') { // 一次性通断电
                this.control_form.box_notify_config.cycle_mode = ''
                this.control_form.box_notify_config.power_duration = ''
                this.control_form.box_notify_config.interval_duration = ''
            }
        },

        // 循环模式改变
        onCycleModeChange(val) {
            if (val == '1') { // 单次
                this.control_form.box_notify_config.interval_duration = ''
            }
        },

        // 删除时序设备
        deleteSequencerDevice(deviceId) {
            let _this = this;

            layer.confirm('确定要删除这个设备吗？', {
                btn: ['确定', '取消']
            }, function () {
                // 构建完整的设备数据数组（过滤掉要删除的设备）
                let updatedDeviceData = _this.new_control_device_data.device_data.filter(device => device.id !== deviceId);

                // 调用接口删除设备（发送完整的更新后数组）
                Vue.axios.post('NewIntelligentController/setDeviceLineData', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": _this.current_device_shop_id,
                            "device_data": updatedDeviceData
                        }
                    },
                    "comment": ""
                })
                    .then(res => {
                        if (res.data.response.result_code == "true") {
                            layer.msg("删除设备成功");
                            // 刷新设备列表
                            _this.getControlerConfig(_this.current_device_shop_id);
                            _this.getControlDeviceTypeArr(_this.current_device_shop_id)
                        } else {
                            layer.msg("删除失败：" + res.data.response.result_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg("删除失败，请重试");
                    })
            });
        },
        // 处理电源控制tab切换
        handlePowerControlTabClick(tab) {
            let _this = this;
            // 根据选中的tab，找到对应的配置项
            const selectedConfig = _this.power_control_config.find(item => item.id === tab.name);
            if (selectedConfig) {
                // 将选中的配置项存储到select_power_control中
                _this.select_power_control = selectedConfig;
            }
        },
        // 获取电源控制配置
        getPowerControlConfig(shop_id) {
            let _this = this
            Vue.axios.post('NewIntelligentController/getPowerControlData', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shop_id
                    }
                },
                "comment": ""
            })
                .then(res => {
                    console.log(res)
                    if (res.data.response.result_code == "true") {
                        _this.power_control_config = res.data.response.result
                        // 设置默认选中的tab为第一个
                        if (_this.power_control_config && _this.power_control_config.length > 0) {
                            _this.activePowerControlTab = _this.power_control_config[0].id;
                            _this.select_power_control = _this.power_control_config[0];
                        }
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
        },
        // 获取控制类型数组
        getControlDeviceTypeArr(shop_id) {
            let _this = this
            Vue.axios.post('NewIntelligentController/getTypes', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "shop_id": shop_id
                    }
                }
            })
                .then(res => {
                    console.log(res)
                    if (res.data.response.result_code == "true") {
                        _this.control_device_type_arr = res.data.response.result
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
        },
        // V2.0 音效库效果管理 
        getEffectTable(page) {
            let _this = this;
            _this.effect_manage_form.page = page ? page : 1;
            _this.loading = true;
            Vue.axios.post('MerchantRoomEffect/getList', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        'page': _this.effect_manage_form.page,
                        'page_size': _this.effect_manage_form.page_size,
                        'shop_id': _this.effect_manage_form.shop_id,
                        'effect_name': _this.effect_manage_form.effect_name,
                        'room_id': _this.effect_manage_form.room_id,
                        "is_merchant": _this.effect_manage_form.is_merchant,
                        "tool_id": _this.effect_manage_form.tool_id
                    }
                },
                "comment": ""
            }).then(res => {
                if (res.data.response.result_code == "true") {
                    // console.log(res.data.response.result);
                    if (_this.effect_manage_form.page == 1) _this.effect_manage_form.total = Number(res.data.response.result.count);
                    _this.effect_table_data = res.data.response.result.data;
                    _this.loading = false;
                } else {
                    layer.msg(res.data.response.error_msg);
                }
            })
        },
        deleteEffect(row) {
            let _this = this;
            layer.confirm('确定要删除这个效果吗？', {
                btn: ['确定', '取消']
            }, function () {
                Vue.axios.post('MerchantRoomEffect/deleteData', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": row.id
                        }
                    },
                    "comment": ""
                }).then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.msg("删除成功");
                        _this.getEffectTable(_this.effect_manage_form.page);
                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
            })
        },

        editEffect(row) {
            this.showEditEffectPanel = true
            this.edit_effect_form = row
        },
        commitEditEffect() {
            let _this = this;
            Vue.axios.post('MerchantRoomEffect/setData', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": _this.edit_effect_form.id,
                        "effect_name": _this.edit_effect_form.effect_name,
                        "effect_describe": _this.edit_effect_form.effect_describe,
                        "is_merchant": _this.edit_effect_form.is_merchant,
                    }
                },
                "comment": ""
            }).then(res => {
                if (res.data.response.result_code == "true") {
                    layer.msg("修改成功");
                    _this.getEffectTable(_this.effect_manage_form.page);
                    this.showEditEffectPanel = false
                } else {
                    layer.msg(res.data.response.error_msg);
                }
            })
        },
    },


}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.vod-manage {
    .red-tip {
        color: red;
    }

    .a-row {
        height: 50px;
        line-height: 50px;
        font-size: 14px;
        color: #7e7e7e;

        label {
            padding: 0;
        }

        #consume-value {
            padding-left: 0;
        }
    }

    .table-responsive {
        width: 100%;
        padding: 0 0 20px;
    }

    .select2-selection--single {
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        border-radius: 0;
    }

    .select2-selection__rendered {
        line-height: 32px !important;
    }
}

.add_printer_area .layui-layer-btn {
    text-align: center !important;
}

.add_printer_area .layui-layer-btn a {
    height: 32px !important;
    line-height: 32px !important;
    padding: 0 30px !important;
    margin: 0px 20px !important;
}

.ctr-label-right {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 28px 0 8px;
}

.ctr-label-right[readonly] {
    background: #FFF;
    cursor: pointer;
}

.printer_arrow {
    height: 32px;
    position: absolute;
    top: 1px;
    right: 16px;
    width: 20px;
    cursor: pointer;

    b {
        border-color: #888 transparent transparent transparent;
        border-style: solid;
        border-width: 5px 4px 0 4px;
        height: 0;
        left: 50%;
        margin-left: -4px;
        margin-top: -2px;
        position: absolute;
        top: 50%;
        width: 0;
    }
}

.upload-wrap {
    position: relative;
    display: block;
    width: 540px;
    padding: 30px 20px 20px;
    margin: 0 auto;

    span {
        color: #AFAFAF;
        font-size: 14px;
    }

    .upload-file-info {
        margin: 50px 0 30px;
    }

    input {
        float: left;
        width: 150px;
        height: 42px;
        margin: 0 0 50px 50px;
        color: #FFF;
        font-size: 16px;
        background: #009af0;
    }

    button {
        float: right;
        width: 150px;
        height: 42px;
        border: none;
        margin: 0 50px 0 0;
        color: #FFF;
        font-size: 16px;
        background: #009af0;
    }

    p {
        clear: both;
        line-height: 30px;
        color: #F00;
        font-size: 14px;
        text-align: center;

        em {
            color: #6699FF;
            font-style: normal;
        }
    }
}

.room-list,
.wake-list {
    table {
        table-layout: fixed;
        word-wrap: break-word;
    }
}

.room-song-alert,
.wake-song-alert {
    display: none;

    li {
        margin: 10px 0 0;
    }

    label {
        margin: 0 10px 0 5px;
    }

    img {
        margin: -6px 0 0;
        cursor: pointer;
    }
}

.upload-songs {
    .layui-layer-btn {
        display: none;
    }
}

.queryrow {
    padding-left: 0;
    margin-left: -36px;
}

.margin30 {
    margin: 0 30px 0 0;
}

.rowpadding {
    margin: 0 0 36px;
}

.shop-cg {
    padding: 0 12px;
    line-height: 32px;
    font-size: 14px;
    background: #EEE;
    border: 1px solid #AAA;
}

.selection_clear {
    display: none;
    position: absolute;
    right: 36px;
    top: 1px;
    width: 20px;
    height: 32px;
    line-height: 32px;
    font-weight: bold;
    cursor: pointer;
}

.box_area_main {
    width: 80%;
    border: 1px solid #e5e5e5;
    margin-top: 20px;
}

.goods_checkboxdiv {
    position: relative;
    display: block;
    margin: 0 auto;
    width: 90%;
    padding: 30px 20px 20px;
}

.goods_checkboxdiv ul {
    border: 1px solid #e5e5e5;
    padding: 0px 30px 20px 30px;
    border-top: none;
}

.goods_checkboxdiv li {
    width: 14.28%;
    float: left;
    height: 32px;
    line-height: 32px;
    color: #a29d9d;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.box_area {
    width: 100%;
    margin: 0 !important;
    padding: 0px !important;
}

.box_area ul {
    margin-bottom: 0px;
    border: none;
}

.goods_checkboxdiv .first {
    width: 100%;
    background: #f5f5f5;
    border: 1px solid #e5e5e5;
    border-bottom: none;
    padding-left: 30px;
    line-height: 32px;
}

.box_area .first {
    border: none;
}

.xgq-mp {
    resize: none;
    height: 140px !important;
}

.xqg-list {
    table-layout: fixed;
}

.xqg-list td {
    word-wrap: break-word;
}

.canselect {
    background-color: #eee !important;
}

.visi_hid {
    width: 0;
    opacity: 0;
}

.bx-list {
    p {
        line-height: 50px;
        color: #F00;
        margin: 0;
    }
}

.bx-set {
    .page-tit {
        margin: 0;
    }

    .page-notice {
        margin: 10px 0 49px;
        color: #F00;
    }

    .bx-txt-add {
        overflow: hidden;
        margin: 36px 0 0 142px;

        div {
            width: 370px;
        }

        img {
            cursor: pointer;
        }
    }

    .col-md-4 {
        width: 370px;
    }

    mark {
        padding: 0;
        margin: 0;
        background-color: yellow;
    }

    .bx-txt-wrap {
        overflow: hidden;
        margin: 36px 0 0 142px;

        div {
            width: 370px;
        }

        img {
            cursor: pointer;
        }
    }

    .content {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        .left {
            width: 600px;
        }

        .init-params-explain {
            width: 600px;
            margin: 0 30px;
            max-height: 500px;

            pre {
                width: 100%;
                height: 100%;
            }
        }
    }
}

.bx_hint_tip {

    // i.layui-layer-TipsL {
    //     display: none;
    // }
    .layui-layer-content {
        color: #757575;
        width: 400px;
        padding-left: 20px;
    }

    .layui-layer-content .dots {
        color: #009af0;
        font-size: 16px;
        display: inline-block;
        font-weight: 900;
        padding-right: 3px;
    }
}

.bx-rm-hint {
    padding: 20px;

    h2 {
        margin: 0 0 10px;
        line-height: 26px;
        font-size: 14px;
    }

    h3 {
        margin: 8px 0 0;
        line-height: 26px;
        font-size: 12px;
    }

    p {
        text-indent: 2em;
        margin: 0;
        line-height: 26px;
        font-size: 12px;
    }

    pre {
        border: none;
        background: #fff;
        font-size: 14px;
        font-family: 'Microsoft YaHei', Avenir, Helvetica, Arial, sans-serif;
        white-space: break-spaces;
    }
}

.mult-set-pop {
    .red-tip {
        color: red;
        margin-bottom: 10px;
    }

    .el-row {
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .el-input {
            margin-right: 10px;
        }
    }
}

// 
.vod-xbz-set {
    .xbz-list {
        p {
            margin: 20px 0;
        }

        .el-image {
            width: 100px;
        }
    }

    .xbz-edit {
        &-img {
            display: block;
            width: 114px;
            height: 114px;
            cursor: pointer;
        }
    }
}

// 智能灯光设置
.vod-lamp-set {
    .lamp-set {
        .el-row {
            display: flex;
            flex-direction: row;
            align-items: center;

            .ctr-label-left {
                margin: 0 20px 0 0;
            }

            .red-tip {
                color: red;
            }
        }

        .gray-block {
            width: 900px;
            padding: 10px;
            background: #efefef;
            margin: 20px 0 20px 50px;
            display: flex;
            flex-direction: row;
            align-items: center;

            .label {
                color: #5e5e5e;
                margin-left: 60px;
            }

            .el-input {
                width: 400px;

                &.small {
                    width: 150px;
                }
            }

            .block-title {
                line-height: 40px;
                font-size: 18px;

                .red-tip {
                    color: red;
                    font-size: 14px;
                }
            }
        }
    }

    .rooms-panel {
        h3 {
            margin: 10px 0;
        }

        .room-wrapper {
            margin: 20px 0;
            border: 1px solid #f5f5f5;

            .block-title {
                line-height: 40px;
                background: #f5f5f5;
                padding-left: 20px;
            }

            .block {
                margin-top: 20px;

                .rooms {
                    padding: 10px 20px;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    align-items: center;

                    .room {
                        width: 200px;
                        margin: 10px 0;
                    }
                }
            }
        }
    }
}

// 场景灯光设置
.vod-scene-set {
    .scene-set {
        .el-row {
            display: flex;
            flex-direction: row;
            align-items: center;

            .ctr-label-left {
                margin: 0 20px 0 0;
            }

            .red-tip {
                color: red;
            }
        }

        .gray-block {
            width: 1400px;
            padding: 20px;
            background: #efefef;
            margin: 20px 0 20px 50px;
            display: flex;
            flex-direction: column;
            align-items: start;
            gap: 20px;

            .label {
                color: #5e5e5e;
                margin-left: 60px;
            }

            .el-input {
                width: 400px;

                &.small {
                    width: 150px;
                }
            }

            .block-title {
                line-height: 40px;
                font-size: 18px;

                .red-tip {
                    color: red;
                    font-size: 14px;
                }
            }
        }
    }

    .rooms-panel {
        h3 {
            margin: 10px 0;
        }

        .room-wrapper {
            margin: 20px 0;
            border: 1px solid #f5f5f5;

            .block-title {
                line-height: 40px;
                background: #f5f5f5;
                padding-left: 20px;
            }

            .block {
                margin-top: 20px;

                .rooms {
                    padding: 10px 20px;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    align-items: center;

                    .room {
                        width: 200px;
                        margin: 10px 0;
                    }
                }
            }
        }
    }
}


// 包厢火警通知设置
.fire-alarm-set,
.mic-low-power-set {
    .list-img {
        width: 100px;
    }

    .fire-add-panel,
    .mic-low-power-add-panel {

        .el-input,
        .el-select {
            width: 400px;
        }

        .red-tip {
            color: red;
        }

        .fire-img-wrapper,
        .mic-low-power-img-wrapper {
            width: 200px;
            height: 200px;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }
}

// 灯光面板点播设置
.vod-light-set {
    .edit-panel {
        .el-form {
            margin-top: 30px;

            .el-input,
            .el-select {
                width: 400px;
            }

            .el-popover__reference {
                margin-right: 10px;
                margin-top: 3px;
            }
        }

        .song-list-set {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: space-between;

            .search-table,
            .choosed-table {
                width: 47%;
                border: 1px solid #efefef;
                padding: 20px;

                h3 {
                    text-align: center;
                }

                .el-input {
                    .el-input-group__prepend {
                        background-color: #fff;
                    }

                    .el-select {
                        width: 140px;

                        .el-input {
                            width: 140px;
                        }
                    }
                }

                .el-pagination__jump .el-input {
                    width: 50px;
                }
            }
        }
    }
}

//购买单曲设置
.add-buy-song-panel {
    .el-form {
        margin-top: 30px;

        .el-input,
        .el-select {
            width: 400px;
        }

        .sub-title {
            margin: 30px;
        }

        .el-row {
            display: flex;
            flex-direction: row;
            align-items: center;
        }
    }

    .week-pop {
        .el-checkbox {
            margin-bottom: 10px;
        }
    }
}

// 三个一效果文件管理
.three-in-one-manage {
    .add-file-panel {
        .el-form {
            margin-top: 20px;

            .el-input,
            .el-select,
            .el-textarea {
                width: 400px;
                margin-right: 10px;

                &.short {
                    width: 180px;
                }
            }

            .el-button {
                margin-left: 10px;
            }
        }
    }

    .room-choose-page {
        .wrapper {
            border: 1px solid #e5e5e5;
            margin: 15px 0 30px;

            .area {
                .area-name {
                    padding-left: 25px;
                    border-bottom: 1px solid #e5e5e5;
                    line-height: 32px;
                    background: #f5f5f5;
                }

                .rooms {
                    padding: 15px 25px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    flex-wrap: wrap;

                    .room {
                        width: 200px;
                        margin: 10px;
                    }
                }
            }
        }
    }
}

// 智慧交换机设置
.smart-machine-set,
.smart-control-set {
    .title {
        text-align: center;
    }

    .shop-name {
        font-size: 16px;
        margin-bottom: 20px;
    }

    .module-title {
        font-size: 16px;
        margin-bottom: 20px;
    }

    .gray-block {
        max-width: 1200px;
        margin-bottom: 30px;
        padding: 20px;
        background: #efefef;
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;

        .line {
            margin: 10px 20px 10px 0;
            display: flex;
            flex-direction: row;
            align-items: center;

            .el-input {
                width: 200px;
                margin-left: 10px;
            }
        }
    }

    .control-block {
        max-width: 1200px;
        margin-bottom: 20px;
        padding: 20px;
        background: #efefef;

        .block-title {
            .el-button {
                margin-left: 10px;
            }
        }
    }

    .control-pop {
        .el-select {
            width: 300px;
        }
    }
}

// 智慧控制器配置
.smart-control-set {
    .gray-block {
        .block-title {
            width: 100%;
        }

        .have-top-line {
            margin-top: 20px;
            padding-top: 20px;
            border-top: 1px solid #e5e5e5;
        }
    }
}

// 工作歌单
.work-song-list {
    .add-work-song-pop {
        .pop-row {
            display: flex;
            flex-direction: row;
            align-items: center;

            .el-button {
                margin-left: 20px;
            }
        }

        .el-select .el-input {
            width: 130px;
        }

        .input-with-select .el-input-group__prepend {
            background-color: #fff;
        }
    }
}



.ad-set-panel {

    // 触摸屏显示内容设置
    .title-img {
        display: flex;
        align-items: center;

        .title-img-left {
            font-size: 24px;
            font-weight: bold;
        }

        .title-img-right {
            width: 30px;
            height: 30px;
            margin-left: 10px;
        }
    }

    .shop-name-ad-set {
        font-size: 16px;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .bg-set-form {
        display: none;
        padding: 20px;

        .tip {
            margin-top: 10px;
            margin-bottom: 10px;
        }

        .el-form-item {
            margin-bottom: 0;
        }

        .el-form-item__label {
            width: 120px;
        }

        .el-form-item__content {
            margin-left: 120px;
        }
    }

    .block-item {
        position: relative;
        width: 900px;
        margin: 0 0 20px 10px;
        padding: 15px;
        background: rgb(242, 242, 242);

        .delete-icon {
            position: absolute;
            right: 0;
            top: 0;
            width: 20px;
            height: 20px;
            padding: 15px;
            box-sizing: content-box;
        }

        .good-row {
            margin-bottom: 10px;
            display: flex;
            flex-direction: row;
            align-items: center;

            .img-wrapper {
                margin: 0 20px 0 10px;

                .add-icon {
                    margin-bottom: 10px;
                }
            }

            .goods-detail {
                .row {
                    margin-top: 15px;
                }
            }
        }
    }

    .img-wrapper,
    .video-wrapper {
        width: 320px;
        height: 180px;
        background: #fff;
        border: 1px solid #ccc;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &.big-img {
            width: 680px;
            height: 94px;
        }

        &.goods {
            width: 150px;
            height: 150px;
        }

        .add-icon {
            width: 40px;
            height: 40px;
            margin: 0;
        }

        .add-txt {
            font-size: 12px;
            color: #999;
        }

        .ad-img {
            width: 100%;
            height: 100%;
            margin: 0;
        }

        .good-img {
            width: 100%;
            height: 100%;
            margin: 0;
        }

        .content-img {
            width: 100%;
            height: 100%;
            margin: 0;
        }

        .video {
            width: 100%;
            height: 100%;
            margin: 0;
        }
    }

    .normal-img {
        width: 200px;
        height: 300px;
    }
}

.ad-tv-screen {
    .ad-tv-screen-form {
        background-color: #efefef;
        padding: 20px;

        .tip-right {
            color: #f00 !important;
            margin-left: 10px !important;
        }
    }


    .img-wrappers {
        display: flex;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        padding: 10px 0;
        gap: 15px;
        max-width: 100%;

        &::-webkit-scrollbar {
            height: 6px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: #a8a8a8;
        }

        .img-wrapper {
            flex: 0 0 auto;
            width: 150px;
            height: 200px;
            position: relative;
            border: 2px dashed #ddd;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #fafafa;
            overflow: hidden;

            &:hover {
                border-color: #409eff;
            }

            .ad-img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 6px;
            }

            .delete-btn {
                position: absolute;
                top: 5px;
                right: 5px;
                width: 20px;
                height: 20px;
                background-color: #ff4757;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                color: white;
                font-size: 12px;
                z-index: 10;

                &:hover {
                    background-color: #ff3838;
                }
            }

            .upload-placeholder {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                color: #999;
                cursor: pointer;

                .upload-icon {
                    font-size: 24px;
                    margin-bottom: 8px;
                }

                .upload-text {
                    font-size: 12px;
                }
            }
        }
    }
}

.ad-touch-screen-list {
    .img-wrappers {
        display: flex;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        padding: 10px 0;
        gap: 15px;
        max-width: 100%;

        &::-webkit-scrollbar {
            height: 6px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: #a8a8a8;
        }

        .img-wrapper {
            flex: 0 0 auto;
            width: 150px;
            height: 200px;
            position: relative;
            border: 2px dashed #ddd;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #fafafa;
            overflow: hidden;

            &:hover {
                border-color: #409eff;
            }

            .ad-img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 6px;
            }

            .delete-btn {
                position: absolute;
                top: 5px;
                right: 5px;
                width: 20px;
                height: 20px;
                background-color: #ff4757;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                color: white;
                font-size: 12px;
                z-index: 10;

                &:hover {
                    background-color: #ff3838;
                }
            }

            .upload-placeholder {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                color: #999;
                cursor: pointer;

                .upload-icon {
                    font-size: 24px;
                    margin-bottom: 8px;
                }

                .upload-text {
                    font-size: 12px;
                }
            }
        }
    }
}

.smart-control-sequencer-set {
    .sequencer-select {
        display: flex;
        align-items: center;
        gap: 30px
    }

    .sequencer-config {
        margin-bottom: 30px;
        background-color: #f2f2f2;
        padding: 10px;

        h3 {
            margin-bottom: 20px;
            color: #333;
            font-size: 18px;
            padding-bottom: 10px;
        }

        .config-list {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 15px;

            .config-item {
                display: flex;
                align-items: center;
                padding: 15px;
                background: #d7d7d7;
                border: 1px solid #e4e7ed;
                border-radius: 6px;

                .line-label {
                    width: 100px;
                    font-weight: bold;
                    color: #000;
                    margin-right: 20px;
                }

                .name-input {
                    width: 150px;
                    margin-right: 20px;
                }

                .device-label {
                    width: 80px;
                    color: #666;
                    margin-right: 15px;
                }

                .device-select {
                    width: 150px;
                }
            }
        }
    }

    .sequencer-actions {
        text-align: center;
        padding: 20px 0;
        border-top: 1px solid #e4e7ed;

        .el-button {
            margin: 0 10px;
            padding: 12px 30px;
        }
    }
}

.smart-control-device-set {

    .module-title {
        font-size: 16px;
        margin-bottom: 20px;
    }

    .gray-block {
        max-width: 1200px;
        margin-bottom: 30px;
        padding: 20px;
        background: #efefef;
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;

        .line {
            margin: 10px 20px 10px 0;
            display: flex;
            flex-direction: row;
            align-items: center;

            .el-input {
                width: 200px;
                margin-left: 10px;
            }
        }
    }

    .control-block {
        max-width: 1200px;
        margin-bottom: 20px;
        padding: 20px;
        background: #efefef;

        .block-title {
            .el-button {
                margin-left: 10px;
            }
        }
    }

    .control-pop {
        .el-select {
            width: 300px;
        }
    }
}

.smart-control-device-set {
    .gray-block {
        .block-title {
            width: 100%;
        }

        .have-top-line {
            margin-top: 20px;
            padding-top: 20px;
            border-top: 1px solid #e5e5e5;
        }
    }

    // 时序设备列表样式
    .sequencer-device-list {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        margin-top: 15px;

        .device-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 20px;
            background: #fff;
            border: 1px solid #e4e7ed;
            border-radius: 6px;
            min-width: 200px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

            .device-name {
                font-size: 14px;
                color: #333;
                font-weight: 500;
            }

            .el-button {
                margin-left: 10px;
            }

            &:hover {
                border-color: #409eff;
                box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
            }
        }
    }

    // 电源控制tab样式
    .power-control-tabs {
        margin-top: 20px;

        .el-tabs__header {
            margin-bottom: 20px;
        }

        .power-control-content {
            padding: 20px;
            background: #fff;
            border: 1px solid #e4e7ed;
            border-radius: 6px;
            min-height: 200px;
        }
    }
}

// 同步弹窗样式
.sync-pop {
    .sync-content {
        padding: 20px;

        .sync-title {
            color: #FF0707;
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 10px;
            text-align: center;
        }

        .sync-subtitle {
            color: #333;
            font-size: 14px;
            margin-bottom: 20px;
            text-align: center;
        }

        .shop-list {
            background: #fff;
            border: 1px solid #ddd;
            border-radius: 4px;
            padding: 15px;
            margin-bottom: 20px;
            max-height: 300px;
            overflow-y: auto;

            .shop-item {
                margin-bottom: 10px;

                &:last-child {
                    margin-bottom: 0;
                }
            }

            .shop-grid {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 10px;
                margin-top: 10px;

                .shop-item {
                    margin-bottom: 0;
                }
            }
        }

        .sync-buttons {
            text-align: center;

            .el-button {
                margin: 0 10px;
                min-width: 80px;
            }
        }
    }
}
</style>